/* !
 * Tiny PowerPaste plugin
 *
 * Copyright (c) 2023 Ephox Corporation DBA Tiny Technologies, Inc.
 * Licensed under the Tiny commercial license. See https://www.tiny.cloud/legal/
 *
 * Version: 6.1.4-601
 */

// Generated by js_of_ocaml 4.0.0
(function(a){typeof
  globalThis!=="object"&&(this?b():(a.defineProperty(a.prototype,"_T_",{configurable:true,get:b}),_T_));function
  b(){var
  b=this||self;b.globalThis=b;delete
  a.prototype._T_}}(Object));(function(w){"use strict";var
  iY="q",fK="i",aK="img",ip="Invalid_argument",dM="Map.bal",io="@[",im="%ni",iX="data-text-indent-alt",cM="th",a7="!",il="align",bX="label",bl="col",ap=0xff,b5="title",fl="del",k=-579472809,cL="font",ik="strike",W="contents",cw="height",ij="abbr",ad="0",fJ="samp",c=-841728391,R=698996132,cK=128,ii="Sys_blocked_io",a1="p",d0="start",iW="fd ",ih="normal",a6="form",A=248,fI="DeltaViewInsertion",fH="var",fG=" {\n",cJ=">",iV=1027,fF="em",dZ="caption",aj=246,bC="td",bk="object",ig="%u",fk="[endif]",cI="noscript",iU="error",a5="table",cu="tbody",dL=127,cv=1024,ak="script",ie="@{",fD="1",fE="e",fj=" : flags Open_rdonly and Open_wronly are not compatible",iT="mso-list",dY="button",cH="h1",bj="-",fC=": Not a directory",fi=" : file already exists",fB="b",a0=0xffffff,id="startfragment",fh="strong",iS="Out_of_memory",dX="big",_="ul",iR=": closedir failed",fA="index out of bounds",dK="select",an="tr",dW="_bigarr02",dV="@",ic=", characters ",b4="isindex",aM=0xffff,dJ="basefont",ia="wordimport.js",dI="none",ib=12520,dH="small",iQ="infinity",$="li",dG="menu",ct=1000,d="",cG="sub",h$="^",b3=749117977,bi=0x3f,bw="link",h_="src",dU="frame",h9="Match_failure",cF="html",dT="iframe",dS=252,h8=" : is a directory",bm=".",bW="+",fz="tt",iP=0xf0,iO="<![endif]",bV="param",bB="width",h7="%li",iN="map",bA="fieldset",bv="a",h6=65536,iM=-32,fg=")",dF="legend",bu=-810056052,ff="nan",iL="list-style-type",iK="closedir",dE="applet",h5=0xe0,h4=0xdfff,bU="div",aJ="/",iJ="Assert_failure",fe="s",bh="meta",fd="ENOTDIR",fc=1073741823,j=870530776,bT="dl",bg=250,b2="frameset",cE="blockquote",dR=",",bz='"',h3="function",fb=1255,fy="<",iI="Fatal error: exception %s\n",bS=255,iH=0x800,fa="jsError",aI=0x8000,aL=256,ao="style",e$="\n}",h2="End_of_file",iG="text-align",dD="center",iF="data-main",e_="Failure",h1="data-converted-paragraph",v=50834029,e9="code",fx="ENOENT",e8="dfn",iE="([^/]+)",fw=0xf,hZ=-48,h0=0xdc00,iD="ENOTEMPTY",e7="EBADF",hY="data-list-level",M="camlinternalFormat.ml",iC="Division_by_zero",iB="<\/",hX="Sys_error",e6="cite",b1="noframes",V="ol",iA=": ",hW="EEXIST",fv="%d",hV="Printexc.handle_uncaught_exception",dQ="optgroup",e5="kbd",iy="'",iz="buffer.ml",cD="h5",dC="int_of_string",dB="dt",hU="display",hS=120,hT=103,dP="colgroup",cs="h6",a4="head",cC="h3",hR=512,ix="br",hQ=0x7ff0,b0="data-list-id",a3="body",e4="u",hP="0x",bf="\n",cr="h2",dO=254,hO="bdo",fu=100,cB="pre",hM="%Li",hN=": file descriptor already closed",ft=" : flags Open_text and Open_binary are not compatible",dA="area",cA="tfoot",dz="input",bR="span",e3=3257036,a2=-804212868,cq="thead",fs=17731,hL="lexing: empty token",fr="Unix.Unix_error",bt="--",e2="mkdir",iw="Stack_overflow",e1="v:shape",cp="address",dy=": No such file or directory",iv="/static/",iu=-97,is="tab-interval",it="Not_found",cz="dd",e0="ins",co=", ",i=781665294,fq="rmdir",by="dir",eZ="data-list-type",cn="class",ir=1026,cy="sup",fp="?",dx="list-style",hK="Pervasives.do_at_exit",ac=" ",fo="Fatal error: exception ",ax=0x80,hJ="Undefined_recursive_module",bZ="base",bx=":",bY="option",cx="hr",hI="cleanDocument",cm="h4",n=-936778451,dw="Set.bal",iq="_",fn="compare: functional value",hH="%i",dN="true",dv="textarea",fm="acronym";function
  xx(d,b,e,c,f){if(c<=b)for(var
  a=1;a<=f;a++)e[c+a]=d[b+a];else
  for(var
  a=f;a>=1;a--)e[c+a]=d[b+a];return 0}function
  cV(c,b,a){var
  e=String.fromCharCode;if(b==0&&a<=4096&&a==c.length)return e.apply(null,c);var
  f=d;for(;0<a;b+=cv,a-=cv)f+=e.apply(null,c.slice(b,b+Math.min(a,cv)));return f}function
  d2(b){var
  c=new
  Uint8Array(b.l),e=b.c,d=e.length,a=0;for(;a<d;a++)c[a]=e.charCodeAt(a);for(d=b.l;a<d;a++)c[a]=0;b.c=c;b.t=4;return c}function
  a8(d,e,b,f,c){if(c==0)return 0;if(f==0&&(c>=b.l||b.t==2&&c>=b.c.length)){b.c=d.t==4?cV(d.c,e,c):e==0&&d.c.length==c?d.c:d.c.substr(e,c);b.t=b.c.length==b.l?0:2}else
  if(b.t==2&&f==b.c.length){b.c+=d.t==4?cV(d.c,e,c):e==0&&d.c.length==c?d.c:d.c.substr(e,c);b.t=b.c.length==b.l?0:2}else{if(b.t!=4)d2(b);var
  g=d.c,h=b.c;if(d.t==4)if(f<=e)for(var
  a=0;a<c;a++)h[f+a]=g[e+a];else
  for(var
  a=c-1;a>=0;a--)h[f+a]=g[e+a];else{var
  i=Math.min(c,g.length-e);for(var
  a=0;a<i;a++)h[f+a]=g.charCodeAt(e+a);for(;a<c;a++)h[f+a]=0}}return 0}function
  aq(a){return a}function
  a9(a,b,c,d,e){a8(aq(a),b,c,d,e);return 0}function
  yk(b,a){throw[0,b,a]}function
  b8(b,a){if(b==0)return d;if(a.repeat)return a.repeat(b);var
  e=d,c=0;for(;;){if(b&1)e+=a;b>>=1;if(b==0)return e;a+=a;c++;if(c==9)a.slice(0,1)}}function
  bF(a){if(a.t==2)a.c+=b8(a.l-a.c.length,"\0");else
  a.c=cV(a.c,0,a.c.length);a.t=0}function
  js(a){if(a.length<24){for(var
  b=0;b<a.length;b++)if(a.charCodeAt(b)>dL)return false;return true}else
  return!/[^\x00-\x7f]/.test(a)}function
  ys(f){for(var
  k=d,c=d,h,g,i,a,b=0,j=f.length;b<j;b++){g=f.charCodeAt(b);if(g<ax){for(var
  e=b+1;e<j&&(g=f.charCodeAt(e))<ax;e++);if(e-b>hR){c.substr(0,1);k+=c;c=d;k+=f.slice(b,e)}else
  c+=f.slice(b,e);if(e==j)break;b=e}a=1;if(++b<j&&((i=f.charCodeAt(b))&-64)==cK){h=i+(g<<6);if(g<h5){a=h-0x3080;if(a<ax)a=1}else{a=2;if(++b<j&&((i=f.charCodeAt(b))&-64)==cK){h=i+(h<<6);if(g<iP){a=h-0xe2080;if(a<iH||a>=0xd7ff&&a<0xe000)a=2}else{a=3;if(++b<j&&((i=f.charCodeAt(b))&-64)==cK&&g<0xf5){a=i-0x3c82080+(h<<6);if(a<0x10000||a>0x10ffff)a=3}}}}}if(a<4){b-=a;c+="\ufffd"}else
  if(a>aM)c+=String.fromCharCode(0xd7c0+(a>>10),h0+(a&0x3FF));else
  c+=String.fromCharCode(a);if(c.length>cv){c.substr(0,1);k+=c;c=d}}return k+c}function
  aN(c,a,b){this.t=c;this.c=a;this.l=b}aN.prototype.toString=function(){switch(this.t){case
  9:return this.c;default:bF(this);case
  0:if(js(this.c)){this.t=9;return this.c}this.t=8;case
  8:return this.c}};aN.prototype.toUtf16=function(){var
  a=this.toString();if(this.t==9)return a;return ys(a)};aN.prototype.slice=function(){var
  a=this.t==4?this.c.slice():this.c;return new
  aN(this.t,a,this.l)};function
  i9(a){return new
  aN(0,a,a.length)}function
  a(a){return i9(a)}function
  f1(c,b){yk(c,a(b))}var
  az=[0];function
  N(a){f1(az.Invalid_argument,a)}function
  i6(){N(fA)}function
  bE(a,b){switch(a.t&6){default:if(b>=a.c.length)return 0;case
  0:return a.c.charCodeAt(b);case
  4:return a.c[b]}}function
  i8(b,a){if(a>>>0>=b.l)i6();return bE(b,a)}function
  F(a,c,b){b&=ap;if(a.t!=4){if(c==a.c.length){a.c+=String.fromCharCode(b);if(c+1==a.l)a.t=0;return 0}d2(a)}a.c[c]=b;return 0}function
  a_(b,a,c){if(a>>>0>=b.l)i6();return F(b,a,c)}function
  ay(c,a){if(c.fun)return ay(c.fun,a);if(typeof
  c!=="function")return c;var
  b=c.length|0;if(b===0)return c.apply(null,a);var
  e=a.length|0,d=b-e|0;if(d==0)return c.apply(null,a);else
  if(d<0)return ay(c.apply(null,a.slice(0,b)),a.slice(b));else
  return function(){var
  e=arguments.length==0?1:arguments.length,d=new
  Array(a.length+e);for(var
  b=0;b<a.length;b++)d[b]=a[b];for(var
  b=0;b<arguments.length;b++)d[a.length+b]=arguments[b];return ay(c,d)}}function
  cO(){N(fA)}function
  B(a,b){if(b>>>0>=a.length-1)cO();return a}function
  xC(a){if(isFinite(a)){if(Math.abs(a)>=2.2250738585072014e-308)return 0;if(a!=0)return 1;return 2}return isNaN(a)?4:3}function
  aO(a){a.t&6&&bF(a);return a.c}var
  yv=Math.log2&&Math.log2(1.1235582092889474E+307)==1020;function
  yu(a){if(yv)return Math.floor(Math.log2(a));var
  b=0;if(a==0)return-Infinity;if(a>=1)while(a>=2){a/=2;b++}else
  while(a<1){a*=2;b--}return b}function
  fT(c){var
  a=new
  Float32Array(1);a[0]=c;var
  b=new
  Int32Array(a.buffer);return b[0]|0}var
  jd=Math.pow(2,-24);function
  jm(a){throw a}function
  f2(){jm(az.Division_by_zero)}function
  l(b,c,a){this.lo=b&a0;this.mi=c&a0;this.hi=a&aM}l.prototype.caml_custom="_j";l.prototype.copy=function(){return new
  l(this.lo,this.mi,this.hi)};l.prototype.ucompare=function(a){if(this.hi>a.hi)return 1;if(this.hi<a.hi)return-1;if(this.mi>a.mi)return 1;if(this.mi<a.mi)return-1;if(this.lo>a.lo)return 1;if(this.lo<a.lo)return-1;return 0};l.prototype.compare=function(a){var
  b=this.hi<<16,c=a.hi<<16;if(b>c)return 1;if(b<c)return-1;if(this.mi>a.mi)return 1;if(this.mi<a.mi)return-1;if(this.lo>a.lo)return 1;if(this.lo<a.lo)return-1;return 0};l.prototype.neg=function(){var
  a=-this.lo,b=-this.mi+(a>>24),c=-this.hi+(b>>24);return new
  l(a,b,c)};l.prototype.add=function(a){var
  b=this.lo+a.lo,c=this.mi+a.mi+(b>>24),d=this.hi+a.hi+(c>>24);return new
  l(b,c,d)};l.prototype.sub=function(a){var
  b=this.lo-a.lo,c=this.mi-a.mi+(b>>24),d=this.hi-a.hi+(c>>24);return new
  l(b,c,d)};l.prototype.mul=function(a){var
  b=this.lo*a.lo,c=(b*jd|0)+this.mi*a.lo+this.lo*a.mi,d=(c*jd|0)+this.hi*a.lo+this.mi*a.mi+this.lo*a.hi;return new
  l(b,c,d)};l.prototype.isZero=function(){return(this.lo|this.mi|this.hi)==0};l.prototype.isNeg=function(){return this.hi<<16<0};l.prototype.and=function(a){return new
  l(this.lo&a.lo,this.mi&a.mi,this.hi&a.hi)};l.prototype.or=function(a){return new
  l(this.lo|a.lo,this.mi|a.mi,this.hi|a.hi)};l.prototype.xor=function(a){return new
  l(this.lo^a.lo,this.mi^a.mi,this.hi^a.hi)};l.prototype.shift_left=function(a){a=a&63;if(a==0)return this;if(a<24)return new
  l(this.lo<<a,this.mi<<a|this.lo>>24-a,this.hi<<a|this.mi>>24-a);if(a<48)return new
  l(0,this.lo<<a-24,this.mi<<a-24|this.lo>>48-a);return new
  l(0,0,this.lo<<a-48)};l.prototype.shift_right_unsigned=function(a){a=a&63;if(a==0)return this;if(a<24)return new
  l(this.lo>>a|this.mi<<24-a,this.mi>>a|this.hi<<24-a,this.hi>>a);if(a<48)return new
  l(this.mi>>a-24|this.hi<<48-a,this.hi>>a-24,0);return new
  l(this.hi>>a-48,0,0)};l.prototype.shift_right=function(a){a=a&63;if(a==0)return this;var
  c=this.hi<<16>>16;if(a<24)return new
  l(this.lo>>a|this.mi<<24-a,this.mi>>a|c<<24-a,this.hi<<16>>a>>>16);var
  b=this.hi<<16>>31;if(a<48)return new
  l(this.mi>>a-24|this.hi<<48-a,this.hi<<16>>a-24>>16,b&aM);return new
  l(this.hi<<16>>a-32,b,b)};l.prototype.lsl1=function(){this.hi=this.hi<<1|this.mi>>23;this.mi=(this.mi<<1|this.lo>>23)&a0;this.lo=this.lo<<1&a0};l.prototype.lsr1=function(){this.lo=(this.lo>>>1|this.mi<<23)&a0;this.mi=(this.mi>>>1|this.hi<<23)&a0;this.hi=this.hi>>>1};l.prototype.udivmod=function(e){var
  c=0,b=this.copy(),a=e.copy(),d=new
  l(0,0,0);while(b.ucompare(a)>0){c++;a.lsl1()}while(c>=0){c--;d.lsl1();if(b.ucompare(a)>=0){d.lo++;b=b.sub(a)}a.lsr1()}return{quotient:d,modulus:b}};l.prototype.div=function(a){var
  b=this;if(a.isZero())f2();var
  d=b.hi^a.hi;if(b.hi&aI)b=b.neg();if(a.hi&aI)a=a.neg();var
  c=b.udivmod(a).quotient;if(d&aI)c=c.neg();return c};l.prototype.mod=function(b){var
  a=this;if(b.isZero())f2();var
  d=a.hi;if(a.hi&aI)a=a.neg();if(b.hi&aI)b=b.neg();var
  c=a.udivmod(b).modulus;if(d&aI)c=c.neg();return c};l.prototype.toInt=function(){return this.lo|this.mi<<24};l.prototype.toFloat=function(){return(this.hi<<16)*Math.pow(2,32)+this.mi*Math.pow(2,24)+this.lo};l.prototype.toArray=function(){return[this.hi>>8,this.hi&ap,this.mi>>16,this.mi>>8&ap,this.mi&ap,this.lo>>16,this.lo>>8&ap,this.lo&ap]};l.prototype.lo32=function(){return this.lo|(this.mi&ap)<<24};l.prototype.hi32=function(){return this.mi>>>8&aM|this.hi<<16};function
  d5(b,c,a){return new
  l(b,c,a)}function
  d4(a){if(!isFinite(a)){if(isNaN(a))return d5(1,0,hQ);return a>0?d5(0,0,hQ):d5(0,0,0xfff0)}var
  f=a==0&&1/a==-Infinity?aI:a>=0?0:aI;if(f)a=-a;var
  b=yu(a)+1023;if(b<=0){b=0;a/=Math.pow(2,-ir)}else{a/=Math.pow(2,b-iV);if(a<16){a*=2;b-=1}if(b==0)a/=2}var
  d=Math.pow(2,24),c=a|0;a=(a-c)*d;var
  e=a|0;a=(a-e)*d;var
  g=a|0;c=c&fw|f|b<<4;return d5(g,e,c)}function
  cS(a){return a.toArray()}function
  i5(c,b,g){c.write(32,b.dims.length);c.write(32,b.kind|b.layout<<8);if(b.caml_custom==dW)for(var
  a=0;a<b.dims.length;a++)if(b.dims[a]<aM)c.write(16,b.dims[a]);else{c.write(16,aM);c.write(32,0);c.write(32,b.dims[a])}else
  for(var
  a=0;a<b.dims.length;a++)c.write(32,b.dims[a]);switch(b.kind){case
  2:case
  3:case
  12:for(var
  a=0;a<b.data.length;a++)c.write(8,b.data[a]);break;case
  4:case
  5:for(var
  a=0;a<b.data.length;a++)c.write(16,b.data[a]);break;case
  6:for(var
  a=0;a<b.data.length;a++)c.write(32,b.data[a]);break;case
  8:case
  9:c.write(8,0);for(var
  a=0;a<b.data.length;a++)c.write(32,b.data[a]);break;case
  7:for(var
  a=0;a<b.data.length/2;a++){var
  e=cS(b.get(a));for(var
  d=0;d<8;d++)c.write(8,e[d])}break;case
  1:for(var
  a=0;a<b.data.length;a++){var
  e=cS(d4(b.get(a)));for(var
  d=0;d<8;d++)c.write(8,e[d])}break;case
  0:for(var
  a=0;a<b.data.length;a++){var
  e=fT(b.get(a));c.write(32,e)}break;case
  10:for(var
  a=0;a<b.data.length/2;a++){var
  d=b.get(a);c.write(32,fT(d[1]));c.write(32,fT(d[2]))}break;case
  11:for(var
  a=0;a<b.data.length/2;a++){var
  f=b.get(a),e=cS(d4(f[1]));for(var
  d=0;d<8;d++)c.write(8,e[d]);var
  e=cS(d4(f[2]));for(var
  d=0;d<8;d++)c.write(8,e[d])}break}g[0]=(4+b.dims.length)*4;g[1]=(4+b.dims.length)*8}function
  i3(a){switch(a){case
  7:case
  10:case
  11:return 2;default:return 1}}function
  xy(b,d){var
  a;switch(b){case
  0:a=Float32Array;break;case
  1:a=Float64Array;break;case
  2:a=Int8Array;break;case
  3:a=Uint8Array;break;case
  4:a=Int16Array;break;case
  5:a=Uint16Array;break;case
  6:a=Int32Array;break;case
  7:a=Int32Array;break;case
  8:a=Int32Array;break;case
  9:a=Int32Array;break;case
  10:a=Float32Array;break;case
  11:a=Float64Array;break;case
  12:a=Uint8Array;break}if(!a)N("Bigarray.create: unsupported kind");var
  c=new
  a(d*i3(b));return c}function
  fU(c){var
  a=new
  Int32Array(1);a[0]=c;var
  b=new
  Float32Array(a.buffer);return b[0]}function
  cR(a){return new
  l(a[7]<<0|a[6]<<8|a[5]<<16,a[4]<<0|a[3]<<8|a[2]<<16,a[1]<<0|a[0]<<8)}function
  fV(d){var
  f=d.lo,g=d.mi,b=d.hi,c=(b&0x7fff)>>4;if(c==2047)return(f|g|b&fw)==0?b&aI?-Infinity:Infinity:NaN;var
  e=Math.pow(2,-24),a=(f*e+g)*e+(b&fw);if(c>0){a+=16;a*=Math.pow(2,c-iV)}else
  a*=Math.pow(2,-ir);if(b&aI)a=-a;return a}function
  fL(b){var
  d=b.length,c=1;for(var
  a=0;a<d;a++){if(b[a]<0)N("Bigarray.create: negative dimension");c=c*b[a]}return c}function
  xR(b,a){return new
  l(b&a0,b>>>24&ap|(a&aM)<<8,a>>>16&aM)}function
  fW(a){return a.hi32()}function
  fX(a){return a.lo32()}var
  xz=dW;function
  bn(c,d,b,a){this.kind=c;this.layout=d;this.dims=b;this.data=a}bn.prototype.caml_custom=xz;bn.prototype.offset=function(b){var
  c=0;if(typeof
  b==="number")b=[b];if(!(b
  instanceof
  Array))N("bigarray.js: invalid offset");if(this.dims.length!=b.length)N("Bigarray.get/set: bad number of dimensions");if(this.layout==0)for(var
  a=0;a<this.dims.length;a++){if(b[a]<0||b[a]>=this.dims[a])cO();c=c*this.dims[a]+b[a]}else
  for(var
  a=this.dims.length-1;a>=0;a--){if(b[a]<1||b[a]>this.dims[a])cO();c=c*this.dims[a]+(b[a]-1)}return c};bn.prototype.get=function(a){switch(this.kind){case
  7:var
  d=this.data[a*2+0],b=this.data[a*2+1];return xR(d,b);case
  10:case
  11:var
  e=this.data[a*2+0],c=this.data[a*2+1];return[dO,e,c];default:return this.data[a]}};bn.prototype.set=function(a,b){switch(this.kind){case
  7:this.data[a*2+0]=fX(b);this.data[a*2+1]=fW(b);break;case
  10:case
  11:this.data[a*2+0]=b[1];this.data[a*2+1]=b[2];break;default:this.data[a]=b;break}return 0};bn.prototype.fill=function(b){switch(this.kind){case
  7:var
  c=fX(b),e=fW(b);if(c==e)this.data.fill(c);else
  for(var
  a=0;a<this.data.length;a++)this.data[a]=a%2==0?c:e;break;case
  10:case
  11:var
  d=b[1],f=b[2];if(d==f)this.data.fill(d);else
  for(var
  a=0;a<this.data.length;a++)this.data[a]=a%2==0?d:f;break;default:this.data.fill(b);break}};bn.prototype.compare=function(b,g){if(this.layout!=b.layout||this.kind!=b.kind){var
  e=this.kind|this.layout<<8,f=b.kind|b.layout<<8;return f-e}if(this.dims.length!=b.dims.length)return b.dims.length-this.dims.length;for(var
  a=0;a<this.dims.length;a++)if(this.dims[a]!=b.dims[a])return this.dims[a]<b.dims[a]?-1:1;switch(this.kind){case
  0:case
  1:case
  10:case
  11:var
  c,d;for(var
  a=0;a<this.data.length;a++){c=this.data[a];d=b.data[a];if(c<d)return-1;if(c>d)return 1;if(c!=d){if(!g)return NaN;if(c==c)return 1;if(d==d)return-1}}break;case
  7:for(var
  a=0;a<this.data.length;a+=2){if(this.data[a+1]<b.data[a+1])return-1;if(this.data[a+1]>b.data[a+1])return 1;if(this.data[a]>>>0<b.data[a]>>>0)return-1;if(this.data[a]>>>0>b.data[a]>>>0)return 1}break;case
  2:case
  3:case
  4:case
  5:case
  6:case
  8:case
  9:case
  12:for(var
  a=0;a<this.data.length;a++){if(this.data[a]<b.data[a])return-1;if(this.data[a]>b.data[a])return 1}break}return 0};function
  b6(c,d,b,a){this.kind=c;this.layout=d;this.dims=b;this.data=a}b6.prototype=new
  bn();b6.prototype.offset=function(a){if(typeof
  a!=="number")if(a
  instanceof
  Array&&a.length==1)a=a[0];else
  N("Ml_Bigarray_c_1_1.offset");if(a<0||a>=this.dims[0])cO();return a};b6.prototype.get=function(a){return this.data[a]};b6.prototype.set=function(a,b){this.data[a]=b;return 0};b6.prototype.fill=function(a){this.data.fill(a);return 0};function
  i1(c,d,a,b){var
  e=i3(c);if(fL(a)*e!=b.length)N("length doesn't match dims");if(d==0&&a.length==1&&e==1)return new
  b6(c,d,a,b);return new
  bn(c,d,a,b)}function
  ar(b){if(!az.Failure)az.Failure=[A,a(e_),-3];f1(az.Failure,b)}function
  i2(b,v,r){var
  i=b.read32s();if(i<0||i>16)ar("input_value: wrong number of bigarray dimensions");var
  p=b.read32s(),j=p&ap,o=p>>8&1,h=[];if(r==dW)for(var
  a=0;a<i;a++){var
  n=b.read16u();if(n==aM){var
  t=b.read32u(),u=b.read32u();if(t!=0)ar("input_value: bigarray dimension overflow in 32bit");n=u}h.push(n)}else
  for(var
  a=0;a<i;a++)h.push(b.read32u());var
  d=fL(h),f=xy(j,d),g=i1(j,o,h,f);switch(j){case
  2:for(var
  a=0;a<d;a++)f[a]=b.read8s();break;case
  3:case
  12:for(var
  a=0;a<d;a++)f[a]=b.read8u();break;case
  4:for(var
  a=0;a<d;a++)f[a]=b.read16s();break;case
  5:for(var
  a=0;a<d;a++)f[a]=b.read16u();break;case
  6:for(var
  a=0;a<d;a++)f[a]=b.read32s();break;case
  8:case
  9:var
  s=b.read8u();if(s)ar("input_value: cannot read bigarray with 64-bit OCaml ints");for(var
  a=0;a<d;a++)f[a]=b.read32s();break;case
  7:var
  e=new
  Array(8);for(var
  a=0;a<d;a++){for(var
  c=0;c<8;c++)e[c]=b.read8u();var
  q=cR(e);g.set(a,q)}break;case
  1:var
  e=new
  Array(8);for(var
  a=0;a<d;a++){for(var
  c=0;c<8;c++)e[c]=b.read8u();var
  k=fV(cR(e));g.set(a,k)}break;case
  0:for(var
  a=0;a<d;a++){var
  k=fU(b.read32s());g.set(a,k)}break;case
  10:for(var
  a=0;a<d;a++){var
  m=fU(b.read32s()),l=fU(b.read32s());g.set(a,[dO,m,l])}break;case
  11:var
  e=new
  Array(8);for(var
  a=0;a<d;a++){for(var
  c=0;c<8;c++)e[c]=b.read8u();var
  m=fV(cR(e));for(var
  c=0;c<8;c++)e[c]=b.read8u();var
  l=fV(cR(e));g.set(a,[dO,m,l])}break}v[0]=(4+i)*4;return i1(j,o,h,f)}function
  i0(a,b,c){return a.compare(b,c)}function
  d7(a,b){return Math.imul(a,b)}function
  X(b,a){a=d7(a,0xcc9e2d51|0);a=a<<15|a>>>32-15;a=d7(a,0x1b873593);b^=a;b=b<<13|b>>>32-13;return(b+(b<<2)|0)+(0xe6546b64|0)|0}function
  xM(a,b){a=X(a,fX(b));a=X(a,fW(b));return a}function
  fR(a,b){return xM(a,d4(b))}function
  i4(c){var
  b=fL(c.dims),d=0;switch(c.kind){case
  2:case
  3:case
  12:if(b>aL)b=aL;var
  e=0,a=0;for(a=0;a+4<=c.data.length;a+=4){e=c.data[a+0]|c.data[a+1]<<8|c.data[a+2]<<16|c.data[a+3]<<24;d=X(d,e)}e=0;switch(b&3){case
  3:e=c.data[a+2]<<16;case
  2:e|=c.data[a+1]<<8;case
  1:e|=c.data[a+0];d=X(d,e)}break;case
  4:case
  5:if(b>cK)b=cK;var
  e=0,a=0;for(a=0;a+2<=c.data.length;a+=2){e=c.data[a+0]|c.data[a+1]<<16;d=X(d,e)}if((b&1)!=0)d=X(d,c.data[a]);break;case
  6:if(b>64)b=64;for(var
  a=0;a<b;a++)d=X(d,c.data[a]);break;case
  8:case
  9:if(b>64)b=64;for(var
  a=0;a<b;a++)d=X(d,c.data[a]);break;case
  7:if(b>32)b=32;b*=2;for(var
  a=0;a<b;a++)d=X(d,c.data[a]);break;case
  10:b*=2;case
  0:if(b>64)b=64;for(var
  a=0;a<b;a++)d=fR(d,c.data[a]);break;case
  11:b*=2;case
  1:if(b>32)b=32;for(var
  a=0;a<b;a++)d=fR(d,c.data[a]);break}return d}function
  xP(a,b){b[0]=4;return a.read32s()}function
  yf(a,b){switch(a.read8u()){case
  1:b[0]=4;return a.read32s();case
  2:ar("input_value: native integer value too large");default:ar("input_value: ill-formed native integer")}}function
  x0(c,d){var
  b=new
  Array(8);for(var
  a=0;a<8;a++)b[a]=c.read8u();d[0]=8;return cR(b)}function
  xW(e,d,b){var
  c=cS(d);for(var
  a=0;a<8;a++)e.write(8,c[a]);b[0]=8;b[1]=8}function
  xQ(a,b,c){return a.compare(b)}function
  xT(a){return a.lo32()^a.hi32()}var
  cQ={"_j":{deserialize:x0,serialize:xW,fixed_length:8,compare:xQ,hash:xT},"_i":{deserialize:xP,fixed_length:4},"_n":{deserialize:yf,fixed_length:4},"_bigarray":{deserialize:function(a,b){return i2(a,b,"_bigarray")},serialize:i5,compare:i0,hash:i4},"_bigarr02":{deserialize:function(a,b){return i2(a,b,dW)},serialize:i5,compare:i0,hash:i4}};function
  fO(a){return cQ[a.caml_custom]&&cQ[a.caml_custom].compare}function
  i_(f,c,d,e){var
  b=fO(c);if(b){var
  a=d>0?b(c,f,e):b(f,c,e);if(e&&a!=a)return d;if(+a!=+a)return+a;if((a|0)!=0)return a|0}return d}function
  cU(a){return a
  instanceof
  aN}function
  d6(a){return cU(a)}function
  i$(a){if(typeof
  a==="number")return ct;else
  if(cU(a))return dS;else
  if(d6(a))return 1252;else
  if(a
  instanceof
  Array&&a[0]===a[0]>>>0&&a[0]<=bS){var
  b=a[0]|0;return b==dO?0:b}else
  if(a
  instanceof
  String)return ib;else
  if(typeof
  a=="string")return ib;else
  if(a
  instanceof
  Number)return ct;else
  if(a&&a.caml_custom)return fb;else
  if(a&&a.compare)return 1256;else
  if(typeof
  a=="function")return 1247;else
  if(typeof
  a=="symbol")return 1251;return 1001}function
  je(a,b){if(a<b)return-1;if(a==b)return 0;return 1}function
  i7(a,b){a.t&6&&bF(a);b.t&6&&bF(b);return a.c<b.c?-1:a.c>b.c?1:0}function
  d9(a,b){return i7(a,b)}function
  fN(a,b,d){var
  e=[];for(;;){if(!(d&&a===b)){var
  f=i$(a);if(f==bg){a=a[1];continue}var
  g=i$(b);if(g==bg){b=b[1];continue}if(f!==g){if(f==ct){if(g==fb)return i_(a,b,-1,d);return-1}if(g==ct){if(f==fb)return i_(b,a,1,d);return 1}return f<g?-1:1}switch(f){case
  247:N(fn);break;case
  248:var
  c=je(a[2],b[2]);if(c!=0)return c|0;break;case
  249:N(fn);break;case
  250:N("equal: got Forward_tag, should not happen");break;case
  251:N("equal: abstract value");break;case
  252:if(a!==b){var
  c=i7(a,b);if(c!=0)return c|0}break;case
  253:N("equal: got Double_tag, should not happen");break;case
  254:N("equal: got Double_array_tag, should not happen");break;case
  255:N("equal: got Custom_tag, should not happen");break;case
  1247:N(fn);break;case
  1255:var
  i=fO(a);if(i!=fO(b))return a.caml_custom<b.caml_custom?-1:1;if(!i)N("compare: abstract value");var
  c=i(a,b,d);if(c!=c)return d?-1:c;if(c!==(c|0))return-1;if(c!=0)return c|0;break;case
  1256:var
  c=a.compare(b,d);if(c!=c)return d?-1:c;if(c!==(c|0))return-1;if(c!=0)return c|0;break;case
  1000:a=+a;b=+b;if(a<b)return-1;if(a>b)return 1;if(a!=b){if(!d)return NaN;if(a==a)return 1;if(b==b)return-1}break;case
  1001:if(a<b)return-1;if(a>b)return 1;if(a!=b){if(!d)return NaN;if(a==a)return 1;if(b==b)return-1}break;case
  1251:if(a!==b){if(!d)return NaN;return 1}break;case
  1252:var
  a=aO(a),b=aO(b);if(a!==b){if(a<b)return-1;if(a>b)return 1}break;case
  12520:var
  a=a.toString(),b=b.toString();if(a!==b){if(a<b)return-1;if(a>b)return 1}break;case
  246:case
  254:default:if(a.length!=b.length)return a.length<b.length?-1:1;if(a.length>1)e.push(a,b,1);break}}if(e.length==0)return 0;var
  h=e.pop();b=e.pop();a=e.pop();if(h+1<a.length)e.push(a,b,h+1);a=a[h];b=b[h]}}function
  b7(a,b){return fN(a,b,true)}function
  xD(){return[0]}function
  E(a){if(a<0)N("Bytes.create");return new
  aN(a?2:9,d,a)}function
  bG(a,b){return+(fN(a,b,false)==0)}function
  xF(a,c,b,e){if(b>0)if(c==0&&(b>=a.l||a.t==2&&b>=a.c.length))if(e==0){a.c=d;a.t=2}else{a.c=b8(b,String.fromCharCode(e));a.t=b==a.l?0:2}else{if(a.t!=4)d2(a);for(b+=c;c<b;c++)a.c[c]=e}return 0}function
  f0(d){d=aO(d);var
  e=d.length;if(e>31)N("format_int: format too long");var
  a={justify:bW,signstyle:bj,filler:ac,alternate:false,base:0,signedconv:false,width:0,uppercase:false,sign:1,prec:-1,conv:"f"};for(var
  c=0;c<e;c++){var
  b=d.charAt(c);switch(b){case"-":a.justify=bj;break;case"+":case" ":a.signstyle=b;break;case"0":a.filler=ad;break;case"#":a.alternate=true;break;case"1":case"2":case"3":case"4":case"5":case"6":case"7":case"8":case"9":a.width=0;while(b=d.charCodeAt(c)-48,b>=0&&b<=9){a.width=a.width*10+b;c++}c--;break;case".":a.prec=0;c++;while(b=d.charCodeAt(c)-48,b>=0&&b<=9){a.prec=a.prec*10+b;c++}c--;case"d":case"i":a.signedconv=true;case"u":a.base=10;break;case"x":a.base=16;break;case"X":a.base=16;a.uppercase=true;break;case"o":a.base=8;break;case"e":case"f":case"g":a.signedconv=true;a.conv=b;break;case"E":case"F":case"G":a.signedconv=true;a.uppercase=true;a.conv=b.toLowerCase();break}}return a}function
  fP(b,g){if(b.uppercase)g=g.toUpperCase();var
  f=g.length;if(b.signedconv&&(b.sign<0||b.signstyle!=bj))f++;if(b.alternate){if(b.base==8)f+=1;if(b.base==16)f+=2}var
  c=d;if(b.justify==bW&&b.filler==ac)for(var
  e=f;e<b.width;e++)c+=ac;if(b.signedconv)if(b.sign<0)c+=bj;else
  if(b.signstyle!=bj)c+=b.signstyle;if(b.alternate&&b.base==8)c+=ad;if(b.alternate&&b.base==16)c+=b.uppercase?"0X":hP;if(b.justify==bW&&b.filler==ad)for(var
  e=f;e<b.width;e++)c+=ad;c+=g;if(b.justify==bj)for(var
  e=f;e<b.width;e++)c+=ac;return a(c)}function
  fQ(i,c){function
  j(a,b){if(Math.abs(a)<1.0)return a.toFixed(b);else{var
  c=parseInt(a.toString().split(bW)[1]);if(c>20){c-=20;a/=Math.pow(10,c);a+=new
  Array(c+1).join(ad);if(b>0)a=a+bm+new
  Array(b+1).join(ad);return a}else
  return a.toFixed(b)}}var
  a,e=f0(i),d=e.prec<0?6:e.prec;if(c<0||c==0&&1/c==-Infinity){e.sign=-1;c=-c}if(isNaN(c)){a=ff;e.filler=ac}else
  if(!isFinite(c)){a="inf";e.filler=ac}else
  switch(e.conv){case"e":var
  a=c.toExponential(d),b=a.length;if(a.charAt(b-3)==fE)a=a.slice(0,b-1)+ad+a.slice(b-1);break;case"f":a=j(c,d);break;case"g":d=d?d:1;a=c.toExponential(d-1);var
  h=a.indexOf(fE),g=+a.slice(h+1);if(g<-4||c>=1e21||c.toFixed(0).length>d){var
  b=h-1;while(a.charAt(b)==ad)b--;if(a.charAt(b)==bm)b--;a=a.slice(0,b+1)+a.slice(h);b=a.length;if(a.charAt(b-3)==fE)a=a.slice(0,b-1)+ad+a.slice(b-1);break}else{var
  f=d;if(g<0){f-=g+1;a=c.toFixed(f)}else
  while(a=c.toFixed(f),a.length>d+1)f--;if(f){var
  b=a.length-1;while(a.charAt(b)==ad)b--;if(a.charAt(b)==bm)b--;a=a.slice(0,b+1)}}break}return fP(e,a)}function
  d3(f,c){if(aO(f)==fv)return a(d+c);var
  b=f0(f);if(c<0)if(b.signedconv){b.sign=-1;c=-c}else
  c>>>=0;var
  e=c.toString(b.base);if(b.prec>=0){b.filler=ac;var
  g=b.prec-e.length;if(g>0)e=b8(g,ad)+e}return fP(b,e)}var
  jk=0;function
  bo(){return jk++}function
  fY(a){return a.toUtf16()}function
  cY(){return false}function
  yw(){function
  a(a){if(a.charAt(0)===aJ)return[d,a.substring(1)];return}function
  b(c){var
  h=/^([a-zA-Z]:|[\\/]{2}[^\\/]+[\\/]+[^\\/]+)?([\\/])?([\s\S]*?)$/,a=h.exec(c),b=a[1]||d,f=Boolean(b&&b.charAt(1)!==bx);if(Boolean(a[2]||f)){var
  e=a[1]||d,g=a[2]||d;return[e,c.substring(e.length+g.length)]}return}return cY()&&w.process&&w.process.platform?w.process.platform==="win32"?b:a:a}var
  f4=yw();function
  jq(a){return a.slice(-1)!==aJ?a+aJ:a}if(cY()&&w.process&&w.process.cwd)var
  cP=w.process.cwd().replace(/\\/g,aJ);else
  var
  cP="/static";cP=jq(cP);function
  x8(a){a=fY(a);if(!f4(a))a=cP+a;var
  e=f4(a),d=e[1].split(aJ),b=[];for(var
  c=0;c<d.length;c++)switch(d[c]){case"..":if(b.length>1)b.pop();break;case".":break;case"":break;default:b.push(d[c]);break}b.unshift(e[0]);b.orig=a;return b}function
  yt(f){for(var
  g=d,b=g,a,i,c=0,h=f.length;c<h;c++){a=f.charCodeAt(c);if(a<ax){for(var
  e=c+1;e<h&&(a=f.charCodeAt(e))<ax;e++);if(e-c>hR){b.substr(0,1);g+=b;b=d;g+=f.slice(c,e)}else
  b+=f.slice(c,e);if(e==h)break;c=e}if(a<iH){b+=String.fromCharCode(0xc0|a>>6);b+=String.fromCharCode(ax|a&bi)}else
  if(a<0xd800||a>=h4)b+=String.fromCharCode(h5|a>>12,ax|a>>6&bi,ax|a&bi);else
  if(a>=0xdbff||c+1==h||(i=f.charCodeAt(c+1))<h0||i>h4)b+="\xef\xbf\xbd";else{c++;a=(a<<10)+i-0x35fdc00;b+=String.fromCharCode(iP|a>>18,ax|a>>12&bi,ax|a>>6&bi,ax|a&bi)}if(b.length>cv){b.substr(0,1);g+=b;b=d}}return g+b}function
  xB(a){var
  b=9;if(!js(a))b=8,a=yt(a);return new
  aN(b,a,a.length)}function
  al(a){return xB(a)}var
  yx=["E2BIG","EACCES","EAGAIN",e7,"EBUSY","ECHILD","EDEADLK","EDOM",hW,"EFAULT","EFBIG","EINTR","EINVAL","EIO","EISDIR","EMFILE","EMLINK","ENAMETOOLONG","ENFILE","ENODEV",fx,"ENOEXEC","ENOLCK","ENOMEM","ENOSPC","ENOSYS",fd,iD,"ENOTTY","ENXIO","EPERM","EPIPE","ERANGE","EROFS","ESPIPE","ESRCH","EXDEV","EWOULDBLOCK","EINPROGRESS","EALREADY","ENOTSOCK","EDESTADDRREQ","EMSGSIZE","EPROTOTYPE","ENOPROTOOPT","EPROTONOSUPPORT","ESOCKTNOSUPPORT","EOPNOTSUPP","EPFNOSUPPORT","EAFNOSUPPORT","EADDRINUSE","EADDRNOTAVAIL","ENETDOWN","ENETUNREACH","ENETRESET","ECONNABORTED","ECONNRESET","ENOBUFS","EISCONN","ENOTCONN","ESHUTDOWN","ETOOMANYREFS","ETIMEDOUT","ECONNREFUSED","EHOSTDOWN","EHOSTUNREACH","ELOOP","EOVERFLOW"];function
  br(e,g,f,a){var
  b=yx.indexOf(e);if(b<0){if(a==null)a=-9999;b=[0,a]}var
  c=[b,al(g||d),al(f||d)];return c}var
  ji={};function
  bI(a){return ji[a]}function
  bq(b,a){throw[0,b].concat(a)}function
  fM(a){if(!(a
  instanceof
  Uint8Array))a=new
  Uint8Array(a);return new
  aN(4,a,a.length)}function
  r(a){f1(az.Sys_error,a)}function
  jn(a){r(a+dy)}function
  cX(a){if(a.t!=4)d2(a);return a.c}function
  as(a){return a.l}function
  xt(){}function
  aa(a){this.data=a}aa.prototype=new
  xt();aa.prototype.constructor=aa;aa.prototype.truncate=function(a){var
  b=this.data;this.data=E(a|0);a8(b,0,this.data,0,a)};aa.prototype.length=function(){return as(this.data)};aa.prototype.write=function(b,d,g,a){var
  c=this.length();if(b+a>=c){var
  e=E(b+a),f=this.data;this.data=e;a8(f,0,this.data,0,c)}a8(fM(d),g,this.data,b,a);return 0};aa.prototype.read=function(b,e,f,a){var
  c=this.length();if(b+a>=c)a=c-b;if(a){var
  d=E(a|0);a8(this.data,b,d,0,a);e.set(cX(d),f)}return a};function
  bD(c,a,b){this.file=a;this.name=c;this.flags=b}bD.prototype.err_closed=function(){r(this.name+hN)};bD.prototype.length=function(){if(this.file)return this.file.length();this.err_closed()};bD.prototype.write=function(c,a,d,b){if(this.file)return this.file.write(c,a,d,b);this.err_closed()};bD.prototype.read=function(c,a,d,b){if(this.file)return this.file.read(c,a,d,b);this.err_closed()};bD.prototype.close=function(){this.file=undefined};function
  U(b,a){this.content={};this.root=b;this.lookupFun=a}U.prototype.nm=function(a){return this.root+a};U.prototype.create_dir_if_needed=function(e){var
  c=e.split(aJ),b=d;for(var
  a=0;a<c.length-1;a++){b+=c[a]+aJ;if(this.content[b])continue;this.content[b]=Symbol("directory")}};U.prototype.slash=function(a){return/\/$/.test(a)?a:a+aJ};U.prototype.lookup=function(b){if(!this.content[b]&&this.lookupFun){var
  c=this.lookupFun(a(this.root),a(b));if(c!==0){this.create_dir_if_needed(b);this.content[b]=new
  aa(aq(c[1]))}}};U.prototype.exists=function(a){if(a==d)return 1;var
  b=this.slash(a);if(this.content[b])return 1;this.lookup(a);return this.content[a]?1:0};U.prototype.mkdir=function(c,f,e){var
  b=e&&bI(fr);if(this.exists(c))if(b)bq(b,br(hW,e2,this.nm(c)));else
  r(c+": File exists");var
  a=/^(.*)\/[^/]+/.exec(c);a=a&&a[1]||d;if(!this.exists(a))if(b)bq(b,br(fx,e2,this.nm(a)));else
  r(a+dy);if(!this.is_dir(a))if(b)bq(b,br(fd,e2,this.nm(a)));else
  r(a+fC);this.create_dir_if_needed(this.slash(c))};U.prototype.rmdir=function(a,g){var
  b=g&&bI(fr),c=a==d?d:this.slash(a),f=new
  RegExp(h$+c+iE);if(!this.exists(a))if(b)bq(b,br(fx,fq,this.nm(a)));else
  r(a+dy);if(!this.is_dir(a))if(b)bq(b,br(fd,fq,this.nm(a)));else
  r(a+fC);for(var
  e
  in
  this.content)if(e.match(f))if(b)bq(b,br(iD,fq,this.nm(a)));else
  r(this.nm(a)+": Directory not empty");delete
  this.content[c]};U.prototype.readdir=function(a){var
  g=a==d?d:this.slash(a);if(!this.exists(a))r(a+dy);if(!this.is_dir(a))r(a+fC);var
  h=new
  RegExp(h$+g+iE),e={},c=[];for(var
  f
  in
  this.content){var
  b=f.match(h);if(b&&!e[b[1]]){e[b[1]]=true;c.push(b[1])}}return c};U.prototype.opendir=function(a,f){var
  b=f&&bI(fr),c=this.readdir(a),d=false,e=0;return{readSync:function(){if(d)if(b)bq(b,br(e7,iK,this.nm(a)));else
  r(a+iR);if(e==c.length)return null;var
  f=c[e];e++;return{name:f}},closeSync:function(){if(d)if(b)bq(b,br(e7,iK,this.nm(a)));else
  r(a+iR);d=true;c=[]}}};U.prototype.is_dir=function(a){if(a==d)return true;var
  b=this.slash(a);return this.content[b]?1:0};U.prototype.unlink=function(a){var
  b=this.content[a]?true:false;delete
  this.content[a];return b};U.prototype.open=function(a,b){var
  c;if(b.rdonly&&b.wronly)r(this.nm(a)+fj);if(b.text&&b.binary)r(this.nm(a)+ft);this.lookup(a);if(this.content[a]){if(this.is_dir(a))r(this.nm(a)+h8);if(b.create&&b.excl)r(this.nm(a)+fi);c=this.content[a];if(b.truncate)c.truncate()}else
  if(b.create){this.create_dir_if_needed(a);this.content[a]=new
  aa(E(0));c=this.content[a]}else
  jn(this.nm(a));return new
  bD(this.nm(a),c,b)};U.prototype.open=function(a,b){var
  c;if(b.rdonly&&b.wronly)r(this.nm(a)+fj);if(b.text&&b.binary)r(this.nm(a)+ft);this.lookup(a);if(this.content[a]){if(this.is_dir(a))r(this.nm(a)+h8);if(b.create&&b.excl)r(this.nm(a)+fi);c=this.content[a];if(b.truncate)c.truncate()}else
  if(b.create){this.create_dir_if_needed(a);this.content[a]=new
  aa(E(0));c=this.content[a]}else
  jn(this.nm(a));return new
  bD(this.nm(a),c,b)};U.prototype.register=function(c,a){var
  b;if(this.content[c])r(this.nm(c)+fi);if(cU(a))b=new
  aa(a);if(d6(a))b=new
  aa(aq(a));else
  if(a
  instanceof
  Array)b=new
  aa(fM(a));else
  if(typeof
  a==="string")b=new
  aa(i9(a));else
  if(a.toString){var
  d=aq(al(a.toString()));b=new
  aa(d)}if(b){this.create_dir_if_needed(c);this.content[c]=b}else
  r(this.nm(c)+" : registering file with invalid content type")};U.prototype.constructor=U;function
  iZ(){}function
  jc(b){var
  a=f4(b);if(!a)return;return a[0]+aJ}var
  d8=jc(cP)||ar("unable to compute caml_root"),b9=[];if(cY())b9.push({path:d8,device:new
  iZ(d8)});else
  b9.push({path:d8,device:new
  U(d8)});b9.push({path:iv,device:new
  U(iv)});function
  jt(b){var
  g=x8(b),b=g.join(aJ),f=jq(b),c;for(var
  e=0;e<b9.length;e++){var
  a=b9[e];if(f.search(a.path)==0&&(!c||c.path.length<a.path.length))c={path:a.path,device:a.device,rest:b.substring(a.path.length,b.length)}}if(!c&&cY()){var
  d=jc(b);if(d&&d.match(/^[a-zA-Z]:\/$/)){var
  a={path:d,device:new
  iZ(d)};b9.push(a);c={path:a.path,device:a.device,rest:b.substring(a.path.length,b.length)}}}if(c)return c;r("no device found for "+f)}function
  xE(c,b){var
  a=jt(c);if(!a.device.register)ar("cannot register file");a.device.register(a.rest,b);return 0}function
  jr(c,b){var
  c=a(c),b=a(b);return xE(c,b)}function
  xH(){var
  b=w.caml_fs_tmp;if(b)for(var
  a=0;a<b.length;a++)jr(b[a].name,b[a].content);w.jsoo_create_file=jr;w.caml_fs_tmp=[];return 0}function
  jb(){return[0]}function
  fS(d,b){var
  e=b.length,a,c;for(a=0;a+4<=e;a+=4){c=b.charCodeAt(a)|b.charCodeAt(a+1)<<8|b.charCodeAt(a+2)<<16|b.charCodeAt(a+3)<<24;d=X(d,c)}c=0;switch(e&3){case
  3:c=b.charCodeAt(a+2)<<16;case
  2:c|=b.charCodeAt(a+1)<<8;case
  1:c|=b.charCodeAt(a);d=X(d,c)}d^=e;return d}function
  xN(a,b){return fS(a,aO(b))}function
  xK(d,b){var
  e=b.length,a,c;for(a=0;a+4<=e;a+=4){c=b[a]|b[a+1]<<8|b[a+2]<<16|b[a+3]<<24;d=X(d,c)}c=0;switch(e&3){case
  3:c=b[a+2]<<16;case
  2:c|=b[a+1]<<8;case
  1:c|=b[a];d=X(d,c)}d^=e;return d}function
  x$(a){switch(a.t&6){default:bF(a);case
  0:return a.c;case
  4:return a.c}}function
  xJ(b,c){var
  a=x$(c);return typeof
  a==="string"?fS(b,a):xK(b,a)}function
  xL(a){a^=a>>>16;a=d7(a,0x85ebca6b|0);a^=a>>>13;a=d7(a,0xc2b2ae35|0);a^=a>>>16;return a}function
  xI(j,l,n,m){var
  f,g,h,d,c,b,a,e,i;d=l;if(d<0||d>aL)d=aL;c=j;b=n;f=[m];g=0;h=1;while(g<h&&c>0){a=f[g++];if(a&&a.caml_custom){if(cQ[a.caml_custom]&&cQ[a.caml_custom].hash){var
  k=cQ[a.caml_custom].hash(a);b=X(b,k);c--}}else
  if(a
  instanceof
  Array&&a[0]===(a[0]|0))switch(a[0]){case
  248:b=X(b,a[2]);c--;break;case
  250:f[--g]=a[1];break;default:var
  o=a.length-1<<10|a[0];b=X(b,o);for(e=1,i=a.length;e<i;e++){if(h>=d)break;f[h++]=a[e]}break}else
  if(cU(a)){b=xJ(b,a);c--}else
  if(d6(a)){b=xN(b,a);c--}else
  if(typeof
  a==="string"){b=fS(b,a);c--}else
  if(a===(a|0)){b=X(b,a+a+1);c--}else
  if(a===+a){b=fR(b,a);c--}}b=xL(b);return b&0x3FFFFFFF}function
  xO(a,c,l){if(!isFinite(a)){if(isNaN(a))return al(ff);return al(a>0?iQ:"-infinity")}var
  j=a==0&&1/a==-Infinity?1:a>=0?0:1;if(j)a=-a;var
  e=0;if(a==0);else
  if(a<1)while(a<1&&e>-1022){a*=2;e--}else
  while(a>=2){a/=2;e++}var
  k=e<0?d:bW,f=d;if(j)f=bj;else
  switch(l){case
  43:f=bW;break;case
  32:f=ac;break;default:break}if(c>=0&&c<13){var
  h=Math.pow(2,c*4);a=Math.round(a*h)/h}var
  b=a.toString(16);if(c>=0){var
  i=b.indexOf(bm);if(i<0)b+=bm+b8(c,ad);else{var
  g=i+1+c;if(b.length<g)b+=b8(g-b.length,ad);else
  b=b.substr(0,g)}}return al(f+hP+b+a1+k+e.toString(10))}function
  xV(a){return+a.isZero()}function
  xY(a){return new
  l(a&a0,a>>24&a0,a>>31&aM)}function
  xZ(a){return a.toInt()}function
  xU(a){return+a.isNeg()}function
  xX(a){return a.neg()}function
  xS(h,c){var
  a=f0(h);if(a.signedconv&&xU(c)){a.sign=-1;c=xX(c)}var
  b=d,i=xY(a.base),g="0123456789abcdef";do{var
  f=c.udivmod(i);c=f.quotient;b=g.charAt(xZ(f.modulus))+b}while(!xV(c));if(a.prec>=0){a.filler=ac;var
  e=a.prec-b.length;if(e>0)b=b8(e,ad)+b}return fP(a,b)}function
  aB(b,a){return bE(b,a)}function
  m(a){return as(a)}function
  yi(c){var
  a=0,e=m(c),b=10,d=1;if(e>0)switch(aB(c,a)){case
  45:a++;d=-1;break;case
  43:a++;d=1;break}if(a+1<e&&aB(c,a)==48)switch(aB(c,a+1)){case
  120:case
  88:b=16;a+=2;break;case
  111:case
  79:b=8;a+=2;break;case
  98:case
  66:b=2;a+=2;break;case
  117:case
  85:a+=2;break}return[a,d,b]}function
  jl(a){if(a>=48&&a<=57)return a-48;if(a>=65&&a<=90)return a-55;if(a>=97&&a<=122)return a-87;return-1}function
  cT(f){var
  h=yi(f),c=h[0],i=h[1],d=h[2],g=m(f),j=-1>>>0,e=c<g?aB(f,c):0,b=jl(e);if(b<0||b>=d)ar(dC);var
  a=b;for(c++;c<g;c++){e=aB(f,c);if(e==95)continue;b=jl(e);if(b<0||b>=d)break;a=d*a+b;if(a>j)ar(dC)}if(c!=g)ar(dC);a=i*a;if(d==10&&(a|0)!=a)ar(dC);return a|0}function
  x2(){var
  b=console,c=["log","debug","info","warn",iU,"assert",by,"dirxml","trace","group","groupCollapsed","groupEnd","time","timeEnd"];function
  d(){}for(var
  a=0;a<c.length;a++)if(!b[c[a]])b[c[a]]=d;return b}function
  x3(c){var
  d=c.length,b=new
  Array(d+1);b[0]=0;for(var
  a=0;a<d;a++)b[a+1]=c[a];return b}function
  x4(d){return function(){var
  b=arguments.length;if(b>0){var
  c=new
  Array(b);for(var
  a=0;a<b;a++)c[a]=arguments[a];return ay(d,c)}else
  return ay(d,[undefined])}}function
  x5(d){return function(){var
  c=arguments.length,b=new
  Array(c+1);b[0]=this;for(var
  a=0;a<c;a++)b[a+1]=arguments[a];return ay(d,b)}}function
  ae(b){b=aO(b);var
  d=b.length/2,c=new
  Array(d);for(var
  a=0;a<d;a++)c[a]=(b.charCodeAt(2*a)|b.charCodeAt(2*a+1)<<8)<<16>>16;return c}function
  x6(b,t,a){var
  n=2,o=3,r=5,d=6,h=7,g=8,j=9,m=1,l=2,q=3,s=4,p=5;if(!b.lex_default){b.lex_base=ae(b[m]);b.lex_backtrk=ae(b[l]);b.lex_check=ae(b[p]);b.lex_trans=ae(b[s]);b.lex_default=ae(b[q])}var
  e,c=t,k=cX(a[n]);if(c>=0){a[h]=a[r]=a[d];a[g]=-1}else
  c=-c-1;for(;;){var
  f=b.lex_base[c];if(f<0)return-f-1;var
  i=b.lex_backtrk[c];if(i>=0){a[h]=a[d];a[g]=i}if(a[d]>=a[o])if(a[j]==0)return-c-1;else
  e=aL;else{e=k[a[d]];a[d]++}if(b.lex_check[f+e]==c)c=b.lex_trans[f+e];else
  c=b.lex_default[c];if(c<0){a[d]=a[h];if(a[g]==-1)ar(hL);else
  return a[g]}else
  if(e==aL)a[j]=0}}function
  bH(c){var
  b=0;for(var
  a=c.length-1;a>=0;a--){var
  d=c[a];b=[0,d,b]}return b}function
  bp(a,d){if(a<0)cO();var
  a=a+1|0,b=new
  Array(a);b[0]=0;for(var
  c=1;c<a;c++)b[c]=d;return b}function
  xv(){var
  a=new
  ArrayBuffer(64),b=new
  Uint32Array(a),c=new
  Uint8Array(a);return{len:0,w:new
  Uint32Array([0x67452301,0xEFCDAB89,0x98BADCFE,0x10325476]),b32:b,b8:c}}var
  d1=function(){function
  k(a,b){return a+b|0}function
  a(d,a,c,f,b,e){a=k(k(a,d),k(f,e));return k(a<<b|a>>>32-b,c)}function
  f(c,b,d,e,h,f,g){return a(b&d|~b&e,c,b,h,f,g)}function
  g(d,b,e,c,h,f,g){return a(b&c|e&~c,d,b,h,f,g)}function
  h(c,b,d,e,h,f,g){return a(b^d^e,c,b,h,f,g)}function
  i(c,b,d,e,h,f,g){return a(d^(b|~e),c,b,h,f,g)}return function(j,e){var
  a=j[0],b=j[1],c=j[2],d=j[3];a=f(a,b,c,d,e[0],7,0xD76AA478);d=f(d,a,b,c,e[1],12,0xE8C7B756);c=f(c,d,a,b,e[2],17,0x242070DB);b=f(b,c,d,a,e[3],22,0xC1BDCEEE);a=f(a,b,c,d,e[4],7,0xF57C0FAF);d=f(d,a,b,c,e[5],12,0x4787C62A);c=f(c,d,a,b,e[6],17,0xA8304613);b=f(b,c,d,a,e[7],22,0xFD469501);a=f(a,b,c,d,e[8],7,0x698098D8);d=f(d,a,b,c,e[9],12,0x8B44F7AF);c=f(c,d,a,b,e[10],17,0xFFFF5BB1);b=f(b,c,d,a,e[11],22,0x895CD7BE);a=f(a,b,c,d,e[12],7,0x6B901122);d=f(d,a,b,c,e[13],12,0xFD987193);c=f(c,d,a,b,e[14],17,0xA679438E);b=f(b,c,d,a,e[15],22,0x49B40821);a=g(a,b,c,d,e[1],5,0xF61E2562);d=g(d,a,b,c,e[6],9,0xC040B340);c=g(c,d,a,b,e[11],14,0x265E5A51);b=g(b,c,d,a,e[0],20,0xE9B6C7AA);a=g(a,b,c,d,e[5],5,0xD62F105D);d=g(d,a,b,c,e[10],9,0x02441453);c=g(c,d,a,b,e[15],14,0xD8A1E681);b=g(b,c,d,a,e[4],20,0xE7D3FBC8);a=g(a,b,c,d,e[9],5,0x21E1CDE6);d=g(d,a,b,c,e[14],9,0xC33707D6);c=g(c,d,a,b,e[3],14,0xF4D50D87);b=g(b,c,d,a,e[8],20,0x455A14ED);a=g(a,b,c,d,e[13],5,0xA9E3E905);d=g(d,a,b,c,e[2],9,0xFCEFA3F8);c=g(c,d,a,b,e[7],14,0x676F02D9);b=g(b,c,d,a,e[12],20,0x8D2A4C8A);a=h(a,b,c,d,e[5],4,0xFFFA3942);d=h(d,a,b,c,e[8],11,0x8771F681);c=h(c,d,a,b,e[11],16,0x6D9D6122);b=h(b,c,d,a,e[14],23,0xFDE5380C);a=h(a,b,c,d,e[1],4,0xA4BEEA44);d=h(d,a,b,c,e[4],11,0x4BDECFA9);c=h(c,d,a,b,e[7],16,0xF6BB4B60);b=h(b,c,d,a,e[10],23,0xBEBFBC70);a=h(a,b,c,d,e[13],4,0x289B7EC6);d=h(d,a,b,c,e[0],11,0xEAA127FA);c=h(c,d,a,b,e[3],16,0xD4EF3085);b=h(b,c,d,a,e[6],23,0x04881D05);a=h(a,b,c,d,e[9],4,0xD9D4D039);d=h(d,a,b,c,e[12],11,0xE6DB99E5);c=h(c,d,a,b,e[15],16,0x1FA27CF8);b=h(b,c,d,a,e[2],23,0xC4AC5665);a=i(a,b,c,d,e[0],6,0xF4292244);d=i(d,a,b,c,e[7],10,0x432AFF97);c=i(c,d,a,b,e[14],15,0xAB9423A7);b=i(b,c,d,a,e[5],21,0xFC93A039);a=i(a,b,c,d,e[12],6,0x655B59C3);d=i(d,a,b,c,e[3],10,0x8F0CCC92);c=i(c,d,a,b,e[10],15,0xFFEFF47D);b=i(b,c,d,a,e[1],21,0x85845DD1);a=i(a,b,c,d,e[8],6,0x6FA87E4F);d=i(d,a,b,c,e[15],10,0xFE2CE6E0);c=i(c,d,a,b,e[6],15,0xA3014314);b=i(b,c,d,a,e[13],21,0x4E0811A1);a=i(a,b,c,d,e[4],6,0xF7537E82);d=i(d,a,b,c,e[11],10,0xBD3AF235);c=i(c,d,a,b,e[2],15,0x2AD7D2BB);b=i(b,c,d,a,e[9],21,0xEB86D391);j[0]=k(a,j[0]);j[1]=k(b,j[1]);j[2]=k(c,j[2]);j[3]=k(d,j[3])}}();function
  xw(a,e,b){var
  d=a.len&bi,c=0;a.len+=b;if(d){var
  f=64-d;if(b<f){a.b8.set(e.subarray(0,b),d);return}a.b8.set(e.subarray(0,f),d);d1(a.w,a.b32);b-=f;c+=f}while(b>=64){a.b8.set(e.subarray(c,c+64),0);d1(a.w,a.b32);b-=64;c+=64}if(b)a.b8.set(e.subarray(c,c+b),0)}function
  xu(b){var
  c=b.len&bi;b.b8[c]=ax;c++;if(c>56){for(var
  a=c;a<64;a++)b.b8[a]=0;d1(b.w,b.b32);for(var
  a=0;a<56;a++)b.b8[a]=0}else
  for(var
  a=c;a<56;a++)b.b8[a]=0;b.b32[14]=b.len<<3;b.b32[15]=b.len>>29&0x1FFFFFFF;d1(b.w,b.b32);var
  e=new
  Uint8Array(16);for(var
  d=0;d<4;d++)for(var
  a=0;a<4;a++)e[d*4+a]=b.w[d]>>8*a&0xFF;return e}function
  yo(b){return a(cV(b,0,b.length))}function
  x9(e,c,b){var
  a=xv(),d=cX(e);xw(a,d.subarray(c,c+b),b);return yo(xu(a))}function
  x_(c,b,a){return x9(aq(c),b,a)}function
  ya(){return 0}var
  a$=new
  Array();function
  aP(b){var
  a=a$[b];if(!a.opened)r("Cannot flush a closed channel");if(!a.buffer||a.buffer_curr==0)return 0;if(a.output)a.output(cV(a.buffer,0,a.buffer_curr));else
  a.file.write(a.offset,a.buffer,0,a.buffer_curr);a.offset+=a.buffer_curr;a.buffer_curr=0;return 0}function
  yq(a,b){return null}var
  d_=new
  Array(3);function
  cN(a,b){aa.call(this,E(0));this.log=function(a){return 0};if(a==1&&typeof
  console.log=="function")this.log=console.log;else
  if(a==2&&typeof
  console.error=="function")this.log=console.error;else
  if(typeof
  console.log=="function")this.log=console.log;this.flags=b}cN.prototype.length=function(){return 0};cN.prototype.write=function(e,c,b,a){if(this.log){if(a>0&&b>=0&&b+a<=c.length&&c[b+a-1]==10)a--;var
  d=E(a);a8(fM(c),b,d,0,a);this.log(d.toUtf16());return 0}r(this.fd+hN)};cN.prototype.read=function(c,a,d,b){r(this.fd+": file descriptor is write only")};cN.prototype.close=function(){this.log=undefined};function
  d$(b,a){if(a==undefined)a=d_.length;d_[a]=b;return a}function
  yy(c,b,f){var
  a={};while(b){switch(b[1]){case
  0:a.rdonly=1;break;case
  1:a.wronly=1;break;case
  2:a.append=1;break;case
  3:a.create=1;break;case
  4:a.truncate=1;break;case
  5:a.excl=1;break;case
  6:a.binary=1;break;case
  7:a.text=1;break;case
  8:a.nonblock=1;break}b=b[2]}if(a.rdonly&&a.wronly)r(aO(c)+fj);if(a.text&&a.binary)r(aO(c)+ft);var
  d=jt(c),e=d.device.open(d.rest,a);return d$(e,undefined)}(function(){function
  a(a,b){return cY()?yq(a,b):new
  cN(a,b)}d$(a(0,{rdonly:1,altname:"/dev/stdin",isCharacterDevice:true}),0);d$(a(1,{buffered:2,wronly:1,isCharacterDevice:true}),1);d$(a(2,{buffered:2,wronly:1,isCharacterDevice:true}),2)}());function
  yb(c){var
  a=d_[c];if(a.flags.wronly)r(iW+c+" is writeonly");var
  d=null,b={file:a,offset:a.flags.append?a.length():0,fd:c,opened:true,out:false,buffer_curr:0,buffer_max:0,buffer:new
  Uint8Array(h6),refill:d};a$[b.fd]=b;return b.fd}function
  jg(c){var
  a=d_[c];if(a.flags.rdonly)r(iW+c+" is readonly");var
  d=a.flags.buffered!==undefined?a.flags.buffered:1,b={file:a,offset:a.flags.append?a.length():0,fd:c,opened:true,out:true,buffer_curr:0,buffer:new
  Uint8Array(h6),buffered:d};a$[b.fd]=b;return b.fd}function
  yc(){var
  b=0;for(var
  a=0;a<a$.length;a++)if(a$[a]&&a$[a].opened&&a$[a].out)b=[0,a$[a].fd,b];return b}function
  O(a){return a}function
  yd(c,b,f,g){var
  a=a$[c];if(!a.opened)r("Cannot output to a closed channel");var
  b=cX(b);b=b.subarray(f,f+g);if(a.buffer_curr+b.length>a.buffer.length){var
  e=new
  Uint8Array(a.buffer_curr+b.length);e.set(a.buffer);a.buffer=e}switch(a.buffered){case
  0:a.buffer.set(b,a.buffer_curr);a.buffer_curr+=b.length;aP(c);break;case
  1:a.buffer.set(b,a.buffer_curr);a.buffer_curr+=b.length;if(a.buffer_curr>=a.buffer.length)aP(c);break;case
  2:var
  d=b.lastIndexOf(10);if(d<0){a.buffer.set(b,a.buffer_curr);a.buffer_curr+=b.length;if(a.buffer_curr>=a.buffer.length)aP(c)}else{a.buffer.set(b.subarray(0,d+1),a.buffer_curr);a.buffer_curr+=d+1;aP(c);a.buffer.set(b.subarray(d+1),a.buffer_curr);a.buffer_curr+=b.length-d-1}break}return 0}function
  jh(b,a,d,c){return yd(b,aq(a),d,c)}function
  fZ(c,b){var
  d=a(String.fromCharCode(b));jh(c,d,0,1);return 0}function
  ye(b,a){if(a==0)f2();return b%a}function
  x7(d,a,c,f){for(;;){var
  b=d.charCodeAt(a);a++;if(b==ap)return;var
  e=d.charCodeAt(a);a++;if(e==ap)c[b+1]=f;else
  c[b+1]=c[e+1]}}function
  jf(d,a,c){for(;;){var
  b=d.charCodeAt(a);a++;if(b==ap)return;var
  e=d.charCodeAt(a);a++;if(e==ap)c[b+1]=-1;else
  c[b+1]=c[e+1]}}function
  yg(a,D,b){var
  t=2,u=3,A=5,f=6,i=7,h=8,n=9,j=10,r=1,p=2,y=3,B=4,v=5,s=6,q=7,z=8,C=9,w=10,x=11;if(!a.lex_default){a.lex_base=ae(a[r]);a.lex_backtrk=ae(a[p]);a.lex_check=ae(a[v]);a.lex_trans=ae(a[B]);a.lex_default=ae(a[y])}if(!a.lex_default_code){a.lex_base_code=ae(a[s]);a.lex_backtrk_code=ae(a[q]);a.lex_check_code=ae(a[w]);a.lex_trans_code=ae(a[C]);a.lex_default_code=ae(a[z])}if(a.lex_code==null)a.lex_code=aO(a[x]);var
  e,c=D,o=cX(b[t]);if(c>=0){b[i]=b[A]=b[f];b[h]=-1}else
  c=-c-1;for(;;){var
  g=a.lex_base[c];if(g<0){var
  d=a.lex_base_code[c];jf(a.lex_code,d,b[j]);return-g-1}var
  l=a.lex_backtrk[c];if(l>=0){var
  d=a.lex_backtrk_code[c];jf(a.lex_code,d,b[j]);b[i]=b[f];b[h]=l}if(b[f]>=b[u])if(b[n]==0)return-c-1;else
  e=aL;else{e=o[b[f]];b[f]++}var
  k=c;if(a.lex_check[g+e]==c)c=a.lex_trans[g+e];else
  c=a.lex_default[c];if(c<0){b[f]=b[i];if(b[h]==-1)ar(hL);else
  return b[h]}else{var
  m=a.lex_base_code[k],d;if(a.lex_check_code[m+e]==k)d=a.lex_trans_code[m+e];else
  d=a.lex_default_code[k];if(d>0)x7(a.lex_code,d,b[j],b[f]);if(e==aL)b[n]=0}}}function
  bJ(a,b){return+(fN(a,b,false)!=0)}function
  jj(d,c){var
  b=new
  Array(c+1);b[0]=d;for(var
  a=1;a<=c;a++)b[a]=0;return b}function
  yh(a,b){a[0]=bg;a[1]=b;return 0}function
  ba(a){if(a
  instanceof
  Array&&a[0]==a[0]>>>0)return a[0];else
  if(cU(a))return dS;else
  if(d6(a))return dS;else
  if(a
  instanceof
  Function||typeof
  a=="function")return 247;else
  if(a&&a.caml_custom)return bS;else
  return ct}function
  aA(b,c,a){if(a&&w.toplevelReloc)b=w.toplevelReloc(a);az[b+1]=c;if(a)az[a]=c}function
  f3(a,b){ji[aO(a)]=b;return 0}function
  yl(a){a[2]=jk++;return a}function
  xA(a,b){if(a===b)return 1;a.t&6&&bF(a);b.t&6&&bF(b);return a.c==b.c?1:0}function
  e(a,b){return xA(a,b)}function
  yn(){N(fA)}function
  G(b,a){if(a>>>0>=m(b))yn();return aB(b,a)}function
  h(a,b){return 1-e(a,b)}function
  yp(){return 0x7FFFFFFF/4|0}function
  yj(){jm(az.Not_found)}function
  jp(c){var
  b=w.process,a=fY(c);if(b&&b.env&&b.env[a]!=undefined)return al(b.env[a]);if(w.jsoo_static_env&&w.jsoo_static_env[a])return al(w.jsoo_static_env[a]);yj()}function
  yr(){if(w.crypto)if(typeof
  w.crypto.getRandomValues==="function"){var
  a=new
  Uint32Array(1);w.crypto.getRandomValues(a);return[0,a[0]]}else
  if(w.crypto.randomBytes===h3){var
  b=w.crypto.randomBytes(4),a=new
  Uint32Array(b);return[0,a[0]]}var
  c=new
  Date().getTime(),d=c^0xffffffff*Math.random();return[0,d]}function
  cW(a){var
  b=1;while(a&&a.joo_tramp){a=a.joo_tramp.apply(null,a.joo_args);b++}return a}function
  o(b,a){return{joo_tramp:b,joo_args:a}}function
  jo(a){return a}function
  H(a){if(a
  instanceof
  Array)return a;if(w.RangeError&&a
  instanceof
  w.RangeError&&a.message&&a.message.match(/maximum call stack/i))return jo(az.Stack_overflow);if(w.InternalError&&a
  instanceof
  w.InternalError&&a.message&&a.message.match(/too much recursion/i))return jo(az.Stack_overflow);if(a
  instanceof
  w.Error&&bI(fa))return[0,bI(fa),a];return[0,az.Failure,al(String(a))]}function
  x1(a){switch(a[2]){case-8:case-11:case-12:return 1;default:return 0}}function
  xG(b){var
  a=d;if(b[0]==0){a+=b[1][1];if(b.length==3&&b[2][0]==0&&x1(b[1]))var
  f=b[2],g=1;else
  var
  g=2,f=b;a+="(";for(var
  e=g;e<f.length;e++){if(e>g)a+=co;var
  c=f[e];if(typeof
  c=="number")a+=c.toString();else
  if(c
  instanceof
  aN)a+=bz+c.toString()+bz;else
  if(typeof
  c=="string")a+=bz+c.toString()+bz;else
  a+=iq}a+=fg}else
  if(b[0]==A)a+=b[1];return a}function
  ja(a){if(a
  instanceof
  Array&&(a[0]==0||a[0]==A)){var
  c=bI(hV);if(c)c(a,false);else{var
  d=xG(a),b=bI(hK);if(b)b(0);console.error(fo+d+"\n")}}else
  throw a}function
  ym(){var
  a=w.process;if(a&&a.on)a.on("uncaughtException",function(b,c){ja(b);a.exit(2)});else
  if(w.addEventListener)w.addEventListener(iU,function(a){if(a.error)ja(a.error)})}ym();function
  b(a,b){return a.length==1?a(b):ay(a,[b])}function
  f(a,b,c){return a.length==2?a(b,c):ay(a,[b,c])}function
  aH(a,b,c,d){return a.length==3?a(b,c,d):ay(a,[b,c,d])}function
  eY(a,b,c,d,e){return a.length==4?a(b,c,d,e):ay(a,[b,c,d,e])}function
  cl(a,b,c,d,e,f){return a.length==5?a(b,c,d,e,f):ay(a,[b,c,d,e,f])}function
  xs(a,b,c,d,e,f,g,h){return a.length==7?a(b,c,d,e,f,g,h):ay(a,[b,c,d,e,f,g,h])}xH();var
  eb=[A,a(iS),-1],f7=[A,a(hX),-2],c0=[A,a(e_),-3],ea=[A,a(ip),-4],q=[A,a(it),-7],f5=[A,a(h9),-8],f6=[A,a(iw),-9],t=[A,a(iJ),-11],f8=[A,a(hJ),-12],c4=[0,a(d),0,0,-1],gk=[0,a(d),1,0,0],xn=[4,0,0,0,[12,45,[4,0,0,0,0]]],et=[0,[11,a('File "'),[2,0,[11,a('", line '),[4,0,0,0,[11,a(ic),[4,0,0,0,[12,45,[4,0,0,0,[11,a(iA),[2,0,0]]]]]]]]]],a('File "%s", line %d, characters %d-%d: %s')],aX=[0,a("\0\0\x01\0\xf9\xff\0\0A\0\xa3\0\xfd\xff\0\0\x01\0\xff\xff\xf1\0 \0\x80\0\xfd\xff\x01\0@\x01\x8e\x01.\x000\0\xfd\xff\x04\0\0\0\xff\xff\x7f\0\xa0\0\xfe\xff\xff\xff\xee\0\x0e\x01\xfd\xff\xfe\xff\x02\0\xff\xff\0\x02\xf7\xffr\x02\xf9\xff\xfa\xff\xfb\xff\x84\x02\0\0\xf8\x02\xff\xff\xfe\xff\xfe\x02\xf9\xff\x04\x03\xfb\xff\xfc\xff\x02\0\n\x03\xff\xff\xfe\xff\x03\0\xff\xffu\0\xff\xff"),a("\xff\xff\x07\0\xff\xff\x05\0\xff\xff\x03\0\xff\xff\x01\0\xff\xff\xff\xff\x04\0\xff\xff\x03\0\xff\xff\x01\0\xff\xff\0\0\xff\xff\x03\0\xff\xff\x01\0\xff\xff\xff\xff\xff\xff\x02\0\xff\xff\xff\xff\xff\xff\x04\0\xff\xff\xff\xff\x03\0\xff\xff\xff\xff\xff\xff\x07\0\xff\xff\xff\xff\xff\xff\x03\0\x02\0\x07\0\xff\xff\xff\xff\xff\xff\xff\xff\x05\0\xff\xff\xff\xff\x02\0\x05\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff"),a("\x01\0\x01\0\0\0\xff\xff\xff\xff\xff\xff\0\0\xff\xff\xff\xff\0\0\xff\xff\f\0\f\0\0\0\xff\xff\xff\xff\xff\xff\x12\0\x12\0\0\0\xff\xff\xff\xff\0\0\x18\0\x18\0\0\0\0\0\x1c\0\x1c\0\0\0\0\0\xff\xff\0\0#\0\0\0#\0\0\0\0\0\0\0#\0\xff\xff#\0\0\0\0\0.\0\0\0.\0\0\0\0\0\xff\xff.\0\0\0\0\x005\0\0\x007\0\0\0"),a("\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0(\0(\x001\x001\0(\0\0\x001\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0(\0\x07\x001\0\0\0\0\x006\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\b\0\t\0\x04\0\x0f\0\x15\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x05\0\0\0\x03\0\xff\xff\x16\0\x06\0 \0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x14\0\x0e\0\xff\xff\0\0\x05\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\n\0\0\0\0\0\0\0\0\0\0\0\0\0\n\0\n\0\n\0\n\0\n\0\n\0\n\0\n\0\n\0\n\0\n\0\n\0\n\0\n\0\n\0\n\0\n\0\n\0\n\0\n\0\n\0\n\0\n\0\n\0\n\0\n\x008\0\0\0\0\0\0\0\n\0\0\0\n\0\n\0\n\0\n\0\n\0\n\0\n\0\n\0\n\0\n\0\n\0\n\0\n\0\n\0\n\0\n\0\n\0\n\0\n\0\n\0\n\0\n\0\n\0\n\0\n\0\n\0\xff\xff\x1a\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x05\0\x05\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\xff\xff\0\0\0\0\0\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\x02\0\xff\xff\x05\0\xff\xff\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\n\0\n\0\r\0\n\0\n\0\n\0\n\0\n\0\n\0\n\0\n\0\n\0\n\0\n\0\x1e\0\x1f\0\x13\0\0\0\xff\xff\0\0\n\0\n\0\n\0\n\0\n\0\n\0\n\0\n\0\n\0\n\0\n\0\n\0\n\0\n\0\n\0\n\0\n\0\n\0\n\0\n\0\n\0\n\0\n\0\n\0\n\0\n\0\xff\xff\xff\xff\0\0\0\0\n\0\0\0\n\0\n\0\n\0\n\0\n\0\n\0\n\0\n\0\n\0\n\0\n\0\n\0\n\0\n\0\n\0\n\0\n\0\n\0\n\0\n\0\n\0\n\0\n\0\n\0\n\0\n\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\xff\xff\0\0\0\0\0\0\0\0\x10\0\0\0\0\0\0\0\0\0\x19\0\xff\xff\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\0\0\0\0\0\0\0\0\x10\0\xff\xff\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\0\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\0\0\0\0\0\0\0\0\0\0\0\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\0\0\0\0\0\0\0\0\x10\0\x1d\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0(\0(\0\0\0\0\0(\0\xff\xff\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0(\0\0\0%\0\0\0\0\0\0\0\0\0$\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0)\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0'\0\0\0\0\0&\0*\0\0\0\0\0'\0'\0'\0'\0'\0'\0'\0'\0'\0'\0'\0'\0'\0'\0'\0'\0'\0'\0'\0'\0'\0'\0'\0'\0'\0'\0\0\0\0\0\0\0\0\0'\0\0\0'\0'\0'\0'\0'\0'\0'\0'\0'\0'\0'\0'\0'\0'\0'\0'\0'\0'\0'\0'\0'\0'\0'\0'\0'\0'\0\xff\xff\xff\xff\0\0\0\0\xff\xff\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\xff\xff\xff\xff\0\0\0\0\xff\xff\xff\xff\0\0\xff\xff\0\0\0\0\0\0\0\0\xff\xff\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\xff\xff\0\0\xff\xff\0\0\0\0\0\0\0\0\xff\xff\0\0\0\0\0\0\xff\xff\xff\xff'\0'\0\0\0'\0'\0'\0'\0'\0'\0'\0'\0'\0'\0'\0\0\0\0\0\xff\xff\xff\xff\0\0\0\0'\0'\0'\0'\0'\0'\0'\0'\0'\0'\0'\0'\0'\0'\0'\0'\0'\0'\0'\0'\0'\0'\0'\0'\0'\0'\0\0\0\0\0\0\0\0\0'\0\0\0'\0'\0'\0'\0'\0'\0'\0'\0'\0'\0'\0'\0'\0'\0'\0'\0'\0'\0'\0'\0'\0'\0'\0'\0'\0'\0\0\0\"\0\xff\xff\xff\xff\0\0\0\0\xff\xff\0\x001\x001\0\0\0\0\x001\0\0\0\xff\xff\xff\xff\0\0\0\0\xff\xff\0\0\xff\xff\xff\xff\0\0\0\0\xff\xff\xff\xff\0\0\xff\xff\0\0\0\0\0\x001\0\xff\xff0\0\0\0\0\0\0\0\xff\xff/\0\xff\xff\0\0\0\0\0\0\xff\xff\xff\xff\xff\xff2\0\0\0\0\0\0\0\xff\xff\0\0\0\0\0\0\xff\xff+\0\0\0\0\0\0\0\0\0\0\x003\0\0\0\0\0\0\0\0\0\0\0\xff\xff\0\0\0\0\0\0\0\0\0\x004\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\xff\xff\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\xff\xff\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\xff\xff\0\0\0\0\0\0\0\0\0\0-\0\0\0\0\0\0\0\0\0\0\0\xff\xff\0\0\0\0\0\0\0\0\0\0\xff\xff"),a("\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff(\0(\x001\x001\0(\0\xff\xff1\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff(\0\x03\x001\0\xff\xff\xff\xff5\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\x07\0\b\0\x03\0\x0e\0\x14\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\x03\0\xff\xff\0\0\x01\0\x15\0\x03\0\x1f\0\x03\0\x03\0\x03\0\x03\0\x03\0\x03\0\x03\0\x03\0\x03\0\x03\0\x03\0\x03\0\x03\0\x03\0\x03\0\x03\0\x03\0\x03\0\x03\0\x03\0\x03\0\x03\0\x03\0\x03\0\x03\0\x03\0\x11\0\x0b\0\x12\0\xff\xff\x03\0\xff\xff\x03\0\x03\0\x03\0\x03\0\x03\0\x03\0\x03\0\x03\0\x03\0\x03\0\x03\0\x03\0\x03\0\x03\0\x03\0\x03\0\x03\0\x03\0\x03\0\x03\0\x03\0\x03\0\x03\0\x03\0\x03\0\x03\0\x04\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\x04\0\x04\0\x04\0\x04\0\x04\0\x04\0\x04\0\x04\0\x04\0\x04\0\x04\0\x04\0\x04\0\x04\0\x04\0\x04\0\x04\0\x04\0\x04\0\x04\0\x04\0\x04\0\x04\0\x04\0\x04\0\x04\x007\0\xff\xff\xff\xff\xff\xff\x04\0\xff\xff\x04\0\x04\0\x04\0\x04\0\x04\0\x04\0\x04\0\x04\0\x04\0\x04\0\x04\0\x04\0\x04\0\x04\0\x04\0\x04\0\x04\0\x04\0\x04\0\x04\0\x04\0\x04\0\x04\0\x04\0\x04\0\x04\0\f\0\x17\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\x05\0\x05\0\xff\xff\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x18\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\xff\xff\xff\xff\0\0\x01\0\x05\x005\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\n\0\n\0\x0b\0\n\0\n\0\n\0\n\0\n\0\n\0\n\0\n\0\n\0\n\0\n\0\x1b\0\x1b\0\x11\0\xff\xff\x12\0\xff\xff\n\0\n\0\n\0\n\0\n\0\n\0\n\0\n\0\n\0\n\0\n\0\n\0\n\0\n\0\n\0\n\0\n\0\n\0\n\0\n\0\n\0\n\0\n\0\n\0\n\0\n\0\x1c\0\x1c\0\xff\xff\xff\xff\n\0\xff\xff\n\0\n\0\n\0\n\0\n\0\n\0\n\0\n\0\n\0\n\0\n\0\n\0\n\0\n\0\n\0\n\0\n\0\n\0\n\0\n\0\n\0\n\0\n\0\n\0\n\0\n\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff7\0\xff\xff\xff\xff\xff\xff\xff\xff\x0f\0\xff\xff\xff\xff\xff\xff\xff\xff\x17\0\f\0\x0f\0\x0f\0\x0f\0\x0f\0\x0f\0\x0f\0\x0f\0\x0f\0\x0f\0\x0f\0\x0f\0\x0f\0\x0f\0\x0f\0\x0f\0\x0f\0\x0f\0\x0f\0\x0f\0\x0f\0\x0f\0\x0f\0\x0f\0\x0f\0\x0f\0\x0f\0\xff\xff\xff\xff\xff\xff\xff\xff\x0f\0\x18\0\x0f\0\x0f\0\x0f\0\x0f\0\x0f\0\x0f\0\x0f\0\x0f\0\x0f\0\x0f\0\x0f\0\x0f\0\x0f\0\x0f\0\x0f\0\x0f\0\x0f\0\x0f\0\x0f\0\x0f\0\x0f\0\x0f\0\x0f\0\x0f\0\x0f\0\x0f\0\x10\0\x10\0\xff\xff\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\xff\xff\xff\xff\xff\xff\xff\xff\x10\0\x1b\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0!\0!\0\xff\xff\xff\xff!\0\x1c\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff!\0\xff\xff!\0\xff\xff\xff\xff\xff\xff\xff\xff!\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff!\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff!\0\xff\xff\xff\xff!\0!\0\xff\xff\xff\xff!\0!\0!\0!\0!\0!\0!\0!\0!\0!\0!\0!\0!\0!\0!\0!\0!\0!\0!\0!\0!\0!\0!\0!\0!\0!\0\xff\xff\xff\xff\xff\xff\xff\xff!\0\xff\xff!\0!\0!\0!\0!\0!\0!\0!\0!\0!\0!\0!\0!\0!\0!\0!\0!\0!\0!\0!\0!\0!\0!\0!\0!\0!\0#\0#\0\xff\xff\xff\xff#\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff'\0'\0\xff\xff\xff\xff'\0#\0\xff\xff#\0\xff\xff\xff\xff\xff\xff\xff\xff#\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff'\0\xff\xff'\0\xff\xff\xff\xff\xff\xff\xff\xff'\0\xff\xff\xff\xff\xff\xff#\0#\0'\0'\0\xff\xff'\0'\0'\0'\0'\0'\0'\0'\0'\0'\0'\0\xff\xff\xff\xff'\0'\0\xff\xff\xff\xff'\0'\0'\0'\0'\0'\0'\0'\0'\0'\0'\0'\0'\0'\0'\0'\0'\0'\0'\0'\0'\0'\0'\0'\0'\0'\0\xff\xff\xff\xff\xff\xff\xff\xff'\0\xff\xff'\0'\0'\0'\0'\0'\0'\0'\0'\0'\0'\0'\0'\0'\0'\0'\0'\0'\0'\0'\0'\0'\0'\0'\0'\0'\0\xff\xff!\0)\0)\0\xff\xff\xff\xff)\0\xff\xff,\0,\0\xff\xff\xff\xff,\0\xff\xff.\0.\0\xff\xff\xff\xff.\0\xff\xff2\x002\0\xff\xff\xff\xff2\0)\0\xff\xff)\0\xff\xff\xff\xff\xff\xff,\0)\0,\0\xff\xff\xff\xff\xff\xff.\0,\0.\0\xff\xff\xff\xff\xff\xff2\0.\x002\0,\0\xff\xff\xff\xff\xff\xff2\0\xff\xff\xff\xff\xff\xff)\0)\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff,\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff.\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff2\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff#\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff'\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff)\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff,\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff.\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff2\0"),a(d),a(d),a(d),a(d),a(d),a(d)],gI=bH([a(a1),a(bT),a(bU),a(dD),a(cI),a(b1),a(cE),a(a6),a(b4),a(cx),a(a5),a(bA),a(cp),a(cH),a(cr),a(cC),a(cm),a(cD),a(cs),a(cB),a(_),a(V),a(by),a(dG)]),xo=[0,a(cL),[0,a(dJ),0]],xp=[0,a(bA),[0,a(b4),[0,a(dT),0]]],hb=bH([a(a1),a(bT),a(bU),a(dD),a(cI),a(b1),a(cE),a(a6),a(b4),a(cx),a(a5),a(bA),a(cp),a(cH),a(cr),a(cC),a(cm),a(cD),a(cs),a(cB),a(_),a(V),a(by),a(dG)]),xq=[0,a(dJ),0],xr=[0,a(bA),[0,a(b4),[0,a(dT),0]]],hf=a("o:spid"),hg=a("id"),dp=[0,a(hI)];aA(11,f8,hJ);aA(10,t,iJ);aA(9,[A,a(ii),-10],ii);aA(8,f6,iw);aA(7,f5,h9);aA(6,q,it);aA(5,[A,a(iC),-6],iC);aA(4,[A,a(h2),-5],h2);aA(3,ea,ip);aA(2,c0,e_);aA(1,f7,hX);aA(0,eb,iS);var
  jz=a("%.12g"),jy=a(bm),jv=a(dN),jw=a("false"),jA=a("CamlinternalLazy.Undefined"),jE=a("\\\\"),jF=a("\\'"),jG=a("\\b"),jH=a("\\t"),jI=a("\\n"),jJ=a("\\r"),jD=a("Char.chr"),jN=a("nth"),jO=a("List.nth"),jM=a("tl"),jT=a("String.blit / Bytes.blit_string"),jS=a("Bytes.blit"),jR=a("String.sub / Bytes.sub"),jY=a("String.contains_from / Bytes.contains_from"),jW=a(d),jV=a(d),jU=a("String.concat"),j1=a("Array.blit"),j6=a("Set.remove_min_elt"),j7=[0,0,0,0],j8=[0,0,0],j9=[0,a("set.ml"),570,18],j2=a(dw),j3=a(dw),j4=a(dw),j5=a(dw),kc=a("Map.remove_min_elt"),kd=[0,0,0,0],ke=[0,a("map.ml"),400,10],kf=[0,0,0],j_=a(dM),j$=a(dM),ka=a(dM),kb=a(dM),kg=a("Stdlib.Stack.Empty"),kk=a("Buffer.add: cannot grow buffer"),kj=[0,a(iz),93,2],ki=[0,a(iz),94,2],kt=a("%c"),ku=a("%s"),kv=a(hH),kw=a(h7),kx=a(im),ky=a(hM),kz=a("%f"),kA=a("%B"),kB=a("%{"),kC=a("%}"),kD=a("%("),kE=a("%)"),kF=a("%a"),kG=a("%t"),kH=a("%?"),kI=a("%r"),kJ=a("%_r"),kK=[0,a(M),850,23],kV=[0,a(M),814,21],kN=[0,a(M),815,21],kW=[0,a(M),818,21],kO=[0,a(M),819,21],kX=[0,a(M),822,19],kP=[0,a(M),823,19],kY=[0,a(M),826,22],kQ=[0,a(M),827,22],kZ=[0,a(M),831,30],kR=[0,a(M),832,30],kT=[0,a(M),836,26],kL=[0,a(M),837,26],kU=[0,a(M),846,28],kM=[0,a(M),847,28],kS=[0,a(M),851,23],l2=a(ig),l0=[0,a(M),1558,4],l1=a("Printf: bad conversion %["),l3=[0,a(M),1626,39],l4=[0,a(M),1649,31],l5=[0,a(M),1650,31],l6=a("Printf: bad conversion %_"),l7=a(ie),l8=a(io),l9=a(ie),l_=a(io),lY=a(ff),lW=a("neg_infinity"),lX=a(iQ),lV=a(bm),lQ=[0,hT],lE=a("%+nd"),lF=a("% nd"),lH=a("%+ni"),lI=a("% ni"),lJ=a("%nx"),lK=a("%#nx"),lL=a("%nX"),lM=a("%#nX"),lN=a("%no"),lO=a("%#no"),lD=a("%nd"),lG=a(im),lP=a("%nu"),lr=a("%+ld"),ls=a("% ld"),lu=a("%+li"),lv=a("% li"),lw=a("%lx"),lx=a("%#lx"),ly=a("%lX"),lz=a("%#lX"),lA=a("%lo"),lB=a("%#lo"),lq=a("%ld"),lt=a(h7),lC=a("%lu"),le=a("%+Ld"),lf=a("% Ld"),lh=a("%+Li"),li=a("% Li"),lj=a("%Lx"),lk=a("%#Lx"),ll=a("%LX"),lm=a("%#LX"),ln=a("%Lo"),lo=a("%#Lo"),ld=a("%Ld"),lg=a(hM),lp=a("%Lu"),k3=a("%+d"),k4=a("% d"),k6=a("%+i"),k7=a("% i"),k8=a("%x"),k9=a("%#x"),k_=a("%X"),k$=a("%#X"),la=a("%o"),lb=a("%#o"),k2=a(fv),k5=a(hH),lc=a(ig),kl=a("@]"),km=a("@}"),kn=a("@?"),ko=a("@\n"),kp=a("@."),kq=a("@@"),kr=a("@%"),ks=a(dV),k0=a("CamlinternalFormat.Type_mismatch"),mc=a(d),md=[0,[11,a(co),[2,0,[2,0,0]]],a(", %s%s")],mC=[0,[11,a(fo),[2,0,[12,10,0]]],a(iI)],mD=[0,[11,a("Fatal error in uncaught exception handler: exception "),[2,0,[12,10,0]]],a("Fatal error in uncaught exception handler: exception %s\n")],mB=a("Fatal error: out of memory in uncaught exception handler"),mz=[0,[11,a(fo),[2,0,[12,10,0]]],a(iI)],mv=[0,[2,0,[12,10,0]],a("%s\n")],mn=a("Raised at"),mo=a("Re-raised at"),mp=a("Raised by primitive operation at"),mq=a("Called from"),mr=a(" (inlined)"),mt=a(d),ms=[0,[2,0,[12,32,[2,0,[11,a(' in file "'),[2,0,[12,34,[2,0,[11,a(", line "),[4,0,0,0,[11,a(ic),xn]]]]]]]]]],a('%s %s in file "%s"%s, line %d, characters %d-%d')],mu=[0,[2,0,[11,a(" unknown location"),0]],a("%s unknown location")],mi=a("Out of memory"),mj=a("Stack overflow"),mk=a("Pattern matching failed"),ml=a("Assertion failed"),mm=a("Undefined recursive module"),me=[0,[12,40,[2,0,[2,0,[12,41,0]]]],a("(%s%s)")],mf=a(d),mg=a(d),mh=[0,[12,40,[2,0,[12,41,0]]],a("(%s)")],mb=[0,[4,0,0,0,0],a(fv)],l$=[0,[3,0,0],a("%S")],ma=a(iq),mw=[0,a(d),a("(Cannot print locations:\n bytecode executable program file not found)"),a("(Cannot print locations:\n bytecode executable program file appears to be corrupt)"),a("(Cannot print locations:\n bytecode executable program file has wrong magic number)"),a("(Cannot print locations:\n bytecode executable program file cannot be opened;\n -- too many open files. Try running with OCAMLRUNPARAM=b=2)")],mE=a("x"),mH=a("Hashtbl: unsupported hash table format"),xl=a("OCAMLRUNPARAM"),xj=a("CAMLRUNPARAM"),mF=a(d),mR=a(d),mW=a(d),mV=a(d),mT=a(d),m1=[2,a(fy)],m2=[2,a(fy)],oQ=a(d),oR=a(d),ph=a(ac),pi=a('="'),pj=a(bz),pd=a(a7),pe=a(bt),pf=a(fp),pp=a("<?"),pq=a(W),pr=a(cJ),ps=a("<!--"),pt=a(W),pu=a("-->"),pv=a("<!"),pw=a(W),px=a(cJ),pg=a(fy),pk=a("/>"),pl=a(cJ),pm=a(cJ),pn=a(iB),po=a(cJ),pc=a("&quot;"),py=a("write"),o4=a(d),o5=a(iB),o6=a(W),o7=a(bt),o8=a(W),o9=a(a7),o_=a(W),o$=a(fp),pa=a(d),o0=[0,0,0],o1=[0,0,1],o2=[0,0,0],o3=[0,0,1],oZ=[0,a("netstring/code/src/netstring/nethtml.ml"),356,27],oY=a(d),oV=a(d),oW=[0,bu,e3],oX=[0,bu,e3],oU=a(d),oP=a(d),m3=a("Nethtml.End_of_scan"),m4=a("Nethtml.Found"),m5=[0,[0,a(b2),[0,j,[0,k,[0,a(b2),[0,a(dU),[0,a(b1),0]]]]]],[0,[0,a(dU),[0,j,v]],0]],m6=bH([k,a(a4),a(b5),a(bZ),a(ak),a(ao),a(bh),a(bw),a(bk),a(a3),a(b2)]),m7=a(cF),m8=[0,a(ao),[0,j,b3]],m9=[0,a(bh),[0,j,v]],m_=[0,a(bZ),[0,j,v]],m$=[0,a(b5),[0,j,[0,k,0]]],na=[0,a(a4),[0,j,[0,k,[0,a(b5),[0,a(bZ),[0,a(ak),[0,a(ao),[0,a(bh),[0,a(bw),[0,a(bk),0]]]]]]]]]],nb=[0,a(bC),[0,j,i]],nc=[0,a(cM),[0,j,i]],nd=[0,a(an),[0,j,[0,k,[0,a(cM),[0,a(bC),0]]]]],ne=[0,a(bl),[0,j,v]],nf=[0,a(dP),[0,j,[0,k,[0,a(bl),0]]]],ng=[0,a(cA),[0,j,[0,k,[0,a(an),0]]]],nh=[0,a(cu),[0,j,[0,k,[0,a(an),0]]]],ni=[0,a(cq),[0,j,[0,k,[0,a(an),0]]]],nj=[0,a(dZ),[0,j,c]],nk=[0,a(dF),[0,j,c]],nl=[0,a(bY),[0,j,[0,k,0]]],nm=[0,a(dQ),[0,j,[0,k,[0,a(bY),0]]]],nn=[0,a($),[0,j,i]],no=[0,a(cz),[0,j,i]],np=[0,a(dB),[0,j,c]],nq=[0,a(fl),[0,bu,i]],nr=[0,a(e0),[0,bu,i]],ns=[0,a(bV),[0,j,v]],nt=[0,a(bw),[0,j,v]],nu=[0,a(dA),[0,j,v]],nw=[0,k,[0,a(ak),0]],nx=a(a3),ny=[0,a(b4),[0,n,v]],nz=[0,a(b1),[0,n,i]],nA=[0,a(dD),[0,n,i]],nB=[0,a(cp),[0,n,c]],nD=[0,k,[0,a(dF),0]],nE=a(bA),nF=[0,a(a5),[0,n,[0,k,[0,a(dZ),[0,a(bl),[0,a(dP),[0,a(cq),[0,a(cA),[0,a(cu),[0,a(an),0]]]]]]]]]],nG=[0,a(cx),[0,n,v]],nI=[0,k,[0,a(ak),0]],nJ=[0,a(a6),0],nK=a(a6),nM=[0,k,[0,a(ak),0]],nN=a(cE),nO=[0,a(cI),[0,n,i]],nP=[0,a(bU),[0,n,i]],nQ=[0,a(bT),[0,n,[0,k,[0,a(dB),[0,a(cz),0]]]]],nR=[0,a(cB),[0,n,[0,R,[0,[0,a(aK),[0,a(bk),[0,a(dE),[0,a(dX),[0,a(dH),[0,a(cG),[0,a(cy),xo]]]]]]],c]]]],nS=[0,k,[0,a($),0]],nT=a(dG),nU=[0,k,[0,a($),0]],nV=a(by),nW=[0,a(V),[0,n,[0,k,[0,a($),0]]]],nX=[0,a(_),[0,n,[0,k,[0,a($),0]]]],nY=[0,a(cs),[0,n,c]],nZ=[0,a(cD),[0,n,c]],n0=[0,a(cm),[0,n,c]],n1=[0,a(cC),[0,n,c]],n2=[0,a(cr),[0,n,c]],n3=[0,a(cH),[0,n,c]],n4=[0,a(a1),[0,n,c]],n5=[0,a(dY),[0,c,[0,R,[0,[0,a(bv),[0,a(dz),[0,a(dK),[0,a(dv),[0,a(bX),[0,a(dY),[0,a(a6),xp]]]]]]],i]]]],n6=[0,a(bX),[0,c,[0,R,[0,[0,a(bX),0],c]]]],n7=[0,a(dv),[0,c,[0,k,0]]],n8=[0,a(dK),[0,c,[0,k,[0,a(dQ),[0,a(bY),0]]]]],n9=[0,a(dz),[0,c,v]],n_=[0,a(dT),[0,c,i]],n$=[0,a(dJ),[0,c,v]],oa=[0,a(cL),[0,c,c]],oc=[0,k,[0,a(bV),0]],od=a(dE),oe=[0,a(iY),[0,c,c]],og=[0,k,[0,a(dA),0]],oh=a(iN),oi=[0,a(ak),[0,c,b3]],ok=[0,k,[0,a(bV),0]],ol=a(bk),om=[0,a(aK),[0,c,v]],on=[0,a(bv),[0,c,[0,R,[0,[0,a(bv),0],c]]]],oo=[0,a(ix),[0,c,v]],op=[0,a(hO),[0,c,c]],oq=[0,a(bR),[0,c,c]],or=[0,a(cG),[0,c,c]],os=[0,a(cy),[0,c,c]],ot=[0,a(fm),[0,c,c]],ou=[0,a(ij),[0,c,c]],ov=[0,a(e6),[0,c,c]],ow=[0,a(fH),[0,c,c]],ox=[0,a(e5),[0,c,c]],oy=[0,a(fJ),[0,c,c]],oz=[0,a(e9),[0,c,c]],oA=[0,a(e8),[0,c,c]],oB=[0,a(fh),[0,c,c]],oC=[0,a(fF),[0,c,c]],oD=[0,a(ik),[0,c,c]],oE=[0,a(fe),[0,c,c]],oF=[0,a(e4),[0,c,c]],oG=[0,a(dH),[0,c,c]],oH=[0,a(dX),[0,c,c]],oI=[0,a(fB),[0,c,c]],oJ=[0,a(fK),[0,c,c]],oK=[0,a(fz),[0,c,c]],oN=[0,a(a3),[0,a(a5),[0,a(V),[0,a(_),[0,a(bT),0]]]]],pB=[0,0,0],pF=a(d),pE=a(d),pD=a(d),pC=a(d),pL=a(ac),pJ=a("' is invalid"),pK=a("document list level '"),pG=a("\xef\x82\xb7"),pH=a("\xef\x82\xa7"),pI=a("o"),pS=a(cF),pV=[0,a("src/main/re/html/htmlStd.re"),138,9],pM=a(W),pN=a(fk),pO=bH([a(cp),a("article"),a("aside"),a("audio"),a(cE),a("canvas"),a(cz),a(bU),a(bT),a(bA),a("figcaption"),a("figure"),a("footer"),a(a6),a(cH),a(cr),a(cC),a(cm),a(cD),a(cs),a("header"),a("hgroup"),a(cx),a($),a(cI),a(V),a("output"),a(a1),a(cB),a("section"),a(a5),a(cu),a(bC),a(cA),a(cM),a(cq),a(an),a(_),a("video")]),pP=[0,a(a3),[0,a(a4),[0,a(cF),[0,a(bw),[0,a(bh),[0,a(ao),[0,a(e1),0]]]]]]],pT=[0,a(d)],p8=a(a1),p6=a(iG),p5=a(il),p7=[0,a(iG)],p3=a(il),p1=a(aK),pX=a(h_),pY=a(h_),pZ=a("file:"),p0=a("data-image-src"),qI=a(ac),qH=a(bf),qE=a(":level"),qC=a(ac),qv=a(e$),qw=a(fG),qx=a(e$),qy=a(fG),qz=a(dV),qA=a(e$),qB=a(fG),qD=a(d),qF=a(d),qG=a("@list "),qt=a(co),qr=[0,a("\n  ")],qs=a("  "),qq=a(d),qo=a("color"),qp=a(ac),ql=a('""'),qm=a(";"),qn=a(bx),qb=a(dR),qc=a(d),qd=a(a7),qe=a(ac),qf=a(d),qa=[0,a(d),0],qg=a(d),qh=a(co),p_=a(bz),p$=a(bz),qi=[0,a("font-family"),0],qW=a("Internal failure -- please contact the parser generator's developers.\n%!"),qX=[0,a("src/main/re/css_parser.ml"),494,4],qV=a(dR),qU=a(bx),qT=a(dV),qS=a(dR),qR=a(bx),qQ=a(dV),qN=a("list"),qP=a(bx),qO=a(d),qL=a(dR),qM=a(d),qK=[0,a(d),0],qJ=a("Css_parser.MenhirBasics.Error"),q4=a(fg),q5=a("' ("),q6=a("Unexpected char: '"),q1=a("Css_lexer.SyntaxError"),q2=[0,a('\0\0\xeb\xff\x14\0\x03\0\x01\0\xd7\0\x0e\0H\x01\x9d\0\xf1\xff\x03\0\x06\0\x11\0u\x01\xe8\x01B\x02\x9c\x02\xf6\x02\x02\0\x1e\0\xf7\xff\xf8\xff\xf9\xff\xfa\xff\xfb\xff\xfc\xff\b\0\x01\0\xfe\xff\xff\xff\xf6\xff\xf5\xff\x12\0P\x03\xaa\x03|\0\xf4\xff\x04\x04^\x04\xc8\x01\x90\x04\x13\0\xbd\x04\xed\xff0\x05\x15\0\x16\0\x17\0\xf0\xff2\x052\x001\x054\0\x0b\0\x12\0\x0e\0"\0\xa1\x05\xa2\x055\0\xa3\x05\xa7\x05\xa8\x05\xa9\x05\xad\x051\x003\0\xee\xffY\0Z\0\xec\xff\\\0]\0'),a("\xff\xff\xff\xff\x14\0\x14\0\x14\0\x10\0\x14\0\x14\0\x14\0\xff\xff\x14\0\x14\0\x14\0\x10\0\r\0\x10\0\x10\0\x10\0\x14\0\x14\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\x02\0\x01\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\x10\0\x10\0\xff\xff\xff\xff\x10\0\x10\0\xff\xff\f\0\xff\xff\x10\0\xff\xff\r\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\x0f\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff"),a("\x01\0\0\0\xff\xff\xff\xff\x05\0\xff\xff\xff\xff3\x001\0\0\0.\0-\0\t\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\0\0\0\0\0\0\0\0\0\0\0\0\xff\xff\xff\xff\0\0\0\0\0\0\0\0\x05\0\xff\xff\xff\xff\xff\xff\0\0\xff\xff\xff\xff'\0'\0'\0\xff\xff\0\0\xff\xff\t\0/\0\t\0\0\x001\x001\x003\x003\0\xff\xff\xff\xff\xff\xff\xff\xff9\x009\x009\x009\x009\x009\x009\x009\0\xff\xff\xff\xff\0\0D\0G\0\0\0G\0G\0"),a("\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x1a\0\x1c\0\x1c\0\0\0\x1b\0\0\0\0\0\0\0\x1a\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x1a\0\x05\0\b\0\x05\0A\0\x05\0\x06\0\x07\0\x1a\0\0\0\t\0\x05\0\x19\0\x0f\0\r\0\x02\0\x0e\0\x0e\0\x0e\0\x0e\0\x0e\0\x0e\0\x0e\0\x0e\0\x0e\0\x0e\0\x15\0\x16\0\x03\0\x05\0D\0\x1f\0\x14\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x1e\0\x04\x009\0B\0\x05\0C\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x11\0\x05\0\x05\0\x10\0\x05\0\x05\0\x05\0\x05\0\x05\0\x18\0\x12\0\x17\0\x13\x005\x006\x007\x008\0E\0E\0#\0H\0H\0\0\0F\0\0\0\0\0F\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0#\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0$\0\0\0\xff\xff#\0\0\0\xff\xff\0\0#\0#\0#\0#\0#\0#\0#\0#\0#\0#\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x000\0\f\0\f\0\f\0\f\0\f\0\f\0\f\0\f\0\f\0\f\0\f\0\f\0\f\0\f\0\f\0\f\0\f\0\f\0\f\0\f\0\f\0\f\0\f\0\f\0\f\0\f\0\f\0\f\0\f\0\f\0\f\0\f\0\x0b\0\x0b\0\x0b\0\x0b\0\x0b\0\x0b\0\x0b\0\x0b\0\x0b\0\x0b\0\x0b\0\x0b\0\x0b\0\x0b\0\x0b\0\x0b\0\n\0\n\0\n\0\n\0\n\0\n\0\n\0\n\0\x05\x002\0\x05\0\0\0\x05\0\0\0\0\0\0\0\x1d\0\xff\xff\x05\0\xff\xff\x05\0\x05\0\xff\xff\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\xff\xff\xff\xff\xff\xff\x05\0\xff\xff\xff\xff\xff\xff\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\xff\xff \0\xff\xff\xff\xff\x05\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\xff\xff\0\0\0\0\xff\xff\0\0\0\0\0\0\xff\xff\xff\xff\0\0\xff\xff\xff\xff\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x000\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x05\0\0\0\x05\0\0\0\x05\0\0\0\0\0\xff\xff\0\0\0\0\x05\0\0\0\x05\0\x05\x004\0,\0,\0,\0,\0,\0,\0,\0,\0,\0,\0\0\0\0\0\0\0\x05\0\0\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0 \0\xff\xff\0\0\x05\0\xff\xff\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0(\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x05\0\0\0\x05\0\0\0\x05\0\0\0\0\0\0\0\0\0\0\0\x05\0\0\0\x05\0\r\0\0\0\x0e\0\x0e\0\x0e\0\x0e\0\x0e\0\x0e\0\x0e\0\x0e\0\x0e\0\x0e\0\0\0\0\0)\0\x05\0\0\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0 \0\0\0\0\0\x05\0\xff\xff\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\x05\0\0\0\x05\0\0\0\0\0\0\0\0\0\0\0\x05\0\0\0*\0\r\0\0\0\x0e\0\x0e\0\x0e\0\x0e\0\x0e\0\x0e\0\x0e\0\x0e\0\x0e\0\x0e\0\0\0\0\0\0\0\x05\0\0\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0 \0\0\0\0\0\x05\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\x05\0\0\0\x05\0\0\0\0\0\0\0\0\0\0\0\x05\0\xff\xff\x05\0\x05\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\x05\0\0\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0 \0\0\0\0\0\x05\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0%\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\x05\0\0\0\x05\0\0\0\0\0\0\0\0\0\0\0\x05\0\0\0\x05\0\x05\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\x05\0\0\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0 \0\0\0\0\0\x05\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0!\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\x05\0\0\0\x05\0\0\0\0\0\0\0\0\0\0\0\x05\0\0\0\x05\0\x05\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\x05\0\0\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0 \0\0\0\0\0\x05\0\0\0\x05\0\"\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\x05\0\0\0\x05\0\0\0\0\0#\0\0\0\0\0\x05\0\0\0\x05\0\x05\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\x05\0\0\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0 \0\0\0\0\0\x05\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\x05\0\0\0\x05\0\0\0\0\0\0\0\0\0\0\0\x05\0\0\0\x05\0\x05\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\x05\0\0\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0 \0\0\0\0\0\x05\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0&\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\x05\0\0\0\x05\0\0\0\0\0'\0\0\0\0\0\x05\0\0\0\x05\0\x05\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\xff\xff\x05\0\0\0\xff\xff\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0(\0 \0\0\0\0\0\x05\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\0\0\x05\0\0\0\x05\0\0\0\x05\0\0\0\0\0\0\0\0\0\0\0\x05\0\0\0\x05\0\x05\0)\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\x05\0+\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0 \0\0\0\0\0\x05\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\xff\xff\xff\xff\0\0\xff\xff\xff\xff\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x05\0\0\0\x05\x000\0\x05\0\0\0\0\x000\0\0\0\0\0\x05\0\0\0\x05\0\x05\0\0\0,\0,\0,\0,\0,\0,\0,\0,\0,\0,\0\0\0\0\0\0\0\x05\0\0\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0 \x004\x002\0\x05\0\xff\xff\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\0\0\0\0\xff\xff\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0:\0:\0:\0\0\0\0\0\0\0:\0:\0:\0\0\0\0\0\0\0:\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0@\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0;\0;\0;\0\0\0\0\0\0\0;\0;\0;\0\0\0\0\0\0\0;\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0<\0\0\0\0\0>\0\0\0=\0\0\0\0\0\0\0?\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\xff\xff\xff\xff\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\xff\xff\xff\xff\xff\xff\0\0\0\0\0\0\xff\xff\xff\xff\xff\xff\0\0\0\0\0\0\xff\xff"),a('\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\0\0\0\0\x1b\0\xff\xff\0\0\xff\xff\xff\xff\xff\xff\x1a\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\0\0\0\0\0\0\0\0\x03\0\0\0\0\0\0\0\x1a\0\xff\xff\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x02\0\x12\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x13\0\0\x008\0A\0\0\0B\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x06\x005\x006\x007\0D\0E\0#\0G\0H\0\xff\xffE\0\xff\xff\xff\xffH\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff#\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff#\0\xff\xff\b\0#\0\xff\xff\b\0\xff\xff#\0#\0#\0#\0#\0#\0#\0#\0#\0#\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\b\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x05\0\b\0\x05\0\xff\xff\x05\0\xff\xff\xff\xff\xff\xff\0\0\x04\0\x05\0\n\0\x05\0\x05\0\x0b\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\f\0 \0)\0\x05\0-\0.\0/\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\x002\0\x05\x004\0;\0\x05\0\xff\xff\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x07\0\xff\xff\xff\xff\x07\0\xff\xff\xff\xff\xff\xffD\0E\0\xff\xffG\0H\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\x07\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\r\0\xff\xff\r\0\xff\xff\r\0\xff\xff\xff\xff\b\0\xff\xff\xff\xff\r\0\xff\xff\r\0\r\0\x07\0\r\0\r\0\r\0\r\0\r\0\r\0\r\0\r\0\r\0\r\0\xff\xff\xff\xff\xff\xff\r\0\xff\xff\xff\xff\xff\xff\r\0\r\0\r\0\r\0\r\0\r\0\r\0\r\0\r\0\r\0\r\0\r\0\r\0\r\0\r\0\r\0\r\0\r\0\r\0\r\0\r\0\r\0\r\0\r\0\r\0\r\0\xff\xff\r\0\'\0\xff\xff\r\0\'\0\r\0\r\0\r\0\r\0\r\0\r\0\r\0\r\0\r\0\r\0\r\0\r\0\r\0\r\0\r\0\r\0\r\0\r\0\r\0\r\0\r\0\r\0\r\0\r\0\r\0\r\0\xff\xff\'\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\x0e\0\xff\xff\x0e\0\xff\xff\x0e\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\x0e\0\xff\xff\x0e\0\x0e\0\xff\xff\x0e\0\x0e\0\x0e\0\x0e\0\x0e\0\x0e\0\x0e\0\x0e\0\x0e\0\x0e\0\xff\xff\xff\xff\'\0\x0e\0\xff\xff\xff\xff\xff\xff\x0e\0\x0e\0\x0e\0\x0e\0\x0e\0\x0e\0\x0e\0\x0e\0\x0e\0\x0e\0\x0e\0\x0e\0\x0e\0\x0e\0\x0e\0\x0e\0\x0e\0\x0e\0\x0e\0\x0e\0\x0e\0\x0e\0\x0e\0\x0e\0\x0e\0\x0e\0\xff\xff\x0e\0\xff\xff\xff\xff\x0e\0\x07\0\x0e\0\x0e\0\x0e\0\x0e\0\x0e\0\x0e\0\x0e\0\x0e\0\x0e\0\x0e\0\x0e\0\x0e\0\x0e\0\x0e\0\x0e\0\x0e\0\x0e\0\x0e\0\x0e\0\x0e\0\x0e\0\x0e\0\x0e\0\x0e\0\x0e\0\x0e\0\x0f\0\xff\xff\x0f\0\xff\xff\x0f\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\x0f\0\xff\xff\x0f\0\x0f\0\xff\xff\x0f\0\x0f\0\x0f\0\x0f\0\x0f\0\x0f\0\x0f\0\x0f\0\x0f\0\x0f\0\xff\xff\xff\xff\xff\xff\x0f\0\xff\xff\xff\xff\xff\xff\x0f\0\x0f\0\x0f\0\x0f\0\x0f\0\x0f\0\x0f\0\x0f\0\x0f\0\x0f\0\x0f\0\x0f\0\x0f\0\x0f\0\x0f\0\x0f\0\x0f\0\x0f\0\x0f\0\x0f\0\x0f\0\x0f\0\x0f\0\x0f\0\x0f\0\x0f\0\xff\xff\x0f\0\xff\xff\xff\xff\x0f\0\xff\xff\x0f\0\x0f\0\x0f\0\x0f\0\x0f\0\x0f\0\x0f\0\x0f\0\x0f\0\x0f\0\x0f\0\x0f\0\x0f\0\x0f\0\x0f\0\x0f\0\x0f\0\x0f\0\x0f\0\x0f\0\x0f\0\x0f\0\x0f\0\x0f\0\x0f\0\x0f\0\x10\0\xff\xff\x10\0\xff\xff\x10\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\x10\0\'\0\x10\0\x10\0\xff\xff\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\xff\xff\xff\xff\xff\xff\x10\0\xff\xff\xff\xff\xff\xff\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\xff\xff\x10\0\xff\xff\xff\xff\x10\0\xff\xff\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x11\0\xff\xff\x11\0\xff\xff\x11\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\x11\0\xff\xff\x11\0\x11\0\xff\xff\x11\0\x11\0\x11\0\x11\0\x11\0\x11\0\x11\0\x11\0\x11\0\x11\0\xff\xff\xff\xff\xff\xff\x11\0\xff\xff\xff\xff\xff\xff\x11\0\x11\0\x11\0\x11\0\x11\0\x11\0\x11\0\x11\0\x11\0\x11\0\x11\0\x11\0\x11\0\x11\0\x11\0\x11\0\x11\0\x11\0\x11\0\x11\0\x11\0\x11\0\x11\0\x11\0\x11\0\x11\0\xff\xff\x11\0\xff\xff\xff\xff\x11\0\xff\xff\x11\0\x11\0\x11\0\x11\0\x11\0\x11\0\x11\0\x11\0\x11\0\x11\0\x11\0\x11\0\x11\0\x11\0\x11\0\x11\0\x11\0\x11\0\x11\0\x11\0\x11\0\x11\0\x11\0\x11\0\x11\0\x11\0!\0\xff\xff!\0\xff\xff!\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff!\0\xff\xff!\0!\0\xff\xff!\0!\0!\0!\0!\0!\0!\0!\0!\0!\0\xff\xff\xff\xff\xff\xff!\0\xff\xff\xff\xff\xff\xff!\0!\0!\0!\0!\0!\0!\0!\0!\0!\0!\0!\0!\0!\0!\0!\0!\0!\0!\0!\0!\0!\0!\0!\0!\0!\0\xff\xff!\0\xff\xff\xff\xff!\0\xff\xff!\0!\0!\0!\0!\0!\0!\0!\0!\0!\0!\0!\0!\0!\0!\0!\0!\0!\0!\0!\0!\0!\0!\0!\0!\0!\0"\0\xff\xff"\0\xff\xff"\0\xff\xff\xff\xff"\0\xff\xff\xff\xff"\0\xff\xff"\0"\0\xff\xff"\0"\0"\0"\0"\0"\0"\0"\0"\0"\0\xff\xff\xff\xff\xff\xff"\0\xff\xff\xff\xff\xff\xff"\0"\0"\0"\0"\0"\0"\0"\0"\0"\0"\0"\0"\0"\0"\0"\0"\0"\0"\0"\0"\0"\0"\0"\0"\0"\0\xff\xff"\0\xff\xff\xff\xff"\0\xff\xff"\0"\0"\0"\0"\0"\0"\0"\0"\0"\0"\0"\0"\0"\0"\0"\0"\0"\0"\0"\0"\0"\0"\0"\0"\0"\0%\0\xff\xff%\0\xff\xff%\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff%\0\xff\xff%\0%\0\xff\xff%\0%\0%\0%\0%\0%\0%\0%\0%\0%\0\xff\xff\xff\xff\xff\xff%\0\xff\xff\xff\xff\xff\xff%\0%\0%\0%\0%\0%\0%\0%\0%\0%\0%\0%\0%\0%\0%\0%\0%\0%\0%\0%\0%\0%\0%\0%\0%\0%\0\xff\xff%\0\xff\xff\xff\xff%\0\xff\xff%\0%\0%\0%\0%\0%\0%\0%\0%\0%\0%\0%\0%\0%\0%\0%\0%\0%\0%\0%\0%\0%\0%\0%\0%\0%\0&\0\xff\xff&\0\xff\xff&\0\xff\xff\xff\xff&\0\xff\xff\xff\xff&\0\xff\xff&\0&\0\xff\xff&\0&\0&\0&\0&\0&\0&\0&\0&\0&\0\xff\xff\xff\xff(\0&\0\xff\xff(\0\xff\xff&\0&\0&\0&\0&\0&\0&\0&\0&\0&\0&\0&\0&\0&\0&\0&\0&\0&\0&\0&\0&\0&\0&\0&\0&\0&\0(\0&\0\xff\xff\xff\xff&\0\xff\xff&\0&\0&\0&\0&\0&\0&\0&\0&\0&\0&\0&\0&\0&\0&\0&\0&\0&\0&\0&\0&\0&\0&\0&\0&\0&\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff*\0\xff\xff*\0\xff\xff*\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff*\0\xff\xff*\0*\0(\0*\0*\0*\0*\0*\0*\0*\0*\0*\0*\0\xff\xff\xff\xff\xff\xff*\0*\0\xff\xff\xff\xff*\0*\0*\0*\0*\0*\0*\0*\0*\0*\0*\0*\0*\0*\0*\0*\0*\0*\0*\0*\0*\0*\0*\0*\0*\0*\0\xff\xff*\0\xff\xff\xff\xff*\0\xff\xff*\0*\0*\0*\0*\0*\0*\0*\0*\0*\0*\0*\0*\0*\0*\0*\0*\0*\0*\0*\0*\0*\0*\0*\0*\0*\0\xff\xff\xff\xff\xff\xff3\x001\0\xff\xff3\x001\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff,\0\xff\xff,\x001\0,\0\xff\xff\xff\xff3\0\xff\xff\xff\xff,\0\xff\xff,\0,\0\xff\xff,\0,\0,\0,\0,\0,\0,\0,\0,\0,\0\xff\xff\xff\xff\xff\xff,\0\xff\xff\xff\xff\xff\xff,\0,\0,\0,\0,\0,\0,\0,\0,\0,\0,\0,\0,\0,\0,\0,\0,\0,\0,\0,\0,\0,\0,\0,\0,\0,\0\xff\xff,\x003\x001\0,\0(\0,\0,\0,\0,\0,\0,\0,\0,\0,\0,\0,\0,\0,\0,\0,\0,\0,\0,\0,\0,\0,\0,\0,\0,\0,\0,\x009\0:\0<\x009\0:\0<\0=\0>\0?\0=\0>\0?\0@\0\xff\xff\xff\xff@\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff9\0:\0<\0\xff\xff\xff\xff\xff\xff=\0>\0?\0\xff\xff\xff\xff\xff\xff@\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff?\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff9\0:\0<\0\xff\xff\xff\xff\xff\xff=\0>\0?\0\xff\xff\xff\xff\xff\xff@\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff:\0\xff\xff\xff\xff=\0\xff\xff<\0\xff\xff\xff\xff\xff\xff>\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff3\x001\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff9\0:\0<\0\xff\xff\xff\xff\xff\xff=\0>\0?\0\xff\xff\xff\xff\xff\xff@\0'),a("\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x01\0\x02\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\t\0\x03\0\0\0\x07\0\x04\0\0\0\0\0\0\0\0\0\t\0\x0b\0\x05\0\r\0\x0f\0\x11\0\x13\0\x19\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0"),a("\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\t\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0"),a("\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x06\0\x06\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x06\0\x06\0\x06\0\x06\0\0\0\0\0\0\0\0\0\x06\0\x06\0\x06\0\x06\0\x06\0\x06\0\x06\0\x06\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0"),a("\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x01\0\0\0\0\0\0\0\0\0\x01\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x0e\0\0\0\x11\0\0\0\x11\0\0\0\x11\0\0\0\x11\0\0\0\x11\0\0\0\x01\0\0\0\0\0\0\0\x11\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x0e\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x0e\0\0\0\x0e\0\0\0\0\0\0\0\x0e\0\0\0\0\0\x0e\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0"),a("\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\x07\0\b\x001\0\x07\0\b\x001\x003\0\xff\xff9\x003\0:\x009\0<\0:\0=\0<\0>\0=\0?\0>\0\xff\xff?\0\xff\xff\0\0@\0\b\x001\0@\0\0\0\x07\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff3\x009\0\xff\xff:\0\xff\xff<\0\xff\xff=\0\xff\xff>\0\xff\xff?\0\xff\xff8\0\xff\xff\xff\xff\xff\xff@\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff?\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\x07\0\b\x001\0\xff\xff\xff\xff\xff\xff3\0\xff\xff9\0\xff\xff:\0\xff\xff<\0\xff\xff=\0\xff\xff>\0\xff\xff?\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff@\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff:\0\xff\xff=\0\xff\xff\xff\xff\xff\xff<\0\xff\xff\xff\xff>\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff2\0\x07\0\b\x001\x004\0;\0\xff\xff3\0\xff\xff9\0\xff\xff:\0\xff\xff<\0\xff\xff=\0\xff\xff>\0\xff\xff?\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff@\0"),a("\xff\x03\xff\x02\xff\xff\x03\xff\xff\x01\x02\0\x03\xff\x04\xff\xff\x03\x04\x04\xff\xff")],q$=a(ao),q9=a(iA),q_=a(": syntax error parsing:"),q7=a(bj),q8=a(bx),ra=a(a3),rg=a(bf),rd=a(ao),re=[1,a(bf)],rf=a(bf),rc=a(bf),rb=a(ao),ru=a(d),ro=a(iy),rp=a("='"),rh=a(iy),ri=a("Data '"),rj=a(bf),rk=a(fg),rl=a(bf),rm=a(d),rn=a("]"),rq=a(co),rr=a(", ["),rs=a("Element ("),rt=a(bf),rv=[0,[0,a(b2),[0,j,[0,k,[0,a(b2),[0,a(dU),[0,a(b1),0]]]]]],[0,[0,a(dU),[0,j,v]],0]],rw=bH([k,a(a4),a(b5),a(bZ),a(ak),a(ao),a(bh),a(bw),a(bk),a(a3),a(b2)]),rx=a(cF),ry=[0,a(ao),[0,j,b3]],rz=[0,a(bh),[0,j,v]],rA=[0,a(bZ),[0,j,v]],rB=[0,a(b5),[0,j,[0,k,0]]],rC=[0,a(a4),[0,j,[0,k,[0,a(b5),[0,a(bZ),[0,a(ak),[0,a(ao),[0,a(bh),[0,a(bw),[0,a(bk),0]]]]]]]]]],rD=[0,a(bC),[0,j,i]],rE=[0,a(cM),[0,j,i]],rF=[0,a(an),[0,j,[0,k,[0,a(cM),[0,a(bC),0]]]]],rG=[0,a(bl),[0,j,v]],rH=[0,a(dP),[0,j,[0,k,[0,a(bl),0]]]],rI=[0,a(cA),[0,j,[0,k,[0,a(an),0]]]],rJ=[0,a(cu),[0,j,[0,k,[0,a(an),0]]]],rK=[0,a(cq),[0,j,[0,k,[0,a(an),0]]]],rL=[0,a(dZ),[0,j,c]],rM=[0,a(dF),[0,j,c]],rN=[0,a(bY),[0,j,[0,k,0]]],rO=[0,a(dQ),[0,j,[0,k,[0,a(bY),0]]]],rP=[0,a($),[0,j,i]],rQ=[0,a(cz),[0,j,i]],rR=[0,a(dB),[0,j,c]],rS=[0,a(fl),[0,bu,i]],rT=[0,a(e0),[0,bu,i]],rU=[0,a(bV),[0,j,v]],rV=[0,a(bw),[0,j,v]],rW=[0,a(dA),[0,j,v]],rY=[0,k,[0,a(ak),0]],rZ=a(a3),r0=[0,a(b4),[0,n,v]],r1=[0,a(b1),[0,n,i]],r2=[0,a(dD),[0,n,i]],r3=[0,a(cp),[0,n,c]],r5=[0,k,[0,a(dF),0]],r6=a(bA),r7=[0,a(a5),[0,a2,[0,k,[0,a(dZ),[0,a(bl),[0,a(dP),[0,a(cq),[0,a(cA),[0,a(cu),[0,a(an),0]]]]]]]]]],r8=[0,a(cx),[0,n,v]],r_=[0,k,[0,a(ak),0]],r$=[0,a(a6),0],sa=a(a6),sc=[0,k,[0,a(ak),0]],sd=a(cE),se=[0,a(cI),[0,n,i]],sf=[0,a(bU),[0,n,i]],sg=[0,a(bT),[0,a2,[0,k,[0,a(dB),[0,a(cz),0]]]]],sh=[0,a(cB),[0,n,[0,R,[0,[0,a(bk),[0,a(dE),[0,a(dX),[0,a(dH),[0,a(cG),[0,a(cy),[0,a(cL),xq]]]]]]],c]]]],si=[0,k,[0,a($),0]],sj=a(dG),sk=[0,k,[0,a($),0]],sl=a(by),sm=[0,a(V),[0,a2,[0,k,[0,a($),0]]]],sn=[0,a(_),[0,a2,[0,k,[0,a($),0]]]],so=[0,a(cs),[0,n,c]],sp=[0,a(cD),[0,n,c]],sq=[0,a(cm),[0,n,c]],sr=[0,a(cC),[0,n,c]],ss=[0,a(cr),[0,n,c]],st=[0,a(cH),[0,n,c]],su=[0,a(a1),[0,n,c]],sv=[0,a(dY),[0,c,[0,R,[0,[0,a(bv),[0,a(dz),[0,a(dK),[0,a(dv),[0,a(bX),[0,a(dY),[0,a(a6),xr]]]]]]],i]]]],sw=[0,a(bX),[0,c,[0,R,[0,[0,a(bX),0],c]]]],sx=[0,a(dv),[0,c,[0,k,0]]],sy=[0,a(dK),[0,c,[0,k,[0,a(dQ),[0,a(bY),0]]]]],sz=[0,a(dz),[0,c,v]],sA=[0,a(dT),[0,c,i]],sB=[0,a(dJ),[0,c,v]],sC=[0,a(cL),[0,c,i]],sE=[0,k,[0,a(bV),0]],sF=a(dE),sG=[0,a(iY),[0,c,i]],sI=[0,k,[0,a(dA),0]],sJ=a(iN),sK=[0,a(ak),[0,c,b3]],sM=[0,k,[0,a(bV),0]],sN=a(bk),sO=[0,a(aK),[0,c,v]],sP=[0,a(bv),[0,c,[0,R,[0,[0,a(bv),0],c]]]],sQ=[0,a(ix),[0,c,v]],sR=[0,a(hO),[0,c,i]],sS=[0,a(bR),[0,c,i]],sT=[0,a(cG),[0,c,i]],sU=[0,a(cy),[0,c,i]],sV=[0,a(fm),[0,c,i]],sW=[0,a(ij),[0,c,i]],sX=[0,a(e6),[0,c,i]],sY=[0,a(fH),[0,c,i]],sZ=[0,a(e5),[0,c,i]],s0=[0,a(fJ),[0,c,i]],s1=[0,a(e9),[0,c,i]],s2=[0,a(e8),[0,c,i]],s3=[0,a(fh),[0,c,i]],s4=[0,a(fF),[0,c,i]],s5=[0,a(ik),[0,c,i]],s6=[0,a(fe),[0,c,i]],s7=[0,a(e4),[0,c,i]],s8=[0,a(dH),[0,c,i]],s9=[0,a(dX),[0,c,i]],s_=[0,a(fB),[0,c,i]],s$=[0,a(fK),[0,c,i]],ta=[0,a(fz),[0,c,i]],tr=a(ao),tq=a(a4),to=a(a3),tp=a(cF),tl=a(a4),tm=a(ao),tk=a(ao),th=a(W),ti=a(bt),tj=a(id),tg=a(a4),tf=a(a3),tc=[0,1],td=[0,0],te=[0,1],tn=[1,a(bh),[0,[0,a("http-equiv"),a("Content-Type")],[0,[0,a("content"),a("text/html; charset=utf-8")],0]],0,0],t5=a(W),t6=a(a7),t7=a(W),t8=a("[if !msEquation]"),t9=a(a7),t_=a(W),t$=a(fk),t3=[0,a("data-ms-equation"),a(dN)],tS=a(W),tT=a(a7),tU=a(W),tV=a("[if !vml]"),tW=a(a7),tX=a(W),tY=a(fk),tQ=a(e1),tL=a(aK),tM=a(aK),tK=a(aK),tN=a(aK),tG=a(e1),tE=a("v:imagedata"),tF=a(aK),tC=a("vshapedata"),tz=[0,[0,a("rtf-data-image"),a(dN)],0],tA=a("data-image-id"),tw=a("rotation"),ts=a("-90"),tt=a("90"),tu=a(cw),tv=a(bB),tx=a(cw),ty=a(bB),tB=a("unsupported"),tJ=a(aK),tO=a("[if gte vml 1]>"),tP=a(iO),tZ=a(bt),t1=a("[if gte msEquation"),t2=a(iO),ua=a(bt),uc=[0,0],uf=a(W),ug=a("[if !supportLists]"),uh=a(a7),ui=a(bt),uV=a(hY),uW=a($),uX=a(cn),uZ=[0,a(h1),a(dN)],uY=a($),uS=a(b0),uT=a(bx),uU=a(eZ),u0=a(a1),uQ=a("mso-text-indent-alt"),uR=a(iX),uN=a("mso-level-legacy"),uO=a("yes"),uP=[0,a(_),0,0],uK=a(hU),uL=a(dI),uM=[0,a(dx)],uH=a("margin-top"),uI=a("margin-bottom"),uz=[0,[0,a(_),0]],ut=a("alpha-lower"),uu=a("alpha-upper"),uv=a("bullet"),uw=a("image"),ux=a("roman-lower"),uy=a("roman-upper"),uA=[0,[0,a(V),[0,a("upper-roman")]]],uB=[0,[0,a(V),[0,a("lower-roman")]]],uC=[0,[0,a(V),[0,a("upper-alpha")]]],uD=[0,[0,a(V),[0,a("lower-alpha")]]],uE=a("mso-level-number-format"),uF=[0,a(V),0],uq=[0,[0,a(_),[0,a("square")]]],ur=[0,[0,a(_),[0,a("circle")]]],us=a("mso-level-text"),up=a(ad),uo=a(d0),ul=[0,a(iL)],um=a(_),un=a("mso-level-start-at"),uj=[0,[0,a(dx)],[0,[0,a(dI),0]]],uk=a($),ue=a(iT),vx=[0,1],vy=[0,1],vz=[0,1],vv=a(b0),vr=a(V),vs=a(_),vn=a(_),vo=a(V),vp=a(V),vm=a(b0),vq=a(b0),vj=a(d0),vk=a(fD),vg=a(V),vh=a(_),vf=a($),vb=a(dx),vc=[0,a(dI),0],vd=a(b0),ve=a(b0),u_=a(V),u$=a(_),u6=a($),u7=a(V),u3=a(_),u4=a(fD),u5=a(d0),u8=a(eZ),u9=a(d0),u1=bH([a(cL),a(bR),a(fB),a(fK),a(e4),a(cG),a(cy),a(fF),a(fh),a(fJ),a(fm),a(e6),a(e9),a(e8),a(e5),a(fz),a(fe),a(e0),a(fl),a(fH),a(a4)]),v6=a(bR),v3=a(cn),v4=a(fI),v2=a(fI),v0=a(cn),v1=a(fI),vY=a(cn),vZ=a("Apple-converted-space"),vR=a(W),vN=a(bt),vO=a("---"),vM=a(W),vH=a(id),vI=a("endfragment"),vJ=a("[if "),vK=a("[endif"),vF=a(bv),vD=a("name"),vE=a("OLE_LINK"),vS=a(a7),vU=[0,a("lang"),[0,a("onmouseover"),[0,a("onmouseout"),[0,a(eZ),0]]]],vV=[0,a(cn),[0,a(h1),[0,a(hY),[0,a(iX),0]]]],wi=a(bU),wg=a("mso-element"),wh=[0,a("para-border-div"),0],we=a("border"),wc=a("margin-left"),wd=a("data-border-margin"),wa=a(a1),v8=a(bR),v9=a(by),v_=a(bR),v$=a(by),wC=a("mso-"),wD=a(iT),wp=a("font-stretch"),wq=a("font-variant-caps"),wr=a("text-decoration"),ws=a("text-indent"),wt=a("text-transform"),wu=a("vertical-align"),wv=a("white-space"),ww=a("word-spacing"),wy=a(ih),wz=a("baseline"),wB=a(ih),wA=a(dI),wx=a("0px"),wk=[0,a(iL),[0,a(dx),[0,a(hU),0]]],wm=bH([a("layout-grid-mode"),a("tab-stops"),a(is),a("text-underline"),a("text-effect"),a("text-line-through"),a("page"),a("font-color"),a("horiz-align"),a("language"),a("separator-image"),a("table-border-color-dark"),a("table-border-color-light"),a("vert-align"),a("widows"),a("letter-spacing"),a("caret-color"),a("orphans")]),wF=[0,a(a5),[0,a(an),[0,a(bC),[0,a(bl),0]]]],wU=a(cw),wV=a(bB),wT=[0,a(bC),[0,a(bl),0]],wS=a(an),wQ=a(bB),wR=a(cw),wP=a(a5),wN=a(a5),wM=a(bB),wK=a(bB),wJ=a("px"),wI=[0,a(bB),[0,a(cw),0]],w2=a("before:"),w3=a("after:"),wZ=a(is),w0=a("data-tab-interval"),wY=[0,1],wX=[0,0],w4=a("Jsoo_runtime.Error.Exn"),w5=a(fa),xc=a(d),xd=a(hI),w9=a(h3),xh=a("ephox.wimp");function
  C(a){if(typeof
  a==="number")return 0;else
  switch(a[0]){case
  0:return[0,C(a[1])];case
  1:return[1,C(a[1])];case
  2:return[2,C(a[1])];case
  3:return[3,C(a[1])];case
  4:return[4,C(a[1])];case
  5:return[5,C(a[1])];case
  6:return[6,C(a[1])];case
  7:return[7,C(a[1])];case
  8:var
  c=a[1];return[8,c,C(a[2])];case
  9:var
  b=a[1];return[9,b,b,C(a[3])];case
  10:return[10,C(a[1])];case
  11:return[11,C(a[1])];case
  12:return[12,C(a[1])];case
  13:return[13,C(a[1])];default:return[14,C(a[1])]}}function
  Y(a,b){if(typeof
  a==="number")return b;else
  switch(a[0]){case
  0:return[0,Y(a[1],b)];case
  1:return[1,Y(a[1],b)];case
  2:return[2,Y(a[1],b)];case
  3:return[3,Y(a[1],b)];case
  4:return[4,Y(a[1],b)];case
  5:return[5,Y(a[1],b)];case
  6:return[6,Y(a[1],b)];case
  7:return[7,Y(a[1],b)];case
  8:var
  c=a[1];return[8,c,Y(a[2],b)];case
  9:var
  d=a[2],e=a[1];return[9,e,d,Y(a[3],b)];case
  10:return[10,Y(a[1],b)];case
  11:return[11,Y(a[1],b)];case
  12:return[12,Y(a[1],b)];case
  13:return[13,Y(a[1],b)];default:return[14,Y(a[1],b)]}}function
  x(a,b){if(typeof
  a==="number")return b;else
  switch(a[0]){case
  0:return[0,x(a[1],b)];case
  1:return[1,x(a[1],b)];case
  2:var
  c=a[1];return[2,c,x(a[2],b)];case
  3:var
  d=a[1];return[3,d,x(a[2],b)];case
  4:var
  e=a[3],f=a[2],g=a[1];return[4,g,f,e,x(a[4],b)];case
  5:var
  h=a[3],i=a[2],j=a[1];return[5,j,i,h,x(a[4],b)];case
  6:var
  k=a[3],l=a[2],m=a[1];return[6,m,l,k,x(a[4],b)];case
  7:var
  n=a[3],o=a[2],p=a[1];return[7,p,o,n,x(a[4],b)];case
  8:var
  q=a[3],r=a[2],s=a[1];return[8,s,r,q,x(a[4],b)];case
  9:var
  t=a[1];return[9,t,x(a[2],b)];case
  10:return[10,x(a[1],b)];case
  11:var
  u=a[1];return[11,u,x(a[2],b)];case
  12:var
  v=a[1];return[12,v,x(a[2],b)];case
  13:var
  w=a[2],y=a[1];return[13,y,w,x(a[3],b)];case
  14:var
  z=a[2],A=a[1];return[14,A,z,x(a[3],b)];case
  15:return[15,x(a[1],b)];case
  16:return[16,x(a[1],b)];case
  17:var
  B=a[1];return[17,B,x(a[2],b)];case
  18:var
  C=a[1];return[18,C,x(a[2],b)];case
  19:return[19,x(a[1],b)];case
  20:var
  D=a[2],E=a[1];return[20,E,D,x(a[3],b)];case
  21:var
  F=a[1];return[21,F,x(a[2],b)];case
  22:return[22,x(a[1],b)];case
  23:var
  G=a[1];return[23,G,x(a[2],b)];default:var
  H=a[2],I=a[1];return[24,I,H,x(a[3],b)]}}function
  cZ(a){throw[0,c0,a]}function
  I(a){throw[0,ea,a]}function
  c1(a){return 0<=a?a:-a|0}function
  g(d,c){var
  a=m(d),e=m(c),b=E(a+e|0);a9(d,0,b,0,a);a9(c,0,b,a,e);return O(b)}function
  ju(a){return a?jv:jw}function
  jx(a){try{var
  b=[0,cT(a)];return b}catch(a){a=H(a);if(a[1]===c0)return 0;throw a}}function
  z(a,b){if(a){var
  c=a[1];return[0,c,z(a[2],b)]}return b}yb(0);var
  ec=jg(1),aQ=jg(2);function
  bK(b,a){return jh(b,a,0,m(a))}function
  b_(a){bK(ec,a);fZ(ec,10);return aP(ec)}function
  f9(a){bK(aQ,a);fZ(aQ,10);return aP(aQ)}function
  ed(b){function
  a(b){var
  a=b;for(;;){if(a){var
  c=a[2],d=a[1];try{aP(d)}catch(a){a=H(a);if(a[1]!==f7)throw a;var
  e=a}var
  a=c;continue}return 0}}return a(yc(0))}f3(a(hK),ed);var
  ee=yp(0),b$=(4*ee|0)-1|0,jB=[A,jA,bo(0)];function
  jC(a){throw jB}function
  ca(a){var
  d=a[1];a[1]=jC;try{var
  c=b(d,0);yh(a,c);return c}catch(b){b=H(b);a[1]=function(a){throw b};throw b}}function
  f_(h,g,e){var
  a=g,d=e;for(;;){var
  c=b(d,0);if(c){var
  i=c[2],a=f(h,a,c[1]),d=i;continue}return a}}function
  ef(a){if(0<=a&&!(bS<a))return a;return I(jD)}function
  f$(a){var
  b=a-192|0,c=0;if(30<b>>>0){if(!(25<b+dL>>>0))c=1}else
  if(23!==b)c=1;return c?a+32|0:a}function
  jK(a){return 25<a-65>>>0?a:a+32|0}function
  jL(a){return 25<a+iu>>>0?a:a+iM|0}function
  bs(c){var
  b=0,a=c;for(;;){if(a){var
  b=b+1|0,a=a[2];continue}return b}}function
  c2(a){return a?a[2]:cZ(jM)}function
  eg(d,c){if(0<=c){var
  a=d,b=c;for(;;){if(a){var
  e=a[2],f=a[1];if(0===b)return f;var
  a=e,b=b-1|0;continue}return cZ(jN)}}return I(jO)}function
  cb(d,c){var
  a=d,b=c;for(;;){if(a){var
  e=[0,a[1],b],a=a[2],b=e;continue}return b}}function
  D(a){return cb(a,0)}function
  at(c,a){if(a){var
  d=a[2],e=b(c,a[1]);return[0,e,at(c,d)]}return 0}function
  bL(d,c){var
  a=c;for(;;){if(a){var
  e=a[2];b(d,a[1]);var
  a=e;continue}return 0}}function
  bb(e,d,c){var
  b=d,a=c;for(;;){if(a){var
  g=a[2],b=f(e,b,a[1]),a=g;continue}return b}}function
  ga(c,a,b){if(a){var
  d=a[1];return f(c,d,ga(c,a[2],b))}return b}function
  aR(e,d){var
  a=d;for(;;){if(a){var
  f=a[2],c=b(e,a[1]);if(c)return c;var
  a=f;continue}return 0}}function
  gb(d,c){var
  a=c;for(;;){if(a){var
  e=a[2],b=0===b7(a[1],d)?1:0;if(b)return b;var
  a=e;continue}return 0}}function
  cc(d,c){var
  a=c;for(;;){if(a){var
  b=a[1],e=a[2],f=b[2];if(0===b7(b[1],d))return f;var
  a=e;continue}throw q}}function
  gc(b,a){return a<=b?b:a}function
  aS(a,c){var
  b=E(a);xF(b,0,a,c);return b}var
  jP=E(0);function
  eh(a){var
  b=as(a),c=E(b);a8(a,0,c,0,b);return c}function
  jQ(a){return O(eh(a))}function
  ei(c,b,a){if(0<=b&&0<=a&&!((as(c)-a|0)<b)){var
  d=E(a);a8(c,b,d,0,a);return d}return I(jR)}function
  c3(c,b,a){return O(ei(c,b,a))}function
  gd(e,c,d,b,a){if(0<=a&&0<=c&&!((as(e)-a|0)<c)&&0<=b&&!((as(d)-a|0)<b))return a8(e,c,d,b,a);return I(jS)}function
  aT(e,c,d,b,a){if(0<=a&&0<=c&&!((m(e)-a|0)<c)&&0<=b&&!((as(d)-a|0)<b))return a9(e,c,d,b,a);return I(jT)}function
  ge(c){var
  a=c-9|0,b=0;if(4<a>>>0){if(23===a)b=1}else
  if(2!==a)b=1;return b?1:0}function
  ej(g,c){var
  d=as(c);if(0===d)return c;var
  e=E(d),f=d-1|0,h=0;if(!(f<0)){var
  a=h;for(;;){F(e,a,b(g,bE(c,a)));var
  i=a+1|0;if(f!==a){var
  a=i;continue}break}}return e}function
  cd(b,a){return O(aS(b,a))}function
  aC(c,b,a){return O(ei(aq(c),b,a))}function
  au(k,g){if(g){var
  h=m(k),c=0,b=g,q=0;for(;;){if(b){var
  i=b[1];if(b[2]){var
  j=(m(i)+h|0)+c|0,n=b[2],o=c<=j?j:I(jU),c=o,b=n;continue}var
  l=m(i)+c|0}else
  var
  l=c;var
  f=E(l),e=q,d=g;for(;;){if(d){var
  a=d[1];if(d[2]){var
  p=d[2];a9(a,0,f,e,m(a));a9(k,0,f,e+m(a)|0,h);var
  e=(e+m(a)|0)+h|0,d=p;continue}a9(a,0,f,e,m(a))}return O(f)}}}return jV}function
  gf(c){var
  a=c-9|0,b=0;if(4<a>>>0){if(23===a)b=1}else
  if(2!==a)b=1;return b?1:0}function
  gg(e,d,c,b){var
  a=c;for(;;){if(d<=a)throw q;if(aB(e,a)===b)return a;var
  a=a+1|0;continue}}function
  gh(a,b){return gg(a,m(a),0,b)}function
  jX(b,a,d){var
  c=m(b);if(0<=a&&!(c<a))try{gg(b,c,a,d);var
  e=1;return e}catch(a){a=H(a);if(a===q)return 0;throw a}return I(jY)}function
  gi(b,a){return jX(b,0,a)}function
  ek(a){return O(ej(jK,aq(a)))}function
  jZ(a){return O(ej(f$,aq(a)))}var
  j0=d9;function
  gj(e,c){var
  d=c.length-1;if(0===d)return[0];var
  f=bp(d,b(e,c[1])),g=d-1|0,h=1;if(!(g<1)){var
  a=h;for(;;){f[1+a]=b(e,c[1+a]);var
  i=a+1|0;if(g!==a){var
  a=i;continue}break}}return f}function
  aU(f,e,a){var
  c=x6(f,e,a),d=0<=c?1:0,g=d?a[12]!==c4?1:0:d;if(g){a[11]=a[12];var
  b=a[12];a[12]=[0,b[1],b[2],b[3],a[4]+a[6]|0]}return c}function
  gl(b,a){var
  c=b?b[1]:1,e=c?gk:c4,f=c?gk:c4,g=[0],h=1,i=0,j=0,k=0,l=0,n=0,o=m(a),d=eh(aq(a));return[0,function(a){a[9]=1;return 0},d,o,n,l,k,j,i,h,g,f,e]}function
  J(a){return c3(a[2],a[5],a[6]-a[5]|0)}function
  el(c,a,b){return c3(c[2],a,b-a|0)}function
  gm(d){function
  p(a){return a?a[4]:0}function
  e(b,e,a){var
  c=b?b[4]:0,d=a?a[4]:0,f=d<=c?c+1|0:d+1|0;return[0,b,e,a,f]}function
  g(b,f,a){var
  g=b?b[4]:0,h=a?a[4]:0;if((h+2|0)<g){if(b){var
  c=b[3],k=b[2],i=b[1],m=p(c);if(m<=p(i))return e(i,k,e(c,f,a));if(c){var
  n=c[2],o=c[1],q=e(c[3],f,a);return e(e(i,k,o),n,q)}return I(j2)}return I(j3)}if((g+2|0)<h){if(a){var
  j=a[3],l=a[2],d=a[1],r=p(d);if(r<=p(j))return e(e(b,f,d),l,j);if(d){var
  s=d[2],t=d[1],u=e(d[3],l,j);return e(e(b,f,t),s,u)}return I(j4)}return I(j5)}var
  v=h<=g?g+1|0:h+1|0;return[0,b,f,a,v]}function
  a(c,b){if(b){var
  e=b[3],h=b[2],i=b[1],j=f(d[1],c,h);if(0===j)return b;if(0<=j){var
  k=a(c,e);return e===k?b:g(i,h,k)}var
  l=a(c,i);return i===l?b:g(l,h,e)}return[0,0,c,0,1]}function
  h(a){return[0,0,a,0,1]}function
  E(b,a){if(a){var
  c=a[3],d=a[2];return g(E(b,a[1]),d,c)}return h(b)}function
  F(b,a){if(a){var
  c=a[2],d=a[1];return g(d,c,F(b,a[3]))}return h(b)}function
  c(b,d,a){if(b){if(a){var
  f=a[4],h=b[4],i=a[3],j=a[2],k=a[1],l=b[3],m=b[2],n=b[1];return(f+2|0)<h?g(n,m,c(l,d,a)):(h+2|0)<f?g(c(b,d,k),j,i):e(b,d,a)}return F(d,b)}return E(d,a)}function
  j(c){var
  a=c;for(;;){if(a){var
  b=a[1];if(b){var
  a=b;continue}return a[2]}throw q}}function
  G(c){var
  a=c;for(;;){if(a){var
  b=a[1];if(b){var
  a=b;continue}return[0,a[2]]}return 0}}function
  H(b){var
  a=b;for(;;){if(a){if(a[3]){var
  a=a[3];continue}return a[2]}throw q}}function
  T(b){var
  a=b;for(;;){if(a){if(a[3]){var
  a=a[3];continue}return[0,a[2]]}return 0}}function
  r(a){if(a){var
  b=a[1];if(b){var
  c=a[3],d=a[2];return g(r(b),d,c)}return a[3]}return I(j6)}function
  m(b,a){if(b){if(a){var
  d=r(a);return c(b,j(a),d)}return b}return a}function
  i(b,a){if(a){var
  e=a[3],g=a[2],h=a[1],l=f(d[1],b,g);if(0===l)return[0,h,1,e];if(0<=l){var
  j=i(b,e),m=j[3],n=j[2];return[0,c(h,g,j[1]),n,m]}var
  k=i(b,h),o=k[2],p=k[1];return[0,p,o,c(k[3],g,e)]}return j7}var
  u=0;function
  U(a){return a?0:1}function
  V(g,e){var
  a=e;for(;;){if(a){var
  h=a[3],i=a[1],b=f(d[1],g,a[2]),c=0===b?1:0;if(c)return c;var
  j=0<=b?h:i,a=j;continue}return 0}}function
  v(e,b){if(b){var
  a=b[3],h=b[2],c=b[1],i=f(d[1],e,h);if(0===i){if(c){if(a){var
  m=r(a);return g(c,j(a),m)}return c}return a}if(0<=i){var
  k=v(e,a);return a===k?b:g(c,h,k)}var
  l=v(e,c);return c===l?b:g(l,h,a)}return 0}function
  k(d,b){if(d){if(b){var
  g=b[4],e=b[2],h=d[4],f=d[2],m=b[3],n=b[1],o=d[3],p=d[1];if(g<=h){if(1===g)return a(e,d);var
  j=i(f,b),q=j[1],r=k(o,j[3]);return c(k(p,q),f,r)}if(1===h)return a(f,b);var
  l=i(e,d),s=l[1],t=k(l[3],m);return c(k(s,n),e,t)}return d}return b}function
  n(a,d){if(a){if(d){var
  e=a[3],f=a[2],g=a[1],b=i(f,d),h=b[1];if(b[2]){var
  j=n(e,b[3]);return c(n(g,h),f,j)}var
  k=n(e,b[3]);return m(n(g,h),k)}return 0}return 0}function
  w(e,a){if(a){var
  j=a[3],g=a[2],k=a[1],l=f(d[1],e,g);if(0===l)return 0;if(0<=l){var
  h=w(e,j);if(h){var
  m=h[2];return[0,c(k,g,h[1]),m]}return 0}var
  i=w(e,k);if(i){var
  n=i[2],o=i[1];return[0,o,function(a){return c(b(n,0),g,j)}]}return 0}return[0,0,function(a){return 0}]}function
  J(g,f){var
  a=g,c=f;for(;;){if(a&&c){var
  h=a[3],i=a[2],j=a[1];if(a===c)return 0;var
  d=w(i,c);if(d){var
  k=d[2],e=J(j,d[1]);if(e){var
  a=h,c=b(k,0);continue}return e}return 0}return 1}}function
  o(a,d){if(a){if(d){var
  e=a[3],f=a[2],g=a[1],b=i(f,d),h=b[1];if(b[2]){var
  j=o(e,b[3]);return m(o(g,h),j)}var
  k=o(e,b[3]);return c(o(g,h),f,k)}return a}return 0}function
  l(d,c){var
  a=d,b=c;for(;;){if(a){var
  e=[0,a[2],a[3],b],a=a[1],b=e;continue}return b}}function
  K(m,k){var
  n=l(k,0),b=l(m,0),a=n;for(;;){if(b){if(a){var
  e=a[3],g=a[2],h=b[3],i=b[2],c=f(d[1],b[1],a[1]);if(0===c){var
  j=l(g,e),b=l(i,h),a=j;continue}return c}return 1}return a?-1:0}}function
  W(b,a){return 0===K(b,a)?1:0}function
  s(o,n){var
  a=o,b=n;for(;;){if(a){if(b){var
  h=b[3],i=b[1],c=a[3],e=a[2],g=a[1],j=f(d[1],e,b[2]);if(0===j){var
  k=s(g,i);if(k){var
  a=c,b=h;continue}return k}if(0<=j){var
  l=s([0,0,e,c,0],h);if(l){var
  a=g;continue}return l}var
  m=s([0,g,e,0,0],i);if(m){var
  a=c;continue}return m}return 0}return 1}}function
  L(c,d){var
  a=d;for(;;){if(a){var
  e=a[3],f=a[2];L(c,a[1]);b(c,f);var
  a=e;continue}return 0}}function
  M(c,e,d){var
  a=e,b=d;for(;;){if(a){var
  g=a[3],h=a[2],i=f(c,h,M(c,a[1],b)),a=g,b=i;continue}return b}}function
  N(c,g){var
  a=g;for(;;){if(a){var
  h=a[3],i=a[1],d=b(c,a[2]);if(d){var
  e=N(c,i);if(e){var
  a=h;continue}var
  f=e}else
  var
  f=d;return f}return 1}}function
  O(c,g){var
  a=g;for(;;){if(a){var
  h=a[3],i=a[1],d=b(c,a[2]);if(d)var
  e=d;else{var
  f=O(c,i);if(!f){var
  a=h;continue}var
  e=f}return e}return 0}}function
  x(d,a){if(a){var
  g=a[3],h=a[2],i=a[1],e=x(d,i),j=b(d,h),f=x(d,g);if(j){if(i===e&&g===f)return a;return c(e,h,f)}return m(e,f)}return 0}function
  y(d,a){if(a){var
  e=a[2],l=a[3],f=y(d,a[1]),g=f[2],h=f[1],n=b(d,e),i=y(d,l),j=i[2],k=i[1];if(n){var
  o=m(g,j);return[0,c(h,e,k),o]}var
  p=c(g,e,j);return[0,m(h,k),p]}return j8}function
  z(a){if(a){var
  b=a[1],c=z(a[3]);return(z(b)+1|0)+c|0}return 0}function
  P(d,c){var
  b=d,a=c;for(;;){if(a){var
  e=a[2],f=a[1],b=[0,e,P(b,a[3])],a=f;continue}return b}}function
  X(a){return P(0,a)}function
  Y(g,e){var
  a=e;for(;;){if(a){var
  b=a[2],h=a[3],i=a[1],c=f(d[1],g,b);if(0===c)return b;var
  j=0<=c?h:i,a=j;continue}throw q}}function
  Z(f,j){var
  c=j;for(;;){if(c){var
  g=c[2],k=c[3],l=c[1];if(b(f,g)){var
  d=g,a=l;for(;;){if(a){var
  e=a[2],h=a[3],i=a[1];if(b(f,e)){var
  d=e,a=i;continue}var
  a=h;continue}return d}}var
  c=k;continue}throw q}}function
  _(f,j){var
  c=j;for(;;){if(c){var
  g=c[2],k=c[3],l=c[1];if(b(f,g)){var
  d=g,a=l;for(;;){if(a){var
  e=a[2],h=a[3],i=a[1];if(b(f,e)){var
  d=e,a=i;continue}var
  a=h;continue}return[0,d]}}var
  c=k;continue}return 0}}function
  $(f,j){var
  c=j;for(;;){if(c){var
  g=c[2],k=c[3],l=c[1];if(b(f,g)){var
  d=g,a=k;for(;;){if(a){var
  e=a[2],h=a[3],i=a[1];if(b(f,e)){var
  d=e,a=h;continue}var
  a=i;continue}return d}}var
  c=l;continue}throw q}}function
  aa(f,j){var
  c=j;for(;;){if(c){var
  g=c[2],k=c[3],l=c[1];if(b(f,g)){var
  d=g,a=k;for(;;){if(a){var
  e=a[2],h=a[3],i=a[1];if(b(f,e)){var
  d=e,a=h;continue}var
  a=i;continue}return[0,d]}}var
  c=l;continue}return 0}}function
  ab(g,e){var
  a=e;for(;;){if(a){var
  b=a[2],h=a[3],i=a[1],c=f(d[1],g,b);if(0===c)return[0,b];var
  j=0<=c?h:i,a=j;continue}return 0}}function
  A(g,e,b){var
  h=0;if(0!==g){var
  m=H(g);if(0<=f(d[1],m,e))h=1}if(!h){var
  i=0;if(0!==b){var
  l=j(b);if(0<=f(d[1],e,l))i=1}if(!i)return c(g,e,b)}return k(g,a(e,b))}function
  B(c,a){if(a){var
  d=a[3],e=a[2],f=a[1],g=B(c,f),h=b(c,e),i=B(c,d);if(f===g&&e===h&&d===i)return a;return A(g,h,i)}return 0}function
  C(e,c){if(c){var
  f=c[3],g=c[2],h=c[1],d=C(e,h),i=b(e,g),a=C(e,f);if(i){var
  k=i[1];if(h===d&&g===k&&f===a)return c;return A(d,k,a)}if(d){if(a){var
  l=r(a);return A(d,j(a),l)}return d}return a}return 0}function
  ac(c){if(c){var
  k=c[2],g=c[1];if(k){var
  l=k[2],i=k[1];if(l){var
  n=l[2],o=l[1];if(n){var
  p=n[2],r=n[1];if(p){if(p[2]){var
  b=d[1],x=function(j,g){if(2===j){if(g){var
  n=g[2];if(n){var
  o=n[1],k=g[1],J=n[2],y=f(b,k,o),K=0===y?[0,k,0]:0<y?[0,k,[0,o,0]]:[0,o,[0,k,0]];return[0,K,J]}}}else
  if(3===j&&g){var
  p=g[2];if(p){var
  q=p[2];if(q){var
  c=q[1],a=p[1],d=g[1],N=q[2],D=f(b,d,a);if(0===D)var
  E=f(b,a,c),O=0===E?[0,a,0]:0<E?[0,a,[0,c,0]]:[0,c,[0,a,0]],r=O;else
  if(0<D){var
  F=f(b,a,c);if(0===F)var
  s=[0,d,[0,a,0]];else
  if(0<F)var
  s=[0,d,[0,a,[0,c,0]]];else
  var
  G=f(b,d,c),P=0===G?[0,d,[0,a,0]]:0<G?[0,d,[0,c,[0,a,0]]]:[0,c,[0,d,[0,a,0]]],s=P;var
  r=s}else{var
  H=f(b,d,c);if(0===H)var
  t=[0,a,[0,d,0]];else
  if(0<H)var
  t=[0,a,[0,d,[0,c,0]]];else
  var
  I=f(b,a,c),Q=0===I?[0,a,[0,d,0]]:0<I?[0,a,[0,c,[0,d,0]]]:[0,c,[0,a,[0,d,0]]],t=Q;var
  r=t}return[0,r,N]}}}var
  z=j>>1,A=m(z,g),L=A[1],B=m(j-z|0,A[2]),i=L,h=B[1],e=0,M=B[2];for(;;){if(i){if(h){var
  u=h[2],v=h[1],w=i[2],l=i[1],x=f(b,l,v);if(0===x){var
  i=w,h=u,e=[0,l,e];continue}if(0<=x){var
  h=u,e=[0,v,e];continue}var
  i=w,e=[0,l,e];continue}var
  C=cb(i,e)}else
  var
  C=cb(h,e);return[0,C,M]}},m=function(j,g){if(2===j){if(g){var
  m=g[2];if(m){var
  n=m[1],k=g[1],J=m[2],y=f(b,k,n),K=0===y?[0,k,0]:0<=y?[0,n,[0,k,0]]:[0,k,[0,n,0]];return[0,K,J]}}}else
  if(3===j&&g){var
  o=g[2];if(o){var
  p=o[2];if(p){var
  c=p[1],a=o[1],d=g[1],N=p[2],D=f(b,d,a);if(0===D)var
  E=f(b,a,c),O=0===E?[0,a,0]:0<=E?[0,c,[0,a,0]]:[0,a,[0,c,0]],q=O;else
  if(0<=D){var
  F=f(b,d,c);if(0===F)var
  r=[0,a,[0,d,0]];else
  if(0<=F)var
  G=f(b,a,c),P=0===G?[0,a,[0,d,0]]:0<=G?[0,c,[0,a,[0,d,0]]]:[0,a,[0,c,[0,d,0]]],r=P;else
  var
  r=[0,a,[0,d,[0,c,0]]];var
  q=r}else{var
  H=f(b,a,c);if(0===H)var
  s=[0,d,[0,a,0]];else
  if(0<=H)var
  I=f(b,d,c),Q=0===I?[0,d,[0,a,0]]:0<=I?[0,c,[0,d,[0,a,0]]]:[0,d,[0,c,[0,a,0]]],s=Q;else
  var
  s=[0,d,[0,a,[0,c,0]]];var
  q=s}return[0,q,N]}}}var
  z=j>>1,A=x(z,g),L=A[1],B=x(j-z|0,A[2]),i=L,h=B[1],e=0,M=B[2];for(;;){if(i){if(h){var
  t=h[2],u=h[1],v=i[2],l=i[1],w=f(b,l,u);if(0===w){var
  i=v,h=t,e=[0,l,e];continue}if(0<w){var
  i=v,e=[0,l,e];continue}var
  h=t,e=[0,u,e];continue}var
  C=cb(i,e)}else
  var
  C=cb(h,e);return[0,C,M]}},q=bs(c),s=2<=q?m(q,c)[1]:c,j=function(b,a){if(!(3<b>>>0))switch(b){case
  0:return[0,0,a];case
  1:if(a)return[0,[0,0,a[1],0,1],a[2]];break;case
  2:if(a){var
  d=a[2];if(d)return[0,[0,[0,0,a[1],0,1],d[1],0,2],d[2]]}break;default:if(a){var
  f=a[2];if(f){var
  g=f[2];if(g)return[0,[0,[0,0,a[1],0,1],f[1],[0,0,g[1],0,1],2],g[2]]}}}var
  h=b/2|0,i=j(h,a),c=i[2],l=i[1];if(c){var
  m=c[1],k=j((b-h|0)-1|0,c[2]),n=k[2];return[0,e(l,m,k[1]),n]}throw[0,t,j9]};return j(bs(s),s)[1]}var
  v=p[1];return a(v,a(r,a(o,a(i,h(g)))))}return a(r,a(o,a(i,h(g))))}return a(o,a(i,h(g)))}return a(i,h(g))}return h(g)}return u}function
  Q(c,b){return f_(function(c,b){return a(b,c)},b,c)}function
  ad(a){return Q(a,u)}function
  D(a,d){if(a){var
  b=a[1],c=l(a[2],a[3]);return[0,b,function(a){return D(c,a)}]}return 0}function
  ae(a){var
  b=l(a,0);return function(a){return D(b,a)}}function
  R(d,c){var
  a=d,b=c;for(;;){if(a){var
  e=[0,a[2],a[1],b],a=a[3],b=e;continue}return b}}function
  S(a,d){if(a){var
  b=a[1],c=R(a[2],a[3]);return[0,b,function(a){return S(c,a)}]}return 0}function
  af(a){var
  b=R(a,0);return function(a){return S(b,a)}}return[0,u,U,V,a,h,v,k,n,J,o,K,W,s,L,B,M,N,O,x,C,y,z,X,j,G,H,T,j,G,i,Y,ab,Z,_,$,aa,ac,function(j,i){var
  a=i,b=0;for(;;){if(a){var
  c=a[3],e=a[2],k=a[1],g=f(d[1],e,j);if(0!==g){if(0<=g){var
  a=k,b=[0,e,c,b];continue}var
  a=c;continue}var
  h=[0,e,c,b]}else
  var
  h=b;return function(a){return D(h,a)}}},ae,af,Q,ad]}function
  em(g){function
  h(a){return a?a[5]:0}function
  d(b,f,e,a){var
  c=h(b),d=h(a),g=d<=c?c+1|0:d+1|0;return[0,b,f,e,a,g]}function
  p(b,a){return[0,0,b,a,0,1]}function
  a(b,g,f,a){var
  i=b?b[5]:0,j=a?a[5]:0;if((j+2|0)<i){if(b){var
  c=b[4],m=b[3],n=b[2],k=b[1],q=h(c);if(q<=h(k))return d(k,n,m,d(c,g,f,a));if(c){var
  r=c[3],s=c[2],t=c[1],u=d(c[4],g,f,a);return d(d(k,n,m,t),s,r,u)}return I(j_)}return I(j$)}if((i+2|0)<j){if(a){var
  l=a[4],o=a[3],p=a[2],e=a[1],v=h(e);if(v<=h(l))return d(d(b,g,f,e),p,o,l);if(e){var
  w=e[3],x=e[2],y=e[1],z=d(e[4],p,o,l);return d(d(b,g,f,y),x,w,z)}return I(ka)}return I(kb)}var
  A=j<=i?i+1|0:j+1|0;return[0,b,g,f,a,A]}var
  C=0;function
  Q(a){return a?0:1}function
  m(d,c,b){if(b){var
  e=b[4],i=b[3],j=b[2],h=b[1],o=b[5],k=f(g[1],d,j);if(0===k)return i===c?b:[0,h,d,c,e,o];if(0<=k){var
  l=m(d,c,e);return e===l?b:a(h,j,i,l)}var
  n=m(d,c,h);return h===n?b:a(n,j,i,e)}return[0,0,d,c,0,1]}function
  R(d,c){var
  a=c;for(;;){if(a){var
  e=a[4],h=a[3],i=a[1],b=f(g[1],d,a[2]);if(0===b)return h;var
  j=0<=b?e:i,a=j;continue}throw q}}function
  S(g,l){var
  c=l;for(;;){if(c){var
  h=c[2],m=c[4],n=c[3],o=c[1];if(b(g,h)){var
  e=h,d=n,a=o;for(;;){if(a){var
  f=a[2],i=a[4],j=a[3],k=a[1];if(b(g,f)){var
  e=f,d=j,a=k;continue}var
  a=i;continue}return[0,e,d]}}var
  c=m;continue}throw q}}function
  T(g,l){var
  c=l;for(;;){if(c){var
  h=c[2],m=c[4],n=c[3],o=c[1];if(b(g,h)){var
  e=h,d=n,a=o;for(;;){if(a){var
  f=a[2],i=a[4],j=a[3],k=a[1];if(b(g,f)){var
  e=f,d=j,a=k;continue}var
  a=i;continue}return[0,[0,e,d]]}}var
  c=m;continue}return 0}}function
  U(g,l){var
  c=l;for(;;){if(c){var
  h=c[2],m=c[4],n=c[3],o=c[1];if(b(g,h)){var
  e=h,d=n,a=m;for(;;){if(a){var
  f=a[2],i=a[4],j=a[3],k=a[1];if(b(g,f)){var
  e=f,d=j,a=i;continue}var
  a=k;continue}return[0,e,d]}}var
  c=o;continue}throw q}}function
  V(g,l){var
  c=l;for(;;){if(c){var
  h=c[2],m=c[4],n=c[3],o=c[1];if(b(g,h)){var
  e=h,d=n,a=m;for(;;){if(a){var
  f=a[2],i=a[4],j=a[3],k=a[1];if(b(g,f)){var
  e=f,d=j,a=i;continue}var
  a=k;continue}return[0,[0,e,d]]}}var
  c=o;continue}return 0}}function
  W(d,c){var
  a=c;for(;;){if(a){var
  e=a[4],h=a[3],i=a[1],b=f(g[1],d,a[2]);if(0===b)return[0,h];var
  j=0<=b?e:i,a=j;continue}return 0}}function
  X(e,d){var
  a=d;for(;;){if(a){var
  h=a[4],i=a[1],b=f(g[1],e,a[2]),c=0===b?1:0;if(c)return c;var
  j=0<=b?h:i,a=j;continue}return 0}}function
  n(c){var
  a=c;for(;;){if(a){var
  b=a[1];if(b){var
  a=b;continue}return[0,a[2],a[3]]}throw q}}function
  D(c){var
  a=c;for(;;){if(a){var
  b=a[1];if(b){var
  a=b;continue}return[0,[0,a[2],a[3]]]}return 0}}function
  Y(b){var
  a=b;for(;;){if(a){if(a[4]){var
  a=a[4];continue}return[0,a[2],a[3]]}throw q}}function
  Z(b){var
  a=b;for(;;){if(a){if(a[4]){var
  a=a[4];continue}return[0,[0,a[2],a[3]]]}return 0}}function
  r(b){if(b){var
  c=b[1];if(c){var
  d=b[4],e=b[3],f=b[2];return a(r(c),f,e,d)}return b[4]}return I(kc)}function
  E(c,b){if(c){if(b){var
  d=n(b),e=d[2],f=d[1];return a(c,f,e,r(b))}return c}return b}function
  s(e,b){if(b){var
  c=b[4],i=b[3],h=b[2],d=b[1],j=f(g[1],e,h);if(0===j)return E(d,c);if(0<=j){var
  k=s(e,c);return c===k?b:a(d,h,i,k)}var
  l=s(e,d);return d===l?b:a(l,h,i,c)}return 0}function
  u(d,i,c){if(c){var
  e=c[4],j=c[3],k=c[2],h=c[1],r=c[5],l=f(g[1],d,k);if(0===l){var
  m=b(i,[0,j]);if(m){var
  n=m[1];return j===n?c:[0,h,d,n,e,r]}return E(h,e)}if(0<=l){var
  o=u(d,i,e);return e===o?c:a(h,k,j,o)}var
  p=u(d,i,h);return h===p?c:a(p,k,j,e)}var
  q=b(i,0);return q?[0,0,d,q[1],0,1]:0}function
  F(b,c){var
  a=c;for(;;){if(a){var
  d=a[4],e=a[3],g=a[2];F(b,a[1]);f(b,g,e);var
  a=d;continue}return 0}}function
  v(c,a){if(a){var
  d=a[5],e=a[4],f=a[3],g=a[2],h=v(c,a[1]),i=b(c,f);return[0,h,g,i,v(c,e),d]}return 0}function
  w(b,a){if(a){var
  c=a[2],d=a[5],e=a[4],g=a[3],h=w(b,a[1]),i=f(b,c,g);return[0,h,c,i,w(b,e),d]}return 0}function
  G(c,e,d){var
  a=e,b=d;for(;;){if(a){var
  f=a[4],g=a[3],h=a[2],i=aH(c,h,g,G(c,a[1],b)),a=f,b=i;continue}return b}}function
  H(b,g){var
  a=g;for(;;){if(a){var
  h=a[4],i=a[1],c=f(b,a[2],a[3]);if(c){var
  d=H(b,i);if(d){var
  a=h;continue}var
  e=d}else
  var
  e=c;return e}return 1}}function
  J(b,g){var
  a=g;for(;;){if(a){var
  h=a[4],i=a[1],c=f(b,a[2],a[3]);if(c)var
  d=c;else{var
  e=J(b,i);if(!e){var
  a=h;continue}var
  d=e}return d}return 0}}function
  K(d,c,b){if(b){var
  e=b[4],f=b[3],g=b[2];return a(K(d,c,b[1]),g,f,e)}return p(d,c)}function
  L(d,c,b){if(b){var
  e=b[3],f=b[2],g=b[1];return a(g,f,e,L(d,c,b[4]))}return p(d,c)}function
  c(e,g,f,b){if(e){if(b){var
  h=b[5],i=e[5],j=b[4],k=b[3],l=b[2],m=b[1],n=e[4],o=e[3],p=e[2],q=e[1];return(h+2|0)<i?a(q,p,o,c(n,g,f,b)):(i+2|0)<h?a(c(e,g,f,m),l,k,j):d(e,g,f,b)}return L(g,f,e)}return K(g,f,b)}function
  j(b,a){if(b){if(a){var
  d=n(a),e=d[2],f=d[1];return c(b,f,e,r(a))}return b}return a}function
  o(d,e,b,a){return b?c(d,e,b[1],a):j(d,a)}function
  i(b,a){if(a){var
  d=a[4],e=a[3],h=a[2],j=a[1],m=f(g[1],b,h);if(0===m)return[0,j,[0,e],d];if(0<=m){var
  k=i(b,d),n=k[3],o=k[2];return[0,c(j,h,e,k[1]),o,n]}var
  l=i(b,j),p=l[2],q=l[1];return[0,q,p,c(l[3],h,e,d)]}return kd}function
  k(c,b,a){if(b){var
  d=b[2],j=b[5],l=b[4],m=b[3],n=b[1];if(h(a)<=j){var
  e=i(d,a),p=e[2],q=e[1],r=k(c,l,e[3]),s=aH(c,d,[0,m],p);return o(k(c,n,q),d,s,r)}}else
  if(!a)return 0;if(a){var
  f=a[2],u=a[4],v=a[3],w=a[1],g=i(f,b),x=g[2],y=g[1],z=k(c,g[3],u),A=aH(c,f,x,[0,v]);return o(k(c,y,w),f,A,z)}throw[0,t,ke]}function
  l(d,b,a){if(b){if(a){var
  j=a[3],e=a[2],k=b[3],f=b[2],u=a[4],v=a[1],w=b[4],x=b[1];if(a[5]<=b[5]){var
  g=i(f,a),m=g[2],y=g[3],n=l(d,x,g[1]),p=l(d,w,y);return m?o(n,f,aH(d,f,k,m[1]),p):c(n,f,k,p)}var
  h=i(e,b),q=h[2],z=h[3],r=l(d,h[1],v),s=l(d,z,u);return q?o(r,e,aH(d,e,q[1],j),s):c(r,e,j,s)}var
  t=b}else
  var
  t=a;return t}function
  x(b,a){if(a){var
  g=a[4],h=a[3],i=a[2],k=a[1],d=x(b,k),l=f(b,i,h),e=x(b,g);if(l){if(k===d&&g===e)return a;return c(d,i,h,e)}return j(d,e)}return 0}function
  y(b,a){if(a){var
  d=a[2],i=a[4],k=a[3],e=y(b,a[1]),g=f(b,d,k),h=y(b,i);return g?c(e,d,g[1],h):j(e,h)}return 0}function
  z(b,a){if(a){var
  d=a[3],e=a[2],n=a[4],g=z(b,a[1]),h=g[2],i=g[1],o=f(b,e,d),k=z(b,n),l=k[2],m=k[1];if(o){var
  p=j(h,l);return[0,c(i,e,d,m),p]}var
  q=c(h,e,d,l);return[0,j(i,m),q]}return kf}function
  e(d,c){var
  a=d,b=c;for(;;){if(a){var
  e=[0,a[2],a[3],a[4],b],a=a[1],b=e;continue}return b}}function
  _(j,i,h){var
  r=e(h,0),b=e(i,0),a=r;for(;;){if(b){if(a){var
  k=a[4],l=a[3],m=a[2],n=b[4],o=b[3],p=b[2],c=f(g[1],b[1],a[1]);if(0===c){var
  d=f(j,p,m);if(0===d){var
  q=e(l,k),b=e(o,n),a=q;continue}return d}return c}return 1}return a?-1:0}}function
  $(k,j,i){var
  s=e(i,0),b=e(j,0),a=s;for(;;){if(b){if(a){var
  l=a[4],m=a[3],n=a[2],o=b[4],p=b[3],q=b[2],c=0===f(g[1],b[1],a[1])?1:0;if(c){var
  d=f(k,q,n);if(d){var
  r=e(m,l),b=e(p,o),a=r;continue}var
  h=d}else
  var
  h=c;return h}return 0}return a?0:1}}function
  A(a){if(a){var
  b=a[1],c=A(a[4]);return(A(b)+1|0)+c|0}return 0}function
  M(d,c){var
  b=d,a=c;for(;;){if(a){var
  e=a[3],f=a[2],g=a[1],b=[0,[0,f,e],M(b,a[4])],a=g;continue}return b}}function
  aa(a){return M(0,a)}function
  N(b,a){return f_(function(b,a){return m(a[1],a[2],b)},a,b)}function
  ab(a){return N(a,C)}function
  B(a,f){if(a){var
  b=a[2],c=a[1],d=e(a[3],a[4]);return[0,[0,c,b],function(a){return B(d,a)}]}return 0}function
  ac(a){var
  b=e(a,0);return function(a){return B(b,a)}}function
  O(d,c){var
  a=d,b=c;for(;;){if(a){var
  e=[0,a[2],a[3],a[1],b],a=a[4],b=e;continue}return b}}function
  P(a,e){if(a){var
  b=a[2],c=a[1],d=O(a[3],a[4]);return[0,[0,c,b],function(a){return P(d,a)}]}return 0}function
  ad(a){var
  b=O(a,0);return function(a){return P(b,a)}}return[0,C,Q,X,m,u,p,s,k,l,_,$,F,G,H,J,x,y,z,A,aa,n,D,Y,Z,n,D,i,R,W,S,T,U,V,v,w,ac,ad,function(k,j){var
  a=j,b=0;for(;;){if(a){var
  c=a[4],e=a[3],d=a[2],l=a[1],h=f(g[1],d,k);if(0!==h){if(0<=h){var
  a=l,b=[0,d,e,c,b];continue}var
  a=c;continue}var
  i=[0,d,e,c,b]}else
  var
  i=b;return function(a){return B(i,a)}}},N,ab]}var
  en=[A,kg,bo(0)];function
  gn(a){return[0,0,0]}function
  eo(b,a){a[1]=[0,b,a[1]];a[2]=a[2]+1|0;return 0}function
  ce(a){var
  b=a[1];if(b){var
  c=b[1];a[1]=b[2];a[2]=a[2]-1|0;return c}throw en}function
  kh(b,a){return bL(b,a[1])}function
  go(a){var
  b=1<=a?a:1,c=b$<b?b$:b,d=E(c);return[0,d,0,c,d]}function
  gp(a){return c3(a[1],0,a[2])}function
  gq(a,c){var
  d=a[2],b=[0,a[3]];for(;;){if(b[1]<(d+c|0)){b[1]=2*b[1]|0;continue}if(b$<b[1])if((d+c|0)<=b$)b[1]=b$;else
  cZ(kk);var
  e=E(b[1]);gd(a[1],0,e,0,a[2]);a[1]=e;a[3]=b[1];if((a[2]+c|0)<=a[3]){if((d+c|0)<=a[3])return 0;throw[0,t,ki]}throw[0,t,kj]}}function
  bM(a,c){var
  b=m(c),d=a[2]+b|0;if(a[3]<d)gq(a,b);a9(c,0,a[1],a[2],b);a[2]=d;return 0}function
  ep(a){return 5===a[2]?12:-6}function
  gr(a){return[0,0,E(a)]}function
  gs(a,g){var
  b=as(a[2]),c=a[1]+g|0,d=b<c?1:0;if(d){var
  e=E(gc(b*2|0,c));gd(a[2],0,e,0,b);a[2]=e;var
  f=0}else
  var
  f=d;return f}function
  bN(a,b){gs(a,1);a_(a[2],a[1],b);a[1]=a[1]+1|0;return 0}function
  S(a,c){var
  b=m(c);gs(a,b);aT(c,0,a[2],a[1],b);a[1]=a[1]+b|0;return 0}function
  gt(a){return c3(a[2],0,a[1])}function
  gu(a){if(typeof
  a==="number")switch(a){case
  0:return kl;case
  1:return km;case
  2:return kn;case
  3:return ko;case
  4:return kp;case
  5:return kq;default:return kr}else
  switch(a[0]){case
  0:return a[1];case
  1:return a[1];default:return g(ks,cd(1,a[1]))}}function
  eq(b,c){var
  a=c;for(;;)if(typeof
  a==="number")return 0;else
  switch(a[0]){case
  0:var
  d=a[1];S(b,kt);var
  a=d;continue;case
  1:var
  e=a[1];S(b,ku);var
  a=e;continue;case
  2:var
  f=a[1];S(b,kv);var
  a=f;continue;case
  3:var
  g=a[1];S(b,kw);var
  a=g;continue;case
  4:var
  h=a[1];S(b,kx);var
  a=h;continue;case
  5:var
  i=a[1];S(b,ky);var
  a=i;continue;case
  6:var
  j=a[1];S(b,kz);var
  a=j;continue;case
  7:var
  k=a[1];S(b,kA);var
  a=k;continue;case
  8:var
  l=a[2],m=a[1];S(b,kB);eq(b,m);S(b,kC);var
  a=l;continue;case
  9:var
  n=a[3],o=a[1];S(b,kD);eq(b,o);S(b,kE);var
  a=n;continue;case
  10:var
  p=a[1];S(b,kF);var
  a=p;continue;case
  11:var
  q=a[1];S(b,kG);var
  a=q;continue;case
  12:var
  r=a[1];S(b,kH);var
  a=r;continue;case
  13:var
  s=a[1];S(b,kI);var
  a=s;continue;default:var
  t=a[1];S(b,kJ);var
  a=t;continue}}function
  K(a){if(typeof
  a==="number")return 0;else
  switch(a[0]){case
  0:return[0,K(a[1])];case
  1:return[1,K(a[1])];case
  2:return[2,K(a[1])];case
  3:return[3,K(a[1])];case
  4:return[4,K(a[1])];case
  5:return[5,K(a[1])];case
  6:return[6,K(a[1])];case
  7:return[7,K(a[1])];case
  8:var
  b=a[1];return[8,b,K(a[2])];case
  9:var
  c=a[2],d=a[1];return[9,c,d,K(a[3])];case
  10:return[10,K(a[1])];case
  11:return[11,K(a[1])];case
  12:return[12,K(a[1])];case
  13:return[13,K(a[1])];default:return[14,K(a[1])]}}function
  T(a){if(typeof
  a==="number"){var
  s=function(a){return 0},t=function(a){return 0},u=function(a){return 0};return[0,function(a){return 0},u,t,s]}else
  switch(a[0]){case
  0:var
  c=T(a[1]),v=c[4],w=c[3],x=c[2],y=c[1],z=function(a){b(x,0);return 0};return[0,function(a){b(y,0);return 0},z,w,v];case
  1:var
  d=T(a[1]),A=d[4],B=d[3],C=d[2],D=d[1],E=function(a){b(C,0);return 0};return[0,function(a){b(D,0);return 0},E,B,A];case
  2:var
  e=T(a[1]),F=e[4],G=e[3],H=e[2],I=e[1],J=function(a){b(H,0);return 0};return[0,function(a){b(I,0);return 0},J,G,F];case
  3:var
  f=T(a[1]),M=f[4],N=f[3],O=f[2],P=f[1],Q=function(a){b(O,0);return 0};return[0,function(a){b(P,0);return 0},Q,N,M];case
  4:var
  g=T(a[1]),R=g[4],S=g[3],U=g[2],V=g[1],W=function(a){b(U,0);return 0};return[0,function(a){b(V,0);return 0},W,S,R];case
  5:var
  h=T(a[1]),X=h[4],Y=h[3],Z=h[2],_=h[1],$=function(a){b(Z,0);return 0};return[0,function(a){b(_,0);return 0},$,Y,X];case
  6:var
  i=T(a[1]),aa=i[4],ab=i[3],ac=i[2],ad=i[1],ae=function(a){b(ac,0);return 0};return[0,function(a){b(ad,0);return 0},ae,ab,aa];case
  7:var
  j=T(a[1]),af=j[4],ag=j[3],ah=j[2],ai=j[1],aj=function(a){b(ah,0);return 0};return[0,function(a){b(ai,0);return 0},aj,ag,af];case
  8:var
  k=T(a[2]),ak=k[4],al=k[3],am=k[2],an=k[1],ao=function(a){b(am,0);return 0};return[0,function(a){b(an,0);return 0},ao,al,ak];case
  9:var
  ap=a[2],aq=a[1],l=T(a[3]),ar=l[4],as=l[3],at=l[2],au=l[1],m=T(L(K(aq),ap)),av=m[4],aw=m[3],ax=m[2],ay=m[1],az=function(a){b(av,0);b(ar,0);return 0},aA=function(a){b(as,0);b(aw,0);return 0},aB=function(a){b(ax,0);b(at,0);return 0};return[0,function(a){b(au,0);b(ay,0);return 0},aB,aA,az];case
  10:var
  n=T(a[1]),aC=n[4],aD=n[3],aE=n[2],aF=n[1],aG=function(a){b(aE,0);return 0};return[0,function(a){b(aF,0);return 0},aG,aD,aC];case
  11:var
  o=T(a[1]),aH=o[4],aI=o[3],aJ=o[2],aK=o[1],aL=function(a){b(aJ,0);return 0};return[0,function(a){b(aK,0);return 0},aL,aI,aH];case
  12:var
  p=T(a[1]),aM=p[4],aN=p[3],aO=p[2],aP=p[1],aQ=function(a){b(aO,0);return 0};return[0,function(a){b(aP,0);return 0},aQ,aN,aM];case
  13:var
  q=T(a[1]),aR=q[4],aS=q[3],aT=q[2],aU=q[1],aV=function(a){b(aR,0);return 0},aW=function(a){b(aS,0);return 0},aX=function(a){b(aT,0);return 0};return[0,function(a){b(aU,0);return 0},aX,aW,aV];default:var
  r=T(a[1]),aY=r[4],aZ=r[3],a0=r[2],a1=r[1],a2=function(a){b(aY,0);return 0},a3=function(a){b(aZ,0);return 0},a4=function(a){b(a0,0);return 0};return[0,function(a){b(a1,0);return 0},a4,a3,a2]}}function
  L(d,c){var
  a=0;if(typeof
  d==="number")if(typeof
  c==="number")return 0;else
  switch(c[0]){case
  10:break;case
  11:a=1;break;case
  12:a=2;break;case
  13:a=3;break;case
  14:a=4;break;case
  8:a=5;break;case
  9:a=6;break;default:throw[0,t,kK]}else
  switch(d[0]){case
  0:var
  e=0,u=d[1];if(typeof
  c!=="number")switch(c[0]){case
  0:return[0,L(u,c[1])];case
  8:a=5;e=1;break;case
  9:a=6;e=1;break;case
  10:e=1;break;case
  11:a=1;e=1;break;case
  12:a=2;e=1;break;case
  13:a=3;e=1;break;case
  14:a=4;e=1;break}if(!e)a=7;break;case
  1:var
  f=0,v=d[1];if(typeof
  c!=="number")switch(c[0]){case
  1:return[1,L(v,c[1])];case
  8:a=5;f=1;break;case
  9:a=6;f=1;break;case
  10:f=1;break;case
  11:a=1;f=1;break;case
  12:a=2;f=1;break;case
  13:a=3;f=1;break;case
  14:a=4;f=1;break}if(!f)a=7;break;case
  2:var
  g=0,w=d[1];if(typeof
  c==="number")g=1;else
  switch(c[0]){case
  2:return[2,L(w,c[1])];case
  8:a=5;break;case
  9:a=6;break;case
  10:break;case
  11:a=1;break;case
  12:a=2;break;case
  13:a=3;break;case
  14:a=4;break;default:g=1}if(g)a=7;break;case
  3:var
  h=0,x=d[1];if(typeof
  c==="number")h=1;else
  switch(c[0]){case
  3:return[3,L(x,c[1])];case
  8:a=5;break;case
  9:a=6;break;case
  10:break;case
  11:a=1;break;case
  12:a=2;break;case
  13:a=3;break;case
  14:a=4;break;default:h=1}if(h)a=7;break;case
  4:var
  i=0,y=d[1];if(typeof
  c==="number")i=1;else
  switch(c[0]){case
  4:return[4,L(y,c[1])];case
  8:a=5;break;case
  9:a=6;break;case
  10:break;case
  11:a=1;break;case
  12:a=2;break;case
  13:a=3;break;case
  14:a=4;break;default:i=1}if(i)a=7;break;case
  5:var
  j=0,z=d[1];if(typeof
  c==="number")j=1;else
  switch(c[0]){case
  5:return[5,L(z,c[1])];case
  8:a=5;break;case
  9:a=6;break;case
  10:break;case
  11:a=1;break;case
  12:a=2;break;case
  13:a=3;break;case
  14:a=4;break;default:j=1}if(j)a=7;break;case
  6:var
  k=0,A=d[1];if(typeof
  c==="number")k=1;else
  switch(c[0]){case
  6:return[6,L(A,c[1])];case
  8:a=5;break;case
  9:a=6;break;case
  10:break;case
  11:a=1;break;case
  12:a=2;break;case
  13:a=3;break;case
  14:a=4;break;default:k=1}if(k)a=7;break;case
  7:var
  l=0,B=d[1];if(typeof
  c==="number")l=1;else
  switch(c[0]){case
  7:return[7,L(B,c[1])];case
  8:a=5;break;case
  9:a=6;break;case
  10:break;case
  11:a=1;break;case
  12:a=2;break;case
  13:a=3;break;case
  14:a=4;break;default:l=1}if(l)a=7;break;case
  8:var
  m=0,C=d[2],D=d[1];if(typeof
  c==="number")m=1;else
  switch(c[0]){case
  8:var
  E=c[1],F=L(C,c[2]);return[8,L(D,E),F];case
  10:break;case
  11:a=1;break;case
  12:a=2;break;case
  13:a=3;break;case
  14:a=4;break;default:m=1}if(m)throw[0,t,kT];break;case
  9:var
  n=0,G=d[3],H=d[2],I=d[1];if(typeof
  c==="number")n=1;else
  switch(c[0]){case
  8:a=5;break;case
  9:var
  J=c[3],M=c[2],N=c[1],s=T(L(K(H),N)),O=s[4];b(s[2],0);b(O,0);return[9,I,M,L(G,J)];case
  10:break;case
  11:a=1;break;case
  12:a=2;break;case
  13:a=3;break;case
  14:a=4;break;default:n=1}if(n)throw[0,t,kU];break;case
  10:var
  P=d[1];if(typeof
  c!=="number"&&10===c[0])return[10,L(P,c[1])];throw[0,t,kV];case
  11:var
  o=0,Q=d[1];if(typeof
  c==="number")o=1;else
  switch(c[0]){case
  10:break;case
  11:return[11,L(Q,c[1])];default:o=1}if(o)throw[0,t,kW];break;case
  12:var
  p=0,R=d[1];if(typeof
  c==="number")p=1;else
  switch(c[0]){case
  10:break;case
  11:a=1;break;case
  12:return[12,L(R,c[1])];default:p=1}if(p)throw[0,t,kX];break;case
  13:var
  q=0,S=d[1];if(typeof
  c==="number")q=1;else
  switch(c[0]){case
  10:break;case
  11:a=1;break;case
  12:a=2;break;case
  13:return[13,L(S,c[1])];default:q=1}if(q)throw[0,t,kY];break;default:var
  r=0,U=d[1];if(typeof
  c==="number")r=1;else
  switch(c[0]){case
  10:break;case
  11:a=1;break;case
  12:a=2;break;case
  13:a=3;break;case
  14:return[14,L(U,c[1])];default:r=1}if(r)throw[0,t,kZ]}switch(a){case
  0:throw[0,t,kN];case
  1:throw[0,t,kO];case
  2:throw[0,t,kP];case
  3:throw[0,t,kQ];case
  4:throw[0,t,kR];case
  5:throw[0,t,kL];case
  6:throw[0,t,kM];default:throw[0,t,kS]}}var
  P=[A,k0,bo(0)];function
  c5(b,a){if(typeof
  b==="number")return[0,0,a];else{if(0===b[0])return[0,[0,b[1],b[2]],a];if(typeof
  a!=="number"&&2===a[0])return[0,[1,b[1]],a[1]];throw P}}function
  cf(e,b,d){var
  a=c5(e,d);if(typeof
  b==="number"){if(b){var
  c=a[2];if(typeof
  c!=="number"&&2===c[0])return[0,a[1],1,c[1]];throw P}return[0,a[1],0,a[2]]}return[0,a[1],[0,b[1]],a[2]]}function
  ab(c,d,a){if(typeof
  c==="number")return[0,0,u(d,a)];else
  switch(c[0]){case
  0:if(typeof
  a!=="number"&&0===a[0]){var
  g=ab(c[1],d,a[1]);return[0,[0,g[1]],g[2]]}break;case
  1:if(typeof
  a!=="number"&&1===a[0]){var
  h=ab(c[1],d,a[1]);return[0,[1,h[1]],h[2]]}break;case
  2:if(typeof
  a!=="number"&&2===a[0]){var
  i=ab(c[1],d,a[1]);return[0,[2,i[1]],i[2]]}break;case
  3:if(typeof
  a!=="number"&&3===a[0]){var
  j=ab(c[1],d,a[1]);return[0,[3,j[1]],j[2]]}break;case
  4:if(typeof
  a!=="number"&&4===a[0]){var
  k=ab(c[1],d,a[1]);return[0,[4,k[1]],k[2]]}break;case
  5:if(typeof
  a!=="number"&&5===a[0]){var
  l=ab(c[1],d,a[1]);return[0,[5,l[1]],l[2]]}break;case
  6:if(typeof
  a!=="number"&&6===a[0]){var
  m=ab(c[1],d,a[1]);return[0,[6,m[1]],m[2]]}break;case
  7:if(typeof
  a!=="number"&&7===a[0]){var
  n=ab(c[1],d,a[1]);return[0,[7,n[1]],n[2]]}break;case
  8:if(typeof
  a!=="number"&&8===a[0]){var
  o=a[1],x=a[2],y=c[2];if(bJ([0,c[1]],[0,o]))throw P;var
  p=ab(y,d,x);return[0,[8,o,p[1]],p[2]]}break;case
  9:if(typeof
  a!=="number"&&9===a[0]){var
  e=a[2],f=a[1],z=a[3],A=c[3],B=c[2],D=c[1],E=[0,C(f)];if(bJ([0,C(D)],E))throw P;var
  F=[0,C(e)];if(bJ([0,C(B)],F))throw P;var
  q=T(L(K(f),e)),G=q[4];b(q[2],0);b(G,0);var
  r=ab(C(A),d,z),H=r[2];return[0,[9,f,e,K(r[1])],H]}break;case
  10:if(typeof
  a!=="number"&&10===a[0]){var
  s=ab(c[1],d,a[1]);return[0,[10,s[1]],s[2]]}break;case
  11:if(typeof
  a!=="number"&&11===a[0]){var
  t=ab(c[1],d,a[1]);return[0,[11,t[1]],t[2]]}break;case
  13:if(typeof
  a!=="number"&&13===a[0]){var
  v=ab(c[1],d,a[1]);return[0,[13,v[1]],v[2]]}break;case
  14:if(typeof
  a!=="number"&&14===a[0]){var
  w=ab(c[1],d,a[1]);return[0,[14,w[1]],w[2]]}break}throw P}function
  u(b,a){if(typeof
  b==="number")return[0,0,a];else
  switch(b[0]){case
  0:if(typeof
  a!=="number"&&0===a[0]){var
  s=u(b[1],a[1]);return[0,[0,s[1]],s[2]]}break;case
  1:if(typeof
  a!=="number"&&0===a[0]){var
  t=u(b[1],a[1]);return[0,[1,t[1]],t[2]]}break;case
  2:var
  ae=b[2],v=c5(b[1],a),e=v[2],ag=v[1];if(typeof
  e!=="number"&&1===e[0]){var
  w=u(ae,e[1]);return[0,[2,ag,w[1]],w[2]]}throw P;case
  3:var
  ah=b[2],x=c5(b[1],a),f=x[2],ai=x[1];if(typeof
  f!=="number"&&1===f[0]){var
  y=u(ah,f[1]);return[0,[3,ai,y[1]],y[2]]}throw P;case
  4:var
  aj=b[4],ak=b[1],g=cf(b[2],b[3],a),h=g[3],al=g[1];if(typeof
  h!=="number"&&2===h[0]){var
  am=g[2],z=u(aj,h[1]);return[0,[4,ak,al,am,z[1]],z[2]]}throw P;case
  5:var
  an=b[4],ao=b[1],i=cf(b[2],b[3],a),j=i[3],ap=i[1];if(typeof
  j!=="number"&&3===j[0]){var
  aq=i[2],A=u(an,j[1]);return[0,[5,ao,ap,aq,A[1]],A[2]]}throw P;case
  6:var
  ar=b[4],as=b[1],k=cf(b[2],b[3],a),l=k[3],at=k[1];if(typeof
  l!=="number"&&4===l[0]){var
  au=k[2],B=u(ar,l[1]);return[0,[6,as,at,au,B[1]],B[2]]}throw P;case
  7:var
  av=b[4],aw=b[1],m=cf(b[2],b[3],a),n=m[3],ax=m[1];if(typeof
  n!=="number"&&5===n[0]){var
  ay=m[2],D=u(av,n[1]);return[0,[7,aw,ax,ay,D[1]],D[2]]}throw P;case
  8:var
  az=b[4],aA=b[1],o=cf(b[2],b[3],a),p=o[3],aB=o[1];if(typeof
  p!=="number"&&6===p[0]){var
  aC=o[2],E=u(az,p[1]);return[0,[8,aA,aB,aC,E[1]],E[2]]}throw P;case
  9:var
  aD=b[2],F=c5(b[1],a),q=F[2],aE=F[1];if(typeof
  q!=="number"&&7===q[0]){var
  G=u(aD,q[1]);return[0,[9,aE,G[1]],G[2]]}throw P;case
  10:var
  H=u(b[1],a);return[0,[10,H[1]],H[2]];case
  11:var
  aF=b[1],I=u(b[2],a);return[0,[11,aF,I[1]],I[2]];case
  12:var
  aG=b[1],J=u(b[2],a);return[0,[12,aG,J[1]],J[2]];case
  13:if(typeof
  a!=="number"&&8===a[0]){var
  K=a[1],aH=a[2],aI=b[3],aJ=b[1];if(bJ([0,b[2]],[0,K]))throw P;var
  L=u(aI,aH);return[0,[13,aJ,K,L[1]],L[2]]}break;case
  14:if(typeof
  a!=="number"&&9===a[0]){var
  M=a[1],aK=a[3],aL=b[3],aM=b[2],aN=b[1],aO=[0,C(M)];if(bJ([0,C(aM)],aO))throw P;var
  N=u(aL,C(aK));return[0,[14,aN,M,N[1]],N[2]]}break;case
  15:if(typeof
  a!=="number"&&10===a[0]){var
  O=u(b[1],a[1]);return[0,[15,O[1]],O[2]]}break;case
  16:if(typeof
  a!=="number"&&11===a[0]){var
  Q=u(b[1],a[1]);return[0,[16,Q[1]],Q[2]]}break;case
  17:var
  aP=b[1],R=u(b[2],a);return[0,[17,aP,R[1]],R[2]];case
  18:var
  S=b[2],r=b[1];if(0===r[0]){var
  W=r[1],aT=W[2],X=u(W[1],a),aU=X[1],Y=u(S,X[2]);return[0,[18,[0,[0,aU,aT]],Y[1]],Y[2]]}var
  Z=r[1],aV=Z[2],_=u(Z[1],a),aW=_[1],$=u(S,_[2]);return[0,[18,[1,[0,aW,aV]],$[1]],$[2]];case
  19:if(typeof
  a!=="number"&&13===a[0]){var
  T=u(b[1],a[1]);return[0,[19,T[1]],T[2]]}break;case
  20:if(typeof
  a!=="number"&&1===a[0]){var
  aQ=b[2],aR=b[1],U=u(b[3],a[1]);return[0,[20,aR,aQ,U[1]],U[2]]}break;case
  21:if(typeof
  a!=="number"&&2===a[0]){var
  aS=b[1],V=u(b[2],a[1]);return[0,[21,aS,V[1]],V[2]]}break;case
  23:var
  d=b[2],c=b[1];if(typeof
  c==="number")switch(c){case
  0:return af(c,d,a);case
  1:return af(c,d,a);case
  2:if(typeof
  a!=="number"&&14===a[0]){var
  aa=u(d,a[1]);return[0,[23,2,aa[1]],aa[2]]}throw P;default:return af(c,d,a)}else
  switch(c[0]){case
  0:return af(c,d,a);case
  1:return af(c,d,a);case
  2:return af(c,d,a);case
  3:return af(c,d,a);case
  4:return af(c,d,a);case
  5:return af(c,d,a);case
  6:return af(c,d,a);case
  7:return af(c,d,a);case
  8:return af([8,c[1],c[2]],d,a);case
  9:var
  aX=c[1],ac=ab(c[2],d,a),ad=ac[2];return[0,[23,[9,aX,ac[1]],ad[1]],ad[2]];case
  10:return af(c,d,a);default:return af(c,d,a)}}throw P}function
  af(d,c,b){var
  a=u(c,b);return[0,[23,d,a[1]],a[2]]}function
  ag(k,g,a){var
  b=m(a),h=0<=g?k:0,d=c1(g);if(d<=b)return a;var
  l=2===h?48:32,c=aS(d,l);switch(h){case
  0:aT(a,0,c,0,b);break;case
  1:aT(a,0,c,d-b|0,b);break;default:var
  e=0;if(0<b){var
  i=0;if(43!==G(a,0)&&45!==G(a,0)&&32!==G(a,0)){e=1;i=1}if(!i){a_(c,0,G(a,0));aT(a,1,c,(d-b|0)+1|0,b-1|0)}}else
  e=1;if(e){var
  f=0;if(1<b&&48===G(a,0)){var
  j=0;if(hS!==G(a,1)&&88!==G(a,1)){f=1;j=1}if(!j){a_(c,1,G(a,1));aT(a,2,c,(d-b|0)+2|0,b-2|0)}}else
  f=1;if(f)aT(a,0,c,d-b|0,b)}}return O(c)}function
  bO(k,b){var
  c=c1(k),a=m(b),d=G(b,0),e=0;if(58<=d){if(71<=d){if(!(5<d+iu>>>0))e=1}else
  if(65<=d)e=1}else{var
  f=0;if(32!==d)if(43<=d)switch(d-43|0){case
  5:if(a<(c+2|0)&&1<a){var
  j=0;if(hS===G(b,1)||88===G(b,1))j=1;if(j){var
  h=aS(c+2|0,48);a_(h,1,G(b,1));aT(b,2,h,(c-a|0)+4|0,a-2|0);return O(h)}}e=1;f=1;break;case
  0:case
  2:break;case
  1:case
  3:case
  4:f=1;break;default:e=1;f=1}else
  f=1;if(!f&&a<(c+1|0)){var
  g=aS(c+1|0,48);a_(g,0,d);aT(b,1,g,(c-a|0)+2|0,a-1|0);return O(g)}}if(e&&a<c){var
  i=aS(c,48);aT(b,0,i,c-a|0,a);return O(i)}return b}function
  k1(k){var
  j=0,B=m(k);for(;;){if(B<=j)var
  p=k;else{var
  o=aB(k,j)+iM|0,q=0;if(59<o>>>0){if(33<o-61>>>0)q=1}else
  if(2===o)q=1;if(!q){var
  j=j+1|0;continue}var
  e=aq(k),a=[0,0],s=as(e)-1|0,x=0;if(!(s<0)){var
  i=x;for(;;){var
  f=bE(e,i),g=0;if(32<=f){var
  l=f-34|0,r=0;if(58<l>>>0){if(93<=l)r=1}else
  if(56<l-1>>>0){g=1;r=1}if(!r){var
  n=1;g=2}}else
  if(11<=f){if(13===f)g=1}else
  if(8<=f)g=1;switch(g){case
  0:var
  n=4;break;case
  1:var
  n=2;break}a[1]=a[1]+n|0;var
  A=i+1|0;if(s!==i){var
  i=A;continue}break}}if(a[1]===as(e))var
  u=eh(e);else{var
  b=E(a[1]);a[1]=0;var
  t=as(e)-1|0,y=0;if(!(t<0)){var
  h=y;for(;;){var
  c=bE(e,h),d=0;if(35<=c)if(92===c)d=2;else
  if(dL<=c)d=1;else
  d=3;else
  if(32<=c)if(34<=c)d=2;else
  d=3;else
  if(14<=c)d=1;else
  switch(c){case
  8:F(b,a[1],92);a[1]++;F(b,a[1],98);break;case
  9:F(b,a[1],92);a[1]++;F(b,a[1],116);break;case
  10:F(b,a[1],92);a[1]++;F(b,a[1],110);break;case
  13:F(b,a[1],92);a[1]++;F(b,a[1],114);break;default:d=1}switch(d){case
  1:F(b,a[1],92);a[1]++;F(b,a[1],48+(c/fu|0)|0);a[1]++;F(b,a[1],48+((c/10|0)%10|0)|0);a[1]++;F(b,a[1],48+(c%10|0)|0);break;case
  2:F(b,a[1],92);a[1]++;F(b,a[1],c);break;case
  3:F(b,a[1],c);break}a[1]++;var
  z=h+1|0;if(t!==h){var
  h=z;continue}break}}var
  u=b}var
  p=O(u)}var
  v=m(p),w=aS(v+2|0,34);a9(p,0,w,1,v);return O(w)}}function
  gv(e,g){var
  h=c1(g),f=lQ[1];switch(e[2]){case
  0:var
  b=102;break;case
  1:var
  b=101;break;case
  2:var
  b=69;break;case
  3:var
  b=hT;break;case
  4:var
  b=71;break;case
  5:var
  b=f;break;case
  6:var
  b=104;break;case
  7:var
  b=72;break;default:var
  b=70}var
  c=gr(16);bN(c,37);switch(e[1]){case
  0:break;case
  1:bN(c,43);break;default:bN(c,32)}if(8<=e[2])bN(c,35);bN(c,46);S(c,a(d+h));bN(c,b);return gt(c)}function
  c6(n,a){if(13<=n){var
  g=[0,0],h=m(a)-1|0,o=0;if(!(h<0)){var
  c=o;for(;;){if(!(9<aB(a,c)+hZ>>>0))g[1]++;var
  r=c+1|0;if(h!==c){var
  c=r;continue}break}}var
  i=g[1],j=E(m(a)+((i-1|0)/3|0)|0),k=[0,0],d=function(a){a_(j,k[1],a);k[1]++;return 0},e=[0,((i-1|0)%3|0)+1|0],l=m(a)-1|0,p=0;if(!(l<0)){var
  b=p;for(;;){var
  f=aB(a,b);if(9<f+hZ>>>0)d(f);else{if(0===e[1]){d(95);e[1]=3}e[1]+=-1;d(f)}var
  q=b+1|0;if(l!==b){var
  b=q;continue}break}}return O(j)}return a}function
  lR(b,c){switch(b){case
  1:var
  a=k3;break;case
  2:var
  a=k4;break;case
  4:var
  a=k6;break;case
  5:var
  a=k7;break;case
  6:var
  a=k8;break;case
  7:var
  a=k9;break;case
  8:var
  a=k_;break;case
  9:var
  a=k$;break;case
  10:var
  a=la;break;case
  11:var
  a=lb;break;case
  0:case
  13:var
  a=k2;break;case
  3:case
  14:var
  a=k5;break;default:var
  a=lc}return c6(b,d3(a,c))}function
  lS(b,c){switch(b){case
  1:var
  a=lr;break;case
  2:var
  a=ls;break;case
  4:var
  a=lu;break;case
  5:var
  a=lv;break;case
  6:var
  a=lw;break;case
  7:var
  a=lx;break;case
  8:var
  a=ly;break;case
  9:var
  a=lz;break;case
  10:var
  a=lA;break;case
  11:var
  a=lB;break;case
  0:case
  13:var
  a=lq;break;case
  3:case
  14:var
  a=lt;break;default:var
  a=lC}return c6(b,d3(a,c))}function
  lT(b,c){switch(b){case
  1:var
  a=lE;break;case
  2:var
  a=lF;break;case
  4:var
  a=lH;break;case
  5:var
  a=lI;break;case
  6:var
  a=lJ;break;case
  7:var
  a=lK;break;case
  8:var
  a=lL;break;case
  9:var
  a=lM;break;case
  10:var
  a=lN;break;case
  11:var
  a=lO;break;case
  0:case
  13:var
  a=lD;break;case
  3:case
  14:var
  a=lG;break;default:var
  a=lP}return c6(b,d3(a,c))}function
  lU(b,c){switch(b){case
  1:var
  a=le;break;case
  2:var
  a=lf;break;case
  4:var
  a=lh;break;case
  5:var
  a=li;break;case
  6:var
  a=lj;break;case
  7:var
  a=lk;break;case
  8:var
  a=ll;break;case
  9:var
  a=lm;break;case
  10:var
  a=ln;break;case
  11:var
  a=lo;break;case
  0:case
  13:var
  a=ld;break;case
  3:case
  14:var
  a=lg;break;default:var
  a=lp}return c6(b,xS(a,c))}function
  aV(b,e,a){function
  f(d){switch(b[1]){case
  0:var
  c=45;break;case
  1:var
  c=43;break;default:var
  c=32}return xO(a,e,c)}function
  k(c){var
  b=xC(a);return 3===b?a<0.?lW:lX:4<=b?lY:c}switch(b[2]){case
  5:var
  d=fQ(gv(b,e),a),c=0,l=m(d);for(;;){if(c===l)var
  j=0;else{var
  h=G(d,c)-46|0,i=0;if(23<h>>>0){if(55===h)i=1}else
  if(21<h-1>>>0)i=1;if(!i){var
  c=c+1|0;continue}var
  j=1}var
  n=j?d:g(d,lV);return k(n)}case
  6:return f(0);case
  7:return O(ej(jL,aq(f(0))));case
  8:return k(f(0));default:return fQ(gv(b,e),a)}}function
  cj(e,I,H,G){var
  c=I,a=H,d=G;for(;;)if(typeof
  d==="number")return b(c,a);else
  switch(d[0]){case
  0:var
  J=d[1];return function(b){return p(c,[5,a,b],J)};case
  1:var
  L=d[1];return function(b){var
  e=0;if(40<=b)if(92===b)var
  d=jE;else
  if(dL<=b)e=1;else
  e=2;else
  if(32<=b)if(39<=b)var
  d=jF;else
  e=2;else
  if(14<=b)e=1;else
  switch(b){case
  8:var
  d=jG;break;case
  9:var
  d=jH;break;case
  10:var
  d=jI;break;case
  13:var
  d=jJ;break;default:e=1}switch(e){case
  1:var
  f=E(4);F(f,0,92);F(f,1,48+(b/fu|0)|0);F(f,2,48+((b/10|0)%10|0)|0);F(f,3,48+(b%10|0)|0);var
  d=O(f);break;case
  2:var
  g=E(1);F(g,0,b);var
  d=O(g);break}var
  h=m(d),i=aS(h+2|0,39);a9(d,0,i,1,h);return p(c,[4,a,O(i)],L)};case
  2:var
  M=d[2],N=d[1];return er(c,a,M,N,function(a){return a});case
  3:return er(c,a,d[2],d[1],k1);case
  4:return c7(c,a,d[4],d[2],d[3],lR,d[1]);case
  5:return c7(c,a,d[4],d[2],d[3],lS,d[1]);case
  6:return c7(c,a,d[4],d[2],d[3],lT,d[1]);case
  7:return c7(c,a,d[4],d[2],d[3],lU,d[1]);case
  8:var
  i=d[4],j=d[3],k=d[2],h=d[1];if(typeof
  k==="number"){if(typeof
  j==="number")return j?function(d,b){return p(c,[4,a,aV(h,d,b)],i)}:function(b){return p(c,[4,a,aV(h,ep(h),b)],i)};var
  ae=j[1];return function(b){return p(c,[4,a,aV(h,ae,b)],i)}}else{if(0===k[0]){var
  q=k[2],r=k[1];if(typeof
  j==="number")return j?function(d,b){return p(c,[4,a,ag(r,q,aV(h,d,b))],i)}:function(b){return p(c,[4,a,ag(r,q,aV(h,ep(h),b))],i)};var
  af=j[1];return function(b){return p(c,[4,a,ag(r,q,aV(h,af,b))],i)}}var
  v=k[1];if(typeof
  j==="number")return j?function(e,d,b){return p(c,[4,a,ag(v,e,aV(h,d,b))],i)}:function(d,b){return p(c,[4,a,ag(v,d,aV(h,ep(h),b))],i)};var
  ah=j[1];return function(d,b){return p(c,[4,a,ag(v,d,aV(h,ah,b))],i)}}case
  9:return er(c,a,d[2],d[1],ju);case
  10:var
  a=[7,a],d=d[1];continue;case
  11:var
  a=[2,a,d[1]],d=d[2];continue;case
  12:var
  a=[3,a,d[1]],d=d[2];continue;case
  13:var
  Q=d[3],R=d[2],w=gr(16);eq(w,R);var
  D=gt(w);return function(b){return p(c,[4,a,D],Q)};case
  14:var
  S=d[3],T=d[2];return function(d){var
  e=d[1],b=u(e,C(K(T)));if(typeof
  b[2]==="number")return p(c,a,x(b[1],S));throw P};case
  15:var
  U=d[1];return function(d,b){return p(c,[6,a,function(a){return f(d,a,b)}],U)};case
  16:var
  V=d[1];return function(b){return p(c,[6,a,b],V)};case
  17:var
  a=[0,a,d[1]],d=d[2];continue;case
  18:var
  n=d[1];if(0===n[0]){var
  W=d[2],X=n[1][1],Y=0,c=function(b,c,d){return function(a){return p(c,[1,b,[0,a]],d)}}(a,c,W),a=Y,d=X;continue}var
  Z=d[2],_=n[1][1],$=0,c=function(b,c,d){return function(a){return p(c,[1,b,[1,a]],d)}}(a,c,Z),a=$,d=_;continue;case
  19:throw[0,t,l0];case
  20:var
  aa=d[3],ab=[8,a,l1];return function(a){return p(c,ab,aa)};case
  21:var
  ac=d[2];return function(b){return p(c,[4,a,d3(l2,b)],ac)};case
  22:var
  ad=d[1];return function(b){return p(c,[5,a,b],ad)};case
  23:var
  g=d[2],l=d[1];if(typeof
  l==="number")switch(l){case
  0:return e<50?s(e+1|0,c,a,g):o(s,[0,c,a,g]);case
  1:return e<50?s(e+1|0,c,a,g):o(s,[0,c,a,g]);case
  2:throw[0,t,l3];default:return e<50?s(e+1|0,c,a,g):o(s,[0,c,a,g])}else
  switch(l[0]){case
  0:return e<50?s(e+1|0,c,a,g):o(s,[0,c,a,g]);case
  1:return e<50?s(e+1|0,c,a,g):o(s,[0,c,a,g]);case
  2:return e<50?s(e+1|0,c,a,g):o(s,[0,c,a,g]);case
  3:return e<50?s(e+1|0,c,a,g):o(s,[0,c,a,g]);case
  4:return e<50?s(e+1|0,c,a,g):o(s,[0,c,a,g]);case
  5:return e<50?s(e+1|0,c,a,g):o(s,[0,c,a,g]);case
  6:return e<50?s(e+1|0,c,a,g):o(s,[0,c,a,g]);case
  7:return e<50?s(e+1|0,c,a,g):o(s,[0,c,a,g]);case
  8:return e<50?s(e+1|0,c,a,g):o(s,[0,c,a,g]);case
  9:var
  B=l[2];return e<50?eX(e+1|0,c,a,B,g):o(eX,[0,c,a,B,g]);case
  10:return e<50?s(e+1|0,c,a,g):o(s,[0,c,a,g]);default:return e<50?s(e+1|0,c,a,g):o(s,[0,c,a,g])}default:var
  y=d[3],z=d[1],A=b(d[2],0);return e<50?eW(e+1|0,c,a,y,z,A):o(eW,[0,c,a,y,z,A])}}function
  eX(e,d,c,a,b){if(typeof
  a==="number")return e<50?s(e+1|0,d,c,b):o(s,[0,d,c,b]);else
  switch(a[0]){case
  0:var
  f=a[1];return function(a){return am(d,c,f,b)};case
  1:var
  g=a[1];return function(a){return am(d,c,g,b)};case
  2:var
  h=a[1];return function(a){return am(d,c,h,b)};case
  3:var
  i=a[1];return function(a){return am(d,c,i,b)};case
  4:var
  j=a[1];return function(a){return am(d,c,j,b)};case
  5:var
  k=a[1];return function(a){return am(d,c,k,b)};case
  6:var
  l=a[1];return function(a){return am(d,c,l,b)};case
  7:var
  m=a[1];return function(a){return am(d,c,m,b)};case
  8:var
  n=a[2];return function(a){return am(d,c,n,b)};case
  9:var
  p=a[3],q=a[2],r=L(K(a[1]),q);return function(a){return am(d,c,Y(r,p),b)};case
  10:var
  u=a[1];return function(e,a){return am(d,c,u,b)};case
  11:var
  v=a[1];return function(a){return am(d,c,v,b)};case
  12:var
  w=a[1];return function(a){return am(d,c,w,b)};case
  13:throw[0,t,l4];default:throw[0,t,l5]}}function
  s(d,b,e,a){var
  c=[8,e,l6];return d<50?cj(d+1|0,b,c,a):o(cj,[0,b,c,a])}function
  eW(h,c,f,a,e,d){if(e){var
  i=e[1];return function(e){return lZ(c,f,a,i,b(d,e))}}var
  g=[4,f,d];return h<50?cj(h+1|0,c,g,a):o(cj,[0,c,g,a])}function
  p(a,b,c){return cW(cj(0,a,b,c))}function
  am(a,b,c,d){return cW(eX(0,a,b,c,d))}function
  lZ(a,b,c,d,e){return cW(eW(0,a,b,c,d,e))}function
  er(f,e,d,a,c){if(typeof
  a==="number")return function(a){return p(f,[4,e,b(c,a)],d)};else{if(0===a[0]){var
  g=a[2],h=a[1];return function(a){return p(f,[4,e,ag(h,g,b(c,a))],d)}}var
  i=a[1];return function(g,a){return p(f,[4,e,ag(i,g,b(c,a))],d)}}}function
  c7(g,e,d,h,c,b,a){if(typeof
  h==="number"){if(typeof
  c==="number")return c?function(h,c){return p(g,[4,e,bO(h,f(b,a,c))],d)}:function(c){return p(g,[4,e,f(b,a,c)],d)};var
  l=c[1];return function(c){return p(g,[4,e,bO(l,f(b,a,c))],d)}}else{if(0===h[0]){var
  i=h[2],j=h[1];if(typeof
  c==="number")return c?function(h,c){return p(g,[4,e,ag(j,i,bO(h,f(b,a,c)))],d)}:function(c){return p(g,[4,e,ag(j,i,f(b,a,c))],d)};var
  m=c[1];return function(c){return p(g,[4,e,ag(j,i,bO(m,f(b,a,c)))],d)}}var
  k=h[1];if(typeof
  c==="number")return c?function(i,h,c){return p(g,[4,e,ag(k,i,bO(h,f(b,a,c)))],d)}:function(h,c){return p(g,[4,e,ag(k,h,f(b,a,c))],d)};var
  n=c[1];return function(h,c){return p(g,[4,e,ag(k,h,bO(n,f(b,a,c)))],d)}}}function
  aW(c,f){var
  a=f;for(;;)if(typeof
  a==="number")return 0;else
  switch(a[0]){case
  0:var
  g=a[1],h=gu(a[2]);aW(c,g);return bK(c,h);case
  1:var
  d=a[2],e=a[1];if(0===d[0]){var
  i=d[1];aW(c,e);bK(c,l7);var
  a=i;continue}var
  j=d[1];aW(c,e);bK(c,l8);var
  a=j;continue;case
  6:var
  m=a[2];aW(c,a[1]);return b(m,c);case
  7:aW(c,a[1]);return aP(c);case
  8:var
  n=a[2];aW(c,a[1]);return I(n);case
  2:case
  4:var
  k=a[2];aW(c,a[1]);return bK(c,k);default:var
  l=a[2];aW(c,a[1]);return fZ(c,l)}}function
  bc(c,g){var
  a=g;for(;;)if(typeof
  a==="number")return 0;else
  switch(a[0]){case
  0:var
  h=a[1],i=gu(a[2]);bc(c,h);return bM(c,i);case
  1:var
  e=a[2],f=a[1];if(0===e[0]){var
  j=e[1];bc(c,f);bM(c,l9);var
  a=j;continue}var
  k=e[1];bc(c,f);bM(c,l_);var
  a=k;continue;case
  6:var
  n=a[2];bc(c,a[1]);return bM(c,b(n,0));case
  7:var
  a=a[1];continue;case
  8:var
  o=a[2];bc(c,a[1]);return I(o);case
  2:case
  4:var
  l=a[2];bc(c,a[1]);return bM(c,l);default:var
  m=a[2];bc(c,a[1]);var
  d=c[2];if(c[3]<=d)gq(c,1);F(c[1],d,m);c[2]=d+1|0;return 0}}function
  gw(d,c){var
  a=c[1],b=0;return p(function(a){aW(d,a);return 0},b,a)}function
  es(a){return gw(aQ,a)}function
  aE(b){var
  a=b[1];return p(function(b){var
  a=go(64);bc(a,b);return gp(a)},0,a)}var
  c8=[0,0];function
  eu(j,i){var
  a=j[1+i];if(1-(typeof
  a==="number"?1:0)){if(ba(a)===dS)return b(aE(l$),a);if(ba(a)===253){var
  d=fQ(jz,a),c=0,h=m(d);for(;;){if(h<=c)return g(d,jy);var
  e=G(d,c),f=0;if(48<=e){if(!(58<=e))f=1}else
  if(45===e)f=1;if(f){var
  c=c+1|0;continue}return d}}return ma}return b(aE(mb),a)}function
  gx(b,a){if(b.length-1<=a)return mc;var
  c=gx(b,a+1|0),d=eu(b,a);return f(aE(md),d,c)}function
  ev(a){function
  q(f){var
  c=f;for(;;){if(c){var
  g=c[2],h=c[1];try{var
  e=0,d=b(h,a);e=1}catch(a){}if(e&&d)return[0,d[1]];var
  c=g;continue}return 0}}var
  j=q(c8[1]);if(j)return j[1];if(a===eb)return mi;if(a===f6)return mj;if(a[1]===f5){var
  d=a[2],k=d[3],r=d[2],s=d[1];return cl(aE(et),s,r,k,k+5|0,mk)}if(a[1]===t){var
  e=a[2],l=e[3],u=e[2],v=e[1];return cl(aE(et),v,u,l,l+6|0,ml)}if(a[1]===f8){var
  h=a[2],m=h[3],w=h[2],x=h[1];return cl(aE(et),x,w,m,m+6|0,mm)}if(0===ba(a)){var
  i=a.length-1,y=a[1][1];if(2<i>>>0)var
  n=gx(a,2),o=eu(a,1),c=f(aE(me),o,n);else
  switch(i){case
  0:var
  c=mf;break;case
  1:var
  c=mg;break;default:var
  p=eu(a,1),c=b(aE(mh),p)}return g(y,c)}return a[1]}function
  ew(t,s){var
  e=xD(s),g=e.length-1-1|0,p=0;if(!(g<0)){var
  c=p;for(;;){var
  a=B(e,c)[1+c],f=function(a){return function(b){return b?0===a?mn:mo:0===a?mp:mq}}(c);if(0===a[0])var
  h=a[5],i=a[4],j=a[3],k=a[6]?mr:mt,l=a[2],m=a[7],n=f(a[1]),d=[0,xs(aE(ms),n,m,l,k,j,i,h)];else
  if(a[1])var
  d=0;else
  var
  o=f(0),d=[0,b(aE(mu),o)];if(d){var
  q=d[1];b(gw(t,mv),q)}var
  r=c+1|0;if(g!==c){var
  c=r;continue}break}}return 0}function
  gy(c){for(;;){var
  a=c8[1],d=[0,c,a],e=c8[1]===a?(c8[1]=d,1):0,b=1-e;if(b)continue;return b}}var
  mx=mw.slice();function
  my(e,d){var
  f=ev(e);b(es(mz),f);ew(aQ,d);var
  a=ya(0);if(a<0){var
  c=c1(a);f9(B(mx,c)[1+c])}return aP(aQ)}var
  mA=[0];f3(a(hV),function(e,i){try{try{var
  c=i?mA:jb(0);try{ed(0)}catch(a){}try{var
  a=my(e,c),d=a}catch(a){a=H(a);var
  g=ev(e);b(es(mC),g);ew(aQ,c);var
  h=ev(a);b(es(mD),h);ew(aQ,jb(0));var
  d=aP(aQ)}var
  f=d}catch(a){a=H(a);if(a!==eb)throw a;var
  f=f9(mB)}return f}catch(a){return 0}});try{var
  xm=jp(xl),gA=xm}catch(a){a=H(a);if(a!==q)throw a;try{var
  xk=jp(xj),gz=xk}catch(a){a=H(a);if(a!==q)throw a;var
  gz=mF}var
  gA=gz}var
  mG=gi(gA,82),c9=[aj,function(z){var
  p=yr(0),c=[0,bp(55,0),0],k=0===p.length-1?[0,0]:p,l=k.length-1,b=0;for(;;){B(c[1],b)[1+b]=b;var
  y=b+1|0;if(54!==b){var
  b=y;continue}var
  i=[0,mE],n=54+gc(55,l)|0,u=0;if(!(n<0)){var
  e=u;for(;;){var
  f=e%55|0,o=ye(e,l),v=B(k,o)[1+o],j=g(i[1],a(d+v));i[1]=x_(j,0,m(j));var
  h=i[1],q=G(h,3)<<24,r=G(h,2)<<16,s=G(h,1)<<8,t=((G(h,0)+s|0)+r|0)+q|0,w=(B(c[1],f)[1+f]^t)&fc;B(c[1],f)[1+f]=w;var
  x=e+1|0;if(n!==e){var
  e=x;continue}break}}c[2]=0;return c}}];function
  ex(a,b){return 4<=a.length-1?xI(10,fu,a[3],b)&(a[2].length-1-1|0):I(mH)}function
  gB(f,b){var
  g=ex(f,b),c=B(f[2],g)[1+g];if(c){var
  d=c[3],j=c[2];if(0===b7(b,c[1]))return j;if(d){var
  e=d[3],k=d[2];if(0===b7(b,d[1]))return k;if(e){var
  l=e[2],m=e[3];if(0===b7(b,e[1]))return l;var
  a=m;for(;;){if(a){var
  h=a[2],i=a[3];if(0===b7(b,a[1]))return h;var
  a=i;continue}throw q}}throw q}throw q}throw q}function
  mI(b,a){var
  c=ba(a)===A?a:a[1];return f3(b,c)}var
  mJ=2;function
  mK(c){var
  a=[0,0],d=m(c)-1|0,e=0;if(!(d<0)){var
  b=e;for(;;){var
  g=G(c,b);a[1]=(223*a[1]|0)+g|0;var
  h=b+1|0;if(d!==b){var
  b=h;continue}break}}a[1]=a[1]&2147483647;var
  f=fc<a[1]?a[1]+2147483648|0:a[1];return f}var
  ey=em([0,d9]),c_=em([0,d9]),c$=em([0,je]),gC=jj(0,0),mL=[0,0];function
  gD(a){return 2<a?gD((a+1|0)/2|0)*2|0:a}function
  gE(d){mL[1]++;var
  b=d.length-1,c=bp((b*2|0)+2|0,gC);B(c,0)[1]=b;var
  g=((gD(b)*32|0)/8|0)-1|0;B(c,1)[2]=g;var
  e=b-1|0,h=0;if(!(e<0)){var
  a=h;for(;;){var
  f=(a*2|0)+3|0,i=B(d,a)[1+a];B(c,f)[1+f]=i;var
  j=a+1|0;if(e!==a){var
  a=j;continue}break}}return[0,mJ,c,c_[1],c$[1],0,0,ey[1],0]}function
  ez(b,d){var
  a=b[2].length-1,e=a<d?1:0;if(e){var
  c=bp(d,gC),f=b[2],h=0;if(0<=a&&!((f.length-1-a|0)<0)&&!((c.length-1-a|0)<0)){xx(f,0,c,0,a);h=1}if(!h)I(j1);b[2]=c;var
  g=0}else
  var
  g=e;return g}var
  gF=[0,0],mM=[0,0];function
  mN(a){var
  b=a[2].length-1;ez(a,b+1|0);return b}function
  mO(a,d){try{var
  b=f(c_[28],d,a[3]);return b}catch(b){b=H(b);if(b===q){var
  c=mN(a);a[3]=aH(c_[4],d,c,a[3]);a[4]=aH(c$[4],c,1,a[4]);return c}throw b}}function
  mP(a){var
  b=a[1];a[1]=b+1|0;return b}function
  mQ(a,c){try{var
  b=f(ey[28],c,a[7]);return b}catch(b){b=H(b);if(b===q){var
  d=mP(a);if(h(c,mR))a[7]=aH(ey[4],c,d,a[7]);return d}throw b}}function
  mS(b,a){var
  c=m(b);return c<a?mT:aC(b,a,c-a|0)}var
  mU=34;function
  mX(a){var
  d=0;for(;;){var
  c=aU(aX,d,a);if(7<c>>>0){b(a[1],a);var
  d=c;continue}switch(c){case
  0:return 0;case
  1:return 3;case
  2:return 6;case
  3:var
  e=J(a);return[0,aC(e,1,m(e)-1|0)];case
  4:var
  f=J(a);return[1,aC(f,2,m(f)-2|0)];case
  5:return m1;case
  6:return 13;default:return[2,J(a)]}}}function
  gG(a){var
  d=33;for(;;){var
  c=aU(aX,d,a);if(9<c>>>0){b(a[1],a);var
  d=c;continue}switch(c){case
  0:return 9;case
  1:return 10;case
  2:return[3,m(J(a))];case
  3:return[4,J(a)];case
  4:return 11;case
  5:return 12;case
  6:return 12;case
  7:return[5,J(a)];case
  8:return 13;default:return 12}}}function
  m0(a){var
  c=55;for(;;){var
  d=aU(aX,c,a);if(0===d)return el(a,a[5],a[6]-1|0);b(a[1],a);var
  c=d;continue}}function
  mZ(a){var
  c=53;for(;;){var
  d=aU(aX,c,a);if(0===d)return el(a,a[5],a[6]-1|0);b(a[1],a);var
  c=d;continue}}var
  aF=[A,m3,bo(0)],gH=[A,m4,bo(0)];function
  mY(a,e){var
  d=e;for(;;){var
  c=aU(aX,d,a);if(7<c>>>0){b(a[1],a);var
  d=c;continue}switch(c){case
  0:return 9;case
  1:return 10;case
  2:return[3,m(J(a))];case
  3:try{var
  f=[5,mZ(a)];return f}catch(a){return 12}case
  4:try{var
  g=[5,m0(a)];return g}catch(a){return 12}case
  5:return[5,J(a)];case
  6:return 13;default:return 12}}}function
  bd(b,a){return[0,fs,[0,b,a]]}var
  nv=[0,nu,[0,nt,[0,ns,[0,nr,[0,nq,[0,np,[0,no,[0,nn,[0,nm,[0,nl,[0,nk,[0,nj,[0,ni,[0,nh,[0,ng,[0,nf,[0,ne,[0,nd,[0,nc,[0,nb,[0,na,[0,m$,[0,m_,[0,m9,[0,m8,[0,[0,m7,[0,j,bd(i,m6)]],m5]]]]]]]]]]]]]]]]]]]]]]]]]],nC=[0,nB,[0,nA,[0,nz,[0,ny,[0,[0,nx,[0,j,bd(i,nw)]],nv]]]]],nH=[0,nG,[0,nF,[0,[0,nE,[0,n,bd(i,nD)]],nC]]],nL=[0,[0,nK,[0,n,[0,R,[0,nJ,bd(i,nI)]]]],nH],ob=[0,oa,[0,n$,[0,n_,[0,n9,[0,n8,[0,n7,[0,n6,[0,n5,[0,n4,[0,n3,[0,n2,[0,n1,[0,n0,[0,nZ,[0,nY,[0,nX,[0,nW,[0,[0,nV,[0,n,[0,R,[0,gI,nU]]]],[0,[0,nT,[0,n,[0,R,[0,gI,nS]]]],[0,nR,[0,nQ,[0,nP,[0,nO,[0,[0,nN,[0,n,bd(i,nM)]],nL]]]]]]]]]]]]]]]]]]]]]]]],of=[0,oe,[0,[0,od,[0,c,bd(i,oc)]],ob]],oj=[0,oi,[0,[0,oh,[0,c,bd(i,og)]],of]],eA=[0,oK,[0,oJ,[0,oI,[0,oH,[0,oG,[0,oF,[0,oE,[0,oD,[0,oC,[0,oB,[0,oA,[0,oz,[0,oy,[0,ox,[0,ow,[0,ov,[0,ou,[0,ot,[0,os,[0,or,[0,oq,[0,op,[0,oo,[0,on,[0,om,[0,[0,ol,[0,c,bd(i,ok)]],oj]]]]]]]]]]]]]]]]]]]]]]]]]];function
  oL(a){function
  b(a){if(typeof
  a==="number"){if(c===a)return i}else
  if(R===a[1]){var
  d=a[2],e=d[1];return[0,R,[0,e,b(d[2])]]}return a}return at(function(d){var
  e=d[2],f=e[2],a=e[1],g=d[1];return c===a?[0,g,[0,a,b(f)]]:[0,g,[0,a,f]]},a)}function
  oM(a,f){return at(function(b){var
  c=b[2],d=c[2],e=c[1],a=b[1];if(n===e&&gb(a,f))return[0,a,[0,a2,d]];return[0,a,[0,e,d]]},a)}oM(oL(eA),oN);function
  oO(c){var
  e=oP;a:for(;;){var
  f=17;for(;;){var
  d=aU(aX,f,c);if(3<d>>>0){b(c[1],c);var
  f=d;continue}switch(d){case
  0:var
  a=1;break;case
  1:var
  a=2;break;case
  2:var
  a=13;break;default:var
  a=2}if(2===a){var
  e=g(e,J(c));continue a}if(13<=a)throw aF;return e}}}function
  gJ(a){var
  e=23;for(;;){var
  d=aU(aX,e,a);if(2<d>>>0){b(a[1],a);var
  e=d;continue}switch(d){case
  0:var
  c=4;break;case
  1:var
  c=13;break;default:var
  c=5}if(5===c){var
  f=J(a);return g(f,gJ(a))}if(13<=c)throw aF;return oQ}}function
  gK(c){var
  e=27;for(;;){var
  d=aU(aX,e,c);if(4<d>>>0){b(c[1],c);var
  e=d;continue}switch(d){case
  0:var
  a=7;break;case
  1:var
  a=7;break;case
  2:var
  a=13;break;case
  3:var
  a=8;break;default:var
  a=8}if(8===a){var
  f=J(c);return g(f,gK(c))}if(13<=a)throw aF;return oR}}function
  oS(k){var
  c=16,l=bs(k);for(;;){if(!(l<=c)&&!(ee<(c*2|0))){var
  c=c*2|0;continue}if(mG){var
  i=ba(c9),b=bg===i?c9[1]:aj===i?ca(c9):c9;b[2]=(b[2]+1|0)%55|0;var
  d=b[2],e=B(b[1],d)[1+d],f=(b[2]+24|0)%55|0,g=(B(b[1],f)[1+f]+(e^(e>>>25|0)&31)|0)&fc,h=b[2];B(b[1],h)[1+h]=g;var
  j=g}else
  var
  j=0;var
  a=[0,0,bp(c,0),j,c];bL(function(v){var
  w=v[1],H=v[2],f=ex(a,w),G=[0,w,H,B(a[2],f)[1+f]];B(a[2],f)[1+f]=G;a[1]=a[1]+1|0;var
  u=a[2].length-1<<1<a[1]?1:0;if(u){var
  i=a[2],s=(i.length-1)*2|0,t=s<ee?1:0;if(t){var
  j=bp(s,0),x=a.length-1<4?1:0,y=x||(a[4]<0?1:0),k=1-y;a[2]=j;var
  l=j.length-1,g=bp(l,0),o=i.length-1-1|0,C=0;if(!(o<0)){var
  e=C;a:for(;;){var
  b=B(i,e)[1+e];for(;;){if(b){var
  m=b[1],z=b[2],A=b[3],h=k?b:[0,m,z,0],c=ex(a,m),n=B(g,c)[1+c];if(n)n[3]=h;else
  B(j,c)[1+c]=h;B(g,c)[1+c]=h;var
  b=A;continue}var
  F=e+1|0;if(o!==e){var
  e=F;continue a}break}break}}if(k){var
  p=l-1|0,D=0;if(!(p<0)){var
  d=D;for(;;){var
  r=B(g,d)[1+d];if(r)r[3]=0;var
  E=d+1|0;if(p!==d){var
  d=E;continue}break}}var
  q=0}else
  var
  q=k;return q}return t}return u},k);return a}}var
  eB=gm([0,d9]);function
  oT(M,L,K,I,G,j){var
  X=M?M[1]:eA,Y=L?L[1]:0,Z=K?K[1]:0,_=I?I[1]:0,$=G?G[1]:0,d=[0,oU],k=[0,0],a=[0,0],p=[0,eB[1]],r=gn(0),N=oS(X),l=$?function(a){return a}:jZ;function
  u(a){if(e(a,oV))return oW;function
  b(a){var
  b=a[2];if(typeof
  b!=="number"&&R===b[1])return[0,a[1],b[2][2]];return a}try{var
  c=b(gB(N,a));return c}catch(a){a=H(a);if(a===q)return oX;throw a}}function
  ac(k,j,e){var
  b=u(e)[1];function
  d(o){var
  a=o;for(;;){if(typeof
  a==="number"){if(e3<=a){if(b3<=a){if(i<=a){var
  g=c===b?1:0;if(g)var
  h=g;else
  var
  p=n===b?1:0,h=p||(a2===b?1:0);return h}return 0}return v<=a?0:1}if(c<=a)return c===b?1:0;var
  q=n===b?1:0,r=q||(a2===b?1:0);return r}var
  f=a[1];if(fs<=f){if(R<=f)throw[0,t,oZ];var
  j=a[2],s=j[2],k=d(j[1]);if(k)return k;var
  a=s;continue}if(-260921543<=f){var
  l=a[2],u=l[2],m=d(l[1]),w=m?1-d(u):m;return w}return gb(e,a[2])}}var
  a=bu===b?1:0;if(a)var
  g=a;else{var
  h=1-f(eB[3],e,j);if(h)return d(u(k)[2]);var
  g=h}return g}function
  z(e){var
  c=gn(0),f=d[1],g=k[1],h=a[1],i=p[1];try{for(;;){if(ac(d[1],p[1],e)){var
  j=0;return j}if(a2===u(d[1])[1])throw en;var
  b=ce(r);eo(b,c);var
  l=b[4],m=b[3],n=b[2],o=b[1],q=D(a[1]),s=[0,[0,d[1],k[1],q]];d[1]=o;k[1]=n;p[1]=l;a[1]=[0,s,m];continue}}catch(b){b=H(b);if(b===en)for(;;){if(0<c[2]){eo(ce(c),r);continue}d[1]=f;k[1]=g;a[1]=h;p[1]=i;return 0}throw b}}function
  A(a){function
  b(b){for(;;){var
  a=b?mY(j,44):gG(j);if(typeof
  a!=="number"&&3===a[0])continue;return a}}function
  e(j){var
  c=j;for(;;){if(typeof
  c==="number")switch(c){case
  9:return o0;case
  10:return o1;case
  13:throw aF}else
  if(4===c[0]){var
  a=c[1],f=b(0);if(typeof
  f==="number")switch(f){case
  9:var
  o=l(a);return[0,[0,[0,l(a),o],0],0];case
  10:var
  p=l(a);return[0,[0,[0,l(a),p],0],1];case
  11:var
  d=b(1);if(typeof
  d==="number")switch(d){case
  9:return o2;case
  10:return o3;case
  13:throw aF}else
  switch(d[0]){case
  4:var
  q=d[1],h=e(b(0)),r=h[2],s=h[1];return[0,[0,[0,l(a),q],s],r];case
  5:var
  t=d[1],i=e(b(0)),u=i[2],v=i[1];return[0,[0,[0,l(a),t],v],u]}var
  c=b(0);continue;case
  13:throw aF}var
  g=e(f),k=g[2],m=g[1],n=l(a);return[0,[0,[0,l(a),n],m],k]}var
  c=b(0);continue}}return e(b(0))}function
  B(d){a:for(;;){var
  f=11;for(;;){var
  c=aU(aX,f,j);if(3<c>>>0){b(j[1],j);var
  f=c;continue}switch(c){case
  0:var
  h=J(j),a=[1,aC(h,2,m(h)-2|0)];break;case
  1:var
  a=m2;break;case
  2:var
  a=13;break;default:var
  a=[2,J(j)]}if(typeof
  a==="number"){if(13===a)throw aF}else
  switch(a[0]){case
  1:var
  i=a[1];return e(l(i),d)?o4:g(o5,g(i,B(d)));case
  2:var
  k=a[1];return g(k,B(d))}continue a}}}function
  O(b){for(;;){var
  a=gG(j);if(typeof
  a==="number")if(11<=a){if(13<=a)throw aF}else
  if(9<=a)return 0;continue}}try{a:for(;;){var
  s=mX(j);if(typeof
  s==="number")switch(s){case
  0:var
  ad=oO(j);if(_)a[1]=[0,[0,[0,o7,[0,[0,o6,ad],0],0]],a[1]];continue;case
  3:var
  ae=gJ(j);if(Y)a[1]=[0,[0,[0,o9,[0,[0,o8,ae],0],0]],a[1]];continue;case
  6:var
  af=gK(j);if(Z)a[1]=[0,[0,[0,o$,[0,[0,o_,af],0],0]],a[1]];continue;case
  13:throw aF}else
  switch(s[0]){case
  0:var
  o=l(s[1]),P=u(o)[2];if(v===P){var
  ag=A(0)[1];z(o);a[1]=[0,[0,[0,o,ag,0]],a[1]];continue}if(b3===P){var
  Q=A(0),ah=Q[2],ai=Q[1];z(o);if(ah)var
  S=pa;else{var
  aj=B(o);O(0);var
  S=aj}a[1]=[0,[0,[0,o,ai,[0,[1,S],0]]],a[1]];continue}var
  T=A(0),U=T[1],ak=T[2];z(o);if(ak)a[1]=[0,[0,[0,o,U,0]],a[1]];else{if(e(o,oY))var
  C=0;else{var
  aa=function(b){var
  a=b[2];if(typeof
  a!=="number"&&R===a[1])return a[2][1];return 0};try{var
  ab=aa(gB(N,o)),C=ab}catch(a){a=H(a);if(a!==q)throw a;var
  C=0,aB=a}}eo([0,d[1],k[1],a[1],p[1]],r);d[1]=o;k[1]=U;a[1]=0;bL(function(a){p[1]=f(eB[4],a,p[1]);return 0},C)}continue;case
  1:var
  E=l(s[1]);O(0);var
  V=e(E,d[1]);if(V)var
  F=V;else
  try{kh(function(c){return function(b){var
  a=b[1];if(e(c,a))throw gH;if(a2===u(a)[1])throw q;return 0}}(E),r);var
  av=0,F=av}catch(a){a=H(a);if(a===gH)var
  W=1;else{if(a!==q)throw a;var
  W=0}var
  F=W,aD=a}if(F)for(;;){if(h(d[1],E)){var
  w=ce(r),al=w[4],am=w[3],an=w[2],ao=w[1],ap=D(a[1]);a[1]=[0,[0,[0,d[1],k[1],ap]],am];d[1]=ao;k[1]=an;p[1]=al;continue}var
  x=ce(r),aq=x[4],ar=x[3],as=x[2],at=x[1],au=D(a[1]);a[1]=[0,[0,[0,d[1],k[1],au]],ar];d[1]=at;k[1]=as;p[1]=aq;continue a}continue;case
  2:a[1]=[0,[1,s[1]],a[1]];continue}continue}}catch(b){b=H(b);if(b===aF)for(;;){if(0<r[2]){var
  y=ce(r),aw=y[4],ax=y[3],ay=y[2],az=y[1],aA=D(a[1]);a[1]=[0,[0,[0,d[1],k[1],aA]],ax];d[1]=az;k[1]=ay;p[1]=aw;continue}return D(a[1])}throw b}}function
  pb(l,k,a,c){function
  i(f){if(0===f[0]){var
  g=f[1],d=g[2],c=g[1],m=g[3];if(h(c,pd)){if(h(c,pe)){if(h(c,pf)){try{var
  o=v===cc(c,l)[2]?1:0,j=o}catch(a){a=H(a);if(a!==q)throw a;var
  j=0}b(a,pg);b(a,c);bL(function(d){var
  f=d[2],g=d[1];b(a,ph);b(a,g);b(a,pi);function
  c(b,a){try{var
  d=gh(a,mU),f=aC(a,0,d),g=mS(a,d+1|0),h=e(f,mW)?c(b,g):c([0,f,b],g);return h}catch(c){c=H(c);if(c===q)return e(a,mV)?b:[0,a,b];throw c}}b(a,au(pc,D(c(0,f))));return b(a,pj)},d);if(j){var
  n=k?pk:pl;return b(a,n)}b(a,pm);bL(i,m);b(a,pn);b(a,c);return b(a,po)}b(a,pp);b(a,cc(pq,d));return b(a,pr)}b(a,ps);b(a,cc(pt,d));return b(a,pu)}b(a,pv);b(a,cc(pw,d));return b(a,px)}return b(a,f[1])}try{var
  d=bL(i,c);return d}catch(a){a=H(a);if(a===q)return cZ(py);throw a}}aS(32,bS);function
  pz(b){var
  a=aS(32,0);a_(a,b>>>3|0,ef(i8(a,b>>>3|0)|1<<(b&7)));return a}var
  gL=E(aL),ci=0;function
  pA(c){var
  b=E(32),a=0;for(;;){a_(b,a,ef(i8(c,a)^bS));var
  d=a+1|0;if(31!==a){var
  a=d;continue}return b}}for(;;){a_(gL,ci,f$(ef(ci)));var
  xi=ci+1|0;if(bS!==ci){var
  ci=xi;continue}jQ(gL);pA(pz(10));var
  Q=function(b,a){return a?a[1]:b},da=function(a,b){if(b)return b;var
  c=ba(a);return bg===c?a[1]:aj===c?ca(a):a},cg=function(c,a){return a?[0,b(c,a[1])]:0},db=function(c,a){return a?b(c,a[1])?a:0:0},gM=function(a,b){if(b)return b[1];var
  c=ba(a);return bg===c?a[1]:aj===c?ca(a):a},av=function(a,c){return a?b(c,a[1]):0},ah=function(b,a){return cg(a,b)},gN=function(a){return a?[0,a[1],0]:0},gO=function(c,a){if(a){var
  d=a[2],e=a[1],f=b(c,e),g=gO(c,d),h=e===f?1:0,i=h?d===g?1:0:h;return i?a:[0,f,g]}return a},ai=function(d,a){if(a){var
  e=a[2],f=a[1],g=b(d,f),c=ai(d,e);return g?e===c?a:[0,f,c]:c}return a},dc=function(c,b,a){var
  d=D(b);return bb(function(b,a){return f(c,a,b)},a,d)},dd=function(a){return a?[0,a[1]]:0},aG=function(e,d){var
  a=d;for(;;){if(a){var
  f=a[2],c=b(e,a[1]);if(c)return c;var
  a=f;continue}return 0}},eC=function(d,a){var
  c=0;return dc(function(e,a){var
  c=b(d,e);return c?[0,c[1],a]:a},a,c)},eD=function(e,d){var
  a=d;for(;;){if(a){var
  c=a[1];if(b(e,c))return[0,c];var
  a=a[2];continue}return 0}},eE=function(f){function
  a(a,c){var
  d=c[2],e=c[1];return b(f,a)?[0,[0,a,e],d]:[0,e,[0,a,d]]}return function(b){return dc(a,b,pB)}},de=function(c,a){var
  d=0;return dc(function(d,a){return z(b(c,d),a)},a,d)},eF=function(c,a){if(a){var
  d=a[1],f=a[2];if(b(c,d)){var
  e=eF(c,f);return[0,[0,d,e[1]],e[2]]}}return[0,0,a]},gP=function(c,a){return eF(function(a){return 1-b(c,a)},a)},gQ=function(b){if(e(b,jW))var
  f=b;else{var
  h=0;if(gf(aB(b,0))||gf(aB(b,m(b)-1|0)))h=1;else
  var
  f=b;if(h){var
  d=aq(b),g=as(d),a=[0,0];for(;;){if(a[1]<g&&ge(bE(d,a[1]))){a[1]++;continue}var
  c=[0,g-1|0];for(;;){if(a[1]<=c[1]&&ge(bE(d,c[1]))){c[1]+=-1;continue}var
  i=a[1]<=c[1]?ei(d,a[1],(c[1]-a[1]|0)+1|0):jP,f=O(i);break}break}}}return e(f,pC)},aY=function(b,a){var
  c=m(a);return m(b)<c?0:e(aC(b,0,c),a)},eG=function(c,b){var
  d=m(c),a=m(b);return d<a?0:e(aC(c,d-a|0,a),b)},gR=function(b,a){var
  c=m(b);return c<a?pD:aC(b,a,c-a|0)},df=function(a,h){function
  c(b,a){try{var
  d=gh(a,h),f=aC(a,0,d),g=gR(a,d+1|0),i=e(f,pF)?c(b,g):c([0,f,b],g);return i}catch(c){c=H(c);if(c===q)return e(a,pE)?b:[0,a,b];throw c}}return D(c(0,a))},y=gm([0,j0]),gS=function(b){var
  a=aC(b,5,m(b)-5|0);try{var
  c=cT(a);return c}catch(a){a=H(a);if(a[1]===c0)throw[0,ea,g(pK,g(b,pJ))];throw a}},gT=function(a){return a?[0,au(pL,a)]:0},pQ=z(pP,pO),pR=b(y[37],pQ),dg=function(a){return f(y[3],a,pR)},eH=function(b,a){return bG(a[1],b)},aD=function(a){function
  b(b){return eH(a,b)}return function(a){return eD(b,a)}},eI=function(c,b,a){var
  d=gO(function(a){var
  d=a[1];return bG(c,d)?[0,d,b]:a},a);return d===a?[0,[0,c,b],a]:d},pU=function(b,a){return av(b,function(b){return 0===a[0]?[0,g(b,a[1])]:0})},gU=function(a){return bb(pU,pT,a)},gV=function(b){function
  c(a){if(1===a[0]&&e(a[1],b))return[0,a];return 0}return function(a){if(0===a[0])throw[0,t,pV];return eC(c,a[4])}},gW=function(a){return 0===a[0]?0:a[4]},eJ=function(c,b,a){if(0===a[0])return 0;var
  d=a[3],g=a[2];if(e(a[1],c))return f(b,g,d);var
  h=a[4];return aG(function(a){return eJ(c,b,a)},h)},dh=function(d,c,g,f,b){var
  a=bG(c,d),e=a?0===b?1:0:a;return e},pW=function(k,j,i,g){var
  c=b(eE(function(a){return e(a[1],pX)}),j),a=c[1],l=c[2];if(a){var
  d=a[1];if(!h(d[1],pY)&&!a[2]){var
  f=d[2];return aY(f,pZ)?[0,[1,k,z(l,[0,[0,p0,f],0]),i,g]]:0}}return 0},p2=[0,function(c,b,g,f){var
  a=e(c,p1),d=a?0!==b?1:0:a;return d},pW],gX=function(a){return e(a[1],p3)},p4=function(f,b,a,d){var
  c=eD(gX,b);if(c){var
  g=c[1][2],i=ai(function(a){return h(a[1],p5)},b),j=aR(function(a){return e(a[1][1],p6)},a)?a:[0,[0,p7,[0,[0,g,0]]],a];return[0,[1,f,i,j,d]]}return 0},p9=[0,function(c,b,f,d){var
  a=e(c,p8);return a?aR(gX,b):a},p4],di=function(a){return gi(a,32)?g(p$,g(a,p_)):a},qj=b(y[37],qi),qk=function(l){var
  b=l[2][1],c=l[1][1];if(f(y[3],c,qj)){var
  a=bb(function(b,a){if(b){var
  c=b[2],d=b[1];if(e(a,qb))return[0,qc,[0,di(d),c]];if(aY(a,qd)){var
  f=g(qe,a);return[0,qf,[0,g(di(d),f),c]]}return[0,g(d,a),c]}return 0},qa,b);if(a){var
  i=a[1];if(h(i,qg))var
  n=a[2],j=[0,di(i),n];else
  var
  j=a[2];var
  k=j}else
  var
  k=a;var
  d=au(qh,D(k))}else
  var
  p=eG(c,qo)?b:at(di,b),d=au(qp,p);var
  o=0===m(d)?ql:d;return g(c,g(qn,g(o,qm)))},gY=function(a,b){var
  c=a?a[1]:qq;return au(c,at(qk,b))},eK=function(a){return g(qs,gY(qr,a))},qu=function(b){switch(b[0]){case
  0:var
  c=b[1],e=g(qw,g(eK(b[2]),qv));return g(au(qt,c[1]),e);case
  1:var
  f=b[1];return g(qz,g(f,g(qy,g(eK(b[2]),qx))));default:var
  h=b[3],i=b[2],j=b[1][1],k=g(qB,g(eK(b[4]),qA)),l=g(Q(qD,cg(function(a){return g(qC,a)},h)),k);return g(qG,g(j,g(Q(qF,cg(function(b){return g(qE,a(d+b[1]))},i)),l)))}},ch=function(a){return au(qI,a[1])},gZ=[A,qJ,bo(0)],aw=function(a){throw gZ},g0=function(a){return qR},g1=function(a){return qS},g2=function(a){return[0,a,0]},eL=function(a){return qT},eM=function(a){return qU},eN=function(a){return qV},bP=function(a){b_(qW);throw[0,t,qX]},g3=function(c,b,a){if(typeof
  a==="number"&&3===a)return Q(0,b);return aw(0)},ck=function(e,H,c,a,G,F,g){var
  d=[0,H,F,G];if(typeof
  g==="number"&&5===g){var
  f=b(a,c);if(typeof
  f==="number")switch(f){case
  4:var
  h=b(a,c),i=g1(0),j=2;return e<50?Z(e+1|0,d,c,a,i,j,h):o(Z,[0,d,c,a,i,j,h]);case
  5:var
  k=b(a,c),l=g0(0),m=2;return e<50?Z(e+1|0,d,c,a,l,m,k):o(Z,[0,d,c,a,l,m,k]);default:return aw(0)}else
  switch(f[0]){case
  0:var
  n=f[1],p=b(a,c),q=2;return e<50?Z(e+1|0,d,c,a,n,q,p):o(Z,[0,d,c,a,n,q,p]);case
  1:var
  r=f[1],s=b(a,c),t=2;return e<50?Z(e+1|0,d,c,a,r,t,s):o(Z,[0,d,c,a,r,t,s]);case
  2:var
  u=f[1],v=2;return e<50?du(e+1|0,d,c,a,u,v):o(du,[0,d,c,a,u,v]);case
  3:var
  w=f[1],x=b(a,c),y=2;return e<50?Z(e+1|0,d,c,a,w,y,x):o(Z,[0,d,c,a,w,y,x]);case
  4:var
  z=f[1],A=b(a,c),B=2;return e<50?Z(e+1|0,d,c,a,z,B,A):o(Z,[0,d,c,a,z,B,A]);default:var
  C=f[1],D=b(a,c),E=2;return e<50?Z(e+1|0,d,c,a,C,E,D):o(Z,[0,d,c,a,C,E,D])}}return aw(0)},Z=function(h,B,g,f,A,z,y){var
  e=B,d=A,c=z,a=y;for(;;)if(typeof
  a==="number")switch(a){case
  4:var
  C=b(f,g),e=[0,e,c,d],d=g1(0),c=3,a=C;continue;case
  5:var
  D=b(f,g),e=[0,e,c,d],d=g0(0),c=3,a=D;continue;case
  2:case
  6:return aw(0);default:var
  i=e,l=[0,d,0],k=c;for(;;){if(2===k){var
  j=i[1],m=[0,i[3],[0,l]];switch(i[2]){case
  0:var
  t=g2(m),u=0;return h<50?bQ(h+1|0,j,g,f,t,u,a):o(bQ,[0,j,g,f,t,u,a]);case
  1:var
  v=j[2],w=j[1],x=[0,m,j[3]];return h<50?bQ(h+1|0,w,g,f,x,v,a):o(bQ,[0,w,g,f,x,v,a]);case
  7:var
  r=g2(m),s=7;return h<50?bQ(h+1|0,j,g,f,r,s,a):o(bQ,[0,j,g,f,r,s,a]);default:return bP(0)}}if(3===k){var
  J=i[2],K=[0,i[3],l],i=i[1],l=K,k=J;continue}return bP(0)}}else
  switch(a[0]){case
  0:var
  E=a[1],e=[0,e,c,d],d=E,c=3,a=b(f,g);continue;case
  1:var
  F=a[1],e=[0,e,c,d],d=F,c=3,a=b(f,g);continue;case
  2:var
  n=a[1],p=[0,e,c,d],q=3;return h<50?du(h+1|0,p,g,f,n,q):o(du,[0,p,g,f,n,q]);case
  3:var
  G=a[1],e=[0,e,c,d],d=G,c=3,a=b(f,g);continue;case
  4:var
  H=a[1],e=[0,e,c,d],d=H,c=3,a=b(f,g);continue;default:var
  I=a[1],e=[0,e,c,d],d=I,c=3,a=b(f,g);continue}},du=function(h,f,c,a,i,e){var
  d=b(a,c);if(typeof
  d==="number")switch(d){case
  2:case
  6:return aw(0)}else
  if(4===d[0]){var
  l=d[1],k=b(a,c),j=g(i,l);return h<50?dt(h+1|0,f,c,a,j,e,k):o(dt,[0,f,c,a,j,e,k])}return h<50?dt(h+1|0,f,c,a,i,e,d):o(dt,[0,f,c,a,i,e,d])},dt=function(g,f,e,d,c,b,a){return g<50?Z(g+1|0,f,e,d,c,b,a):o(Z,[0,f,e,d,c,b,a])},bQ=function(f,m,c,a,l,k,g){var
  d=[0,m,k,l];if(typeof
  g==="number")switch(g){case
  0:var
  e=b(a,c);if(typeof
  e==="number")switch(e){case
  1:case
  3:return f<50?ds(f+1|0,d,c,a,e):o(ds,[0,d,c,a,e])}else
  if(4===e[0]){var
  n=e[1],h=b(a,c),i=[0,n],j=1;return f<50?ck(f+1|0,d,c,a,i,j,h):o(ck,[0,d,c,a,i,j,h])}return aw(0);case
  1:case
  3:return f<50?ds(f+1|0,d,c,a,g):o(ds,[0,d,c,a,g])}return bP(0)},ds=function(k,g,e,d,c){var
  i=g[2],h=g[1],m=g[3],l=[0,y[1],0],a=bb(function(a,b){var
  c=b[1][1],d=a[1],e=a[2];return f(y[3],c,d)?a:[0,f(y[4],c,d),[0,b,e]]},l,m)[2];if(i){if(7<=i){if(typeof
  c==="number"&&1===c){var
  j=b(d,e);return k<50?dr(k+1|0,h,e,d,a,j):o(dr,[0,h,e,d,a,j])}return aw(0)}return bP(0)}return g3(h,[0,a],c)},dr=function(e,r,c,a,k,j){var
  l=r[3],K=0,O=r[2],P=r[1];if(l&&!h(l[1],qQ)){var
  f=l[2],s=0;if(f&&!h(f[1],qN)){var
  n=f[2];if(n){var
  p=n[2],t=n[1];if(p){if(!h(p[1],qP)){var
  q=p[2];if(q){var
  L=q[1],M=gT(q[2]),m=[2,[0,t],[0,[0,gS(L)]],M,k];s=1}}}else{var
  m=[2,[0,t],0,0,k];s=1}}}if(!s)var
  m=[1,au(qO,f),k]}else
  K=1;if(K)var
  m=[0,[0,D(bb(function(a,b){if(a){var
  c=a[2],d=a[1];return h(b,qL)?[0,g(d,b),c]:[0,qM,[0,d,c]]}return 0},qK,l))],k];var
  d=[0,P,O,m];if(typeof
  j==="number")switch(j){case
  3:var
  i=d,u=0;for(;;){var
  v=i[2],w=[0,i[3],u],N=i[1];if(4===v)return w;if(5===v){var
  i=N,u=w;continue}return bP(0)}case
  4:var
  x=b(a,c),y=eN(0),z=5;return e<50?aZ(e+1|0,d,c,a,y,z,x):o(aZ,[0,d,c,a,y,z,x]);case
  5:var
  A=b(a,c),B=eM(0),C=5;return e<50?aZ(e+1|0,d,c,a,B,C,A):o(aZ,[0,d,c,a,B,C,A]);case
  6:var
  E=b(a,c),F=eL(0),G=5;return e<50?aZ(e+1|0,d,c,a,F,G,E):o(aZ,[0,d,c,a,F,G,E])}else
  if(4===j[0]){var
  H=j[1],I=b(a,c),J=5;return e<50?aZ(e+1|0,d,c,a,H,J,I):o(aZ,[0,d,c,a,H,J,I])}return aw(0)},aZ=function(k,p,f,e,n,m,l){var
  d=p,c=n,a=m,g=l;for(;;){if(typeof
  g==="number")switch(g){case
  2:var
  h=d,j=[0,c,0],i=a;for(;;)switch(i){case
  4:return k<50?dq(k+1|0,h,f,e,j,i):o(dq,[0,h,f,e,j,i]);case
  5:return k<50?dq(k+1|0,h,f,e,j,i):o(dq,[0,h,f,e,j,i]);case
  6:var
  u=h[2],v=[0,h[3],j],h=h[1],j=v,i=u;continue;default:return bP(0)}case
  4:var
  q=b(e,f),d=[0,d,a,c],c=eN(0),a=6,g=q;continue;case
  5:var
  r=b(e,f),d=[0,d,a,c],c=eM(0),a=6,g=r;continue;case
  6:var
  s=b(e,f),d=[0,d,a,c],c=eL(0),a=6,g=s;continue}else
  if(4===g[0]){var
  t=g[1],d=[0,d,a,c],c=t,a=6,g=b(e,f);continue}return aw(0)}},dq=function(f,n,c,a,m,l){var
  d=[0,n,l,m],e=b(a,c);if(typeof
  e==="number"){if(1===e){var
  g=b(a,c),h=0;return f<50?dr(f+1|0,d,c,a,h,g):o(dr,[0,d,c,a,h,g])}}else
  if(4===e[0]){var
  p=e[1],i=b(a,c),j=[0,p],k=7;return f<50?ck(f+1|0,d,c,a,j,k,i):o(ck,[0,d,c,a,j,k,i])}return aw(0)},qY=function(a,b,c,d,e,f){return cW(ck(0,a,b,c,d,e,f))},dj=function(a,b,c,d,e,f){return cW(aZ(0,a,b,c,d,e,f))},qZ=function(c,a){var
  d=b(c,a),e=0;if(typeof
  d==="number")switch(d){case
  3:return 0;case
  4:var
  f=b(c,a);return dj(e,a,c,eN(0),4,f);case
  5:var
  g=b(c,a);return dj(e,a,c,eM(0),4,g);case
  6:var
  h=b(c,a);return dj(e,a,c,eL(0),4,h)}else
  if(4===d[0]){var
  i=d[1];return dj(e,a,c,i,4,b(c,a))}return aw(0)},g4=[A,q1,bo(0)],q0=function(d,c){var
  a=b(d,c),e=0;if(typeof
  a==="number"){if(3===a)return g3(e,0,a)}else
  if(4===a[0]){var
  f=a[1];return qY(e,c,d,[0,f],0,b(d,c))}return aw(0)},q3=function(c){a:for(;;){c[10]=bp(5,-1);var
  k=0;for(;;){var
  e=yg(q2,k,c),j=0<=e?1:0,m=j?c[12]!==c4?1:0:j;if(m){c[11]=c[12];var
  f=c[12];c[12]=[0,f[1],f[2],f[3],c[4]+c[6]|0]}if(20<e>>>0){b(c[1],c);var
  k=e;continue}switch(e){case
  0:return 3;case
  1:var
  h=c[12];c[12]=[0,h[1],h[2]+1|0,c[6],h[4]];continue a;case
  2:continue a;case
  3:return 4;case
  4:return 2;case
  5:return 1;case
  6:return 0;case
  7:return 5;case
  8:return 6;case
  9:return[3,J(c)];case
  10:return[5,J(c)];case
  11:return[4,J(c)];case
  12:return[0,J(c)];case
  13:return[2,J(c)];case
  14:return[1,J(c)];case
  15:var
  n=B(c[10],0)[1];return[1,el(c,B(c[10],1)[2],n)];case
  16:return[4,J(c)];case
  17:continue a;case
  18:continue a;case
  19:continue a;default:var
  i=J(c),l=G(i,0);if(aL<l)return[1,i];throw[0,g4,g(q6,g(i,g(q5,g(a(d+l),q4))))]}}}},g5=function(c){var
  e=c[11],b=c[12],f=g(q7,a(d+((b[4]-b[3]|0)+1|0))),h=g(q8,g(a(d+((e[4]-e[3]|0)+1|0)),f));return g(a(d+b[2]),h)},g6=function(c,a){var
  b=gl(0,c);try{var
  h=f(a,q3,b);return h}catch(a){a=H(a);if(a[1]===g4){var
  d=g(q9,a[2]);b_(g(g5(b),d));return 0}if(a===gZ){var
  e=g(q_,c);b_(g(g5(b),e));return 0}throw a}},g7=function(a){return g6(a,qZ)},eO=function(b){if(0===b[0])return gQ(b[1]);var
  d=b[4],e=h(b[1],ra);if(e){var
  f=0!==d?1:0;if(f){var
  a=d;for(;;){if(a){var
  i=a[2],c=eO(a[1]);if(c){var
  a=i;continue}return c}return 1}}var
  g=f}else
  var
  g=e;return g},g8=function(a){var
  c=0;return D(bb(function(f,a){if(0===a[0]){var
  c=a[1],j=c[3],k=c[2],l=c[1],h=function(a){return g6(a[2],q0)},d=b(eE(function(a){return e(a[1],q$)}),k),i=d[2],g=bb(z,0,at(h,d[1]));return[0,[1,l,i,g,g8(j)],f]}return[0,[0,a[1]],f]},c,a))},g9=function(b,a){return 0===a?b:[0,[0,rb,gY(0,a)],b]},g_=function(c,j){var
  b=c?c[1]:0;function
  d(a){return g(rc,cd(b*2|0,32))}var
  k=0,a=bb(function(f,a){if(0===a[0])return[0,[1,a[1]],f];var
  h=a[1],n=a[4],o=g9(a[2],a[3]),i=g_([0,b+1|0],n),c=e(h,rd)?z([0,re,i],[0,[1,d(0)],0]):i,m=0;if(c){var
  j=c[1];if(0===j[0]&&dg(j[1][1])){var
  k=[0,[1,g(rf,cd((b+1|0)*2|0,32))],c];m=1}}if(!m)var
  k=c;var
  l=[0,[0,h,o,k]];return dg(h)?[0,[1,d(0)],[0,l,f]]:[0,l,f]},k,j),i=0;if(a){var
  f=a[1];if(0!==f[0]){var
  n=0,l=a[2],m=f[1];if(0<b&&e(m,d(0))){var
  h=[0,[1,g(rg,cd((b-1|0)*2|0,32))],l];i=1;n=1}}}if(!i)var
  h=a;return D(h)},g$=function(u){var
  d=0,a=u;for(;;){if(a){var
  e=a[1],j=0;if(0===e[0]){var
  f=a[2];if(f){var
  h=f[1],k=e[1];if(0===h[0]){var
  v=f[2],a=[0,[0,g(k,h[1])],v];continue}var
  o=f[2],n=k,m=h,l=h[1];j=1}}else{var
  i=a[2];if(i){var
  s=i[1],z=e[1];if(0===s[0]){var
  o=i[2],n=s[1],m=e,l=z;j=1}}}if(j&&dg(l)&&gQ(n)){var
  a=[0,m,o];continue}var
  b=a[1];if(0===b[0]){var
  d=[0,[0,b[1]],d],a=a[2];continue}var
  p=b[4],q=b[1],w=a[2],x=b[3],y=b[2];if(dg(q)){var
  c=p;for(;;){if(c){var
  t=c[2];if(eO(c[1])){var
  c=t;continue}}var
  r=dc(function(b,a){if(eO(b)&&0===a)return a;return[0,b,a]},c,0);break}}else
  var
  r=p;var
  d=[0,[1,q,y,x,g$(r)],d],a=w;continue}return D(d)}},ha=function(a){function
  c(d,a){var
  b=cd(d*2|0,32);if(0===a[0])return g(rj,g(b,g(ri,g(a[1],rh))));var
  e=a[4],f=a[1],h=g9(a[2],a[3]),i=g(rl,g(b,rk)),j=d+1|0,k=g(rn,g(au(rm,at(function(a){return c(j,a)},e)),i));return g(rt,g(b,g(rs,g(f,g(rr,g(au(rq,at(function(a){var
  b=a[1];return g(b,g(rp,g(a[2],ro)))},h)),k))))))}return c(0,a)},be=function(b,a){return[0,fs,[0,b,a]]},rX=[0,rW,[0,rV,[0,rU,[0,rT,[0,rS,[0,rR,[0,rQ,[0,rP,[0,rO,[0,rN,[0,rM,[0,rL,[0,rK,[0,rJ,[0,rI,[0,rH,[0,rG,[0,rF,[0,rE,[0,rD,[0,rC,[0,rB,[0,rA,[0,rz,[0,ry,[0,[0,rx,[0,j,be(i,rw)]],rv]]]]]]]]]]]]]]]]]]]]]]]]]],r4=[0,r3,[0,r2,[0,r1,[0,r0,[0,[0,rZ,[0,j,be(i,rY)]],rX]]]]],r9=[0,r8,[0,r7,[0,[0,r6,[0,n,be(i,r5)]],r4]]],sb=[0,[0,sa,[0,n,[0,R,[0,r$,be(i,r_)]]]],r9],sD=[0,sC,[0,sB,[0,sA,[0,sz,[0,sy,[0,sx,[0,sw,[0,sv,[0,su,[0,st,[0,ss,[0,sr,[0,sq,[0,sp,[0,so,[0,sn,[0,sm,[0,[0,sl,[0,n,[0,R,[0,hb,sk]]]],[0,[0,sj,[0,n,[0,R,[0,hb,si]]]],[0,sh,[0,sg,[0,sf,[0,se,[0,[0,sd,[0,n,be(i,sc)]],sb]]]]]]]]]]]]]]]]]]]]]]]],sH=[0,sG,[0,[0,sF,[0,c,be(i,sE)]],sD]],sL=[0,sK,[0,[0,sJ,[0,c,be(i,sI)]],sH]],tb=[0,ta,[0,s$,[0,s_,[0,s9,[0,s8,[0,s7,[0,s6,[0,s5,[0,s4,[0,s3,[0,s2,[0,s1,[0,s0,[0,sZ,[0,sY,[0,sX,[0,sW,[0,sV,[0,sU,[0,sT,[0,sS,[0,sR,[0,sQ,[0,sP,[0,sO,[0,[0,sN,[0,c,be(i,sM)]],sL]]]]]]]]]]]]]]]]]]]]]]]]]],hc=function(a){return g$(g8(oT([0,tb],te,td,tc,0,gl(0,a))))},hd=function(a){return[0,[0,tA,a],tz]},eP=hd(tB),he=function(n,m,a){var
  f=ai(function(b){var
  a=b[1],c=e(a,hf),d=c||e(a,hg);return d},n);function
  o(a){return gR(a[2],7)}var
  p=b(aD(hf),f),q=Q(eP,ah(ah(da([aj,function(a){return b(aD(hg),f)}],p),o),hd)),c=b(aD(tx),a),d=b(aD(ty),a),i=0;if(d&&c){var
  j=c[1][2],k=d[1][2],l=function(b){if(h(b,ts)&&h(b,tt))return a;return eI(tv,j,eI(tu,k,a))},g=ah(aG(function(a){return h(a[1][1],tw)?0:[0,ch(a[2])]},m),l);i=1}if(!i)var
  g=0;return z(q,Q(a,g))},hh=function(b,a){var
  c=[1,tC,0,0,a];return eJ(b,function(b,a){return[0,[0,b,a]]},c)},tD=function(f,d,a,c){function
  e(b){var
  c=b[2],e=he(d,a,b[1]);return[0,e,z(c,a)]}var
  b=Q([0,eP,0],ah(hh(tE,c),e));return[0,[1,tF,b[1],b[2],0]]},tH=[0,function(a,d,c,b){return e(a,tG)},tD],tI=function(a,b){return[0,a]},hi=function(a){return eJ(tJ,tI,a)},hj=function(d,a){if(0===a[0])return 0;var
  b=a[1];if(h(b,tK)){var
  e=a[4],f=a[3],g=a[2],c=function(b){if(b){var
  a=b[1];if(0===a[0])return[0,a,c(b[2])];var
  e=a[1];if(h(e,tL)){var
  f=a[4],g=a[3],i=a[2],j=c(b[2]);return[0,[1,e,i,g,c(f)],j]}return[0,[1,tM,d,a[3],a[4]],b[2]]}return 0};return[0,[1,b,g,f,c(e)]]}return[0,[1,tN,d,a[3],a[4]]]},tR=function(w,c,v,u,b){if(c){var
  n=c[1];if(!h(n[1],tS)&&!c[2]){var
  a=n[2],l=aY(a,tO),s=l?eG(a,tP):l;if(s){if(b){var
  d=b[1];if(0!==d[0]&&!h(d[1],tT)){var
  e=d[2];if(e){var
  o=e[1];if(!h(o[1],tU)&&!h(o[2],tV)&&!e[2]){var
  f=b[2];if(f){var
  g=f[2];if(g){var
  i=g[1],j=f[1];if(0!==i[0]&&!h(i[1],tW)){var
  k=i[2];if(k){var
  p=k[1];if(!h(p[1],tX)&&!h(p[2],tY)&&!k[2]){var
  t=g[2],q=hc(aC(a,15,(m(a)-9|0)-15|0)),r=function(a){function
  b(b){return he(b[1],b[2],a)}var
  c=ah(hh(tQ,q),b);return hj(gM([aj,function(b){return z(eP,a)}],c),j)};return[0,[0,Q(j,av(hi(j),r)),t]]}}}}}}}}}return 0}return 0}}return 0},t0=[0,function(a,b,c,d){return dh(tZ,a,b,c,d)},tR],t4=function(u,b,t,s,a){if(b){var
  l=b[1];if(!h(l[1],t5)&&!b[2]){var
  m=l[2],k=aY(m,t1),q=k?eG(m,t2):k;if(q){if(a){var
  c=a[1];if(0!==c[0]&&!h(c[1],t6)){var
  d=c[2];if(d){var
  n=d[1];if(!h(n[1],t7)&&!h(n[2],t8)&&!d[2]){var
  e=a[2];if(e){var
  f=e[2];if(f){var
  g=f[1],i=e[1];if(0!==g[0]&&!h(g[1],t9)){var
  j=g[2];if(j){var
  o=j[1];if(!h(o[1],t_)&&!h(o[2],t$)&&!j[2]){var
  r=f[2],p=function(a){return hj([0,t3,a],i)};return[0,[0,Q(i,av(hi(i),p)),r]]}}}}}}}}}return 0}return 0}}return 0},ub=[0,function(a,b,c,d){return dh(ua,a,b,c,d)},t4],hk=function(h,g,o){var
  i=h?h[1]:0,c=0,a=o;for(;;){if(a){var
  b=a[1];if(0===b[0]){var
  c=[0,b,c],a=a[2];continue}var
  d=a[2],f=b[4],j=b[3],k=b[2],l=b[1],e=cl(g,l,k,j,f,d);if(typeof
  e==="number"){if(0===e){var
  a=d;continue}var
  m=hk([0,i],g,f),n=[1,l,k,j,m];if(i&&bJ(m,f)){var
  a=[0,n,d];continue}var
  c=[0,n,c],a=d;continue}else{if(0===e[0]){var
  a=[0,e[1],d];continue}var
  a=e[1];continue}}return D(c)}},hl=function(a,e,d,c,b){return Q(0,aG(function(f){if(eY(f[1],e,d,c,b)){var
  a=eY(f[2],e,d,c,b);if(typeof
  a==="number"&&!a)return 0;return[0,a]}return 0},a))},dk=function(a,i,h,b){var
  c=a?a[1]:0;return hk([0,c],function(f,e,d,b,c){var
  a=hl(i,f,e,d,b);if(typeof
  a==="number")switch(a){case
  0:var
  g=aG(function(a){return eY(a[1],f,e,d,b)?cl(a[2],f,e,d,b,c):0},h);return g?[1,g[1]]:1;case
  1:return[1,z(b,c)];default:return 0}else
  return 0===a[0]?[0,a[1]]:[1,z(a[1],c)]},b)},ud=function(c){if(!h(c[1][1],ue)){var
  a=c[2][1];if(a){var
  b=a[2];if(b){var
  d=b[2],e=b[1],f=a[1],g=[aj,function(a){return gT(d)}];return[0,[0,[0,f],gS(e),g]]}}}return 0},eQ=function(a){return aG(ud,a)},dl=function(b,a){return aG(function(a){var
  c=a[2];return e(a[1][1],b)?[0,ch(c)]:0},a)},hm=function(o){var
  c=0,a=o;a:for(;;){if(a){var
  b=a[1];if(0===b[0]){var
  c=[0,b,c],a=a[2];continue}var
  k=a[2],f=b[2],g=b[1],p=b[3],l=hm(b[4]);if(f){var
  m=f[1];if(!h(m[1],uf)&&!h(m[2],ug)&&!f[2]&&!l){var
  n=0;if(e(g,uh)||e(g,ui))n=1;if(n){var
  i=1,d=gP(function(f){return function(a){if(1===a[0]){var
  b=a[2];if(b){var
  c=b[1],d=a[1];if(!h(c[1],pM)&&!h(c[2],pN)&&!b[2]&&e(d,f))return 1}}return 0}}(g),k)[2];for(;;){if(0===i)var
  j=d;else{if(d){var
  i=i-1|0,d=d[2];continue}var
  j=0}var
  a=j;continue a}}}}var
  c=[0,[1,g,f,p,l],c],a=k;continue}return D(c)}},hn=function(a){return[0,uk,a[2],[0,uj,a[3]],0]},uG=function(b){var
  a=b[1][1],c=e(a,uH),d=c||e(a,uI);return d},uJ=function(a){if(!h(a[1][1],uK)){var
  c=a[2],b=c[1];if(b&&!h(b[1],uL)&&!b[2])return[0,uM,c]}return a},ho=function(j,b,c){function
  p(g){var
  k=g[3],c=g[2],i=c[3],f=c[2],l=c[1],o=c[4],p=g[1],m=0===k?0:ho(j,b,k),n=[0,uV,a(d+p)];if(e(l,uW))return[1,l,[0,n,f],i,m];var
  q=aR(function(a){return eH(uX,a)},f)?f:[0,uZ,f],r=[0,n,z(eC(function(a){return h(a[1][1],uQ)?0:[0,[0,uR,ch(a[2])]]},i),q)],s=at(uJ,i);return[1,uY,r,s,z(hm(o),m)]}if(c){var
  k=c[1],l=k[2][3],m=k[1],i=function(g,d,c){function
  f(a){if(2===a[0]){var
  b=a[3];if(e(a[1][1],g)){if(c)var
  f=c[1],d=b?bG(f,b[1]):0;else
  var
  d=0===b?1:0;if(d)return 1}}return 0}function
  h(a){if(2===a[0]){var
  b=a[2];if(b){var
  c=a[4];if(b[1][1]===d)return[0,c]}}return 0}function
  i(a){if(2===a[0]&&!a[2])return[0,a[4]];return 0}var
  b=ai(f,j),a=aG(h,b);return a?a:aG(i,b)},n=function(b){var
  a=b[3],d=b[2],e=b[1][1],c=ba(a),f=bg===c?a[1]:aj===c?ca(a):a;return i(e,d,f)},o=function(c){var
  a=[aj,function(d){function
  a(a){return av(eQ(l),n)}var
  b=dl(uN,c);return av(db(function(a){return e(uO,a)},b),a)}];function
  m(g){var
  a=ek(g);if(h(a,ut))if(h(a,uu)){var
  d=0;if(h(a,uv)&&h(a,uw))var
  b=h(a,ux)?h(a,uy)?0:uA:uB;else
  d=1;if(d)var
  f=function(a){return e(a,pH)?uq:e(a,pI)?ur:e(a,pG)?0:0},b=av(dl(us,c),f)}else
  var
  b=uC;else
  var
  b=uD;return da([aj,function(a){return uz}],b)}var
  g=Q(uF,av(dl(uE,c),m)),b=g[1],j=g[2],d=gN(ah(j,function(a){return[0,ul,[0,[0,a,0]]]}));if(e(b,um))return[0,b,0,d];function
  f(a){return dl(un,a)}var
  i=[aj,function(d){var
  b=ba(a),c=bg===b?a[1]:aj===b?ca(a):a;return av(c,f)}];function
  k(a){return[0,uo,a]}var
  o=da(i,f(c));return[0,b,gN(ah(db(function(a){return h(a,up)},o),k)),d]},f=Q(uP,ah(i(b,m,0),o)),q=f[3],r=f[2],s=f[1],t=at(p,c),u=z([0,[0,uU,g(b,g(uT,a(d+m)))],[0,[0,uS,b],0]],r);return[0,[1,s,u,z(q,ai(uG,l)),t],0]}return 0},u2=b(y[37],u1),hp=function(e){var
  a=e;for(;;){if(a){var
  b=a[1];if(0===b[0]){var
  c=a[2];if(c){var
  d=c[1],f=b[1];if(0===d[0]){var
  h=c[2],a=[0,[0,g(f,d[1])],h];continue}}}return[0,b,hp(a[2])]}return a}},hq=function(e,d){var
  b=0,a=e,c=d;for(;;){if(a){var
  b=[0,a[1],b],a=a[2];continue}if(c){var
  b=[0,c[1],b],a=0,c=c[2];continue}return D(b)}},va=function(d,c,g,i,a){var
  j=b(aD(vd),c);if(a){var
  f=a[1];if(0===f[0])var
  k=0;else{var
  r=f[4],s=f[2],t=f[1],u=b(aD(ve),s),m=h(d,t);if(m)var
  n=m;else
  var
  p=j?1:0,q=1-p,n=q||bJ(j,u);if(n)var
  o=0;else
  var
  v=function(a){if(0===a[0])return 0;var
  g=a[4],b=e(a[1],vf);if(b){if(0===a[0])var
  c=0;else
  var
  f=a[3],c=aR(function(a){var
  c=a[2][1],b=e(a[1][1],vb),d=b?bG(c,vc):b;return d},f);var
  d=c}else
  var
  d=b;return d?[0,g]:0},o=av(dd(r),v);var
  k=o}var
  l=k}else
  var
  l=0;return cg(function(h){var
  f=D(i);if(f)var
  j=f[1],e=[0,j,D(f[2])];else
  var
  e=0;if(e){var
  b=e[1],k=e[2];if(0===b[0]){var
  l=c2(a);return[0,[1,d,c,g,z(i,h)],l]}var
  m=b[4],n=b[3],o=b[2],p=b[1],q=c2(a);return[0,[1,d,c,g,z(k,[0,[1,p,o,n,z(m,h)],0])],q]}return[0,[1,d,c,g,h],c2(a)]},l)},vi=[0,function(a,g,f,d){var
  b=e(a,vg),c=b||e(a,vh);return c},va],hr=function(a){var
  c=b(aD(vj),a);return cT(Q(vk,cg(function(a){return a[2]},c)))},vl=function(d,c,o,g,f){function
  a(a){var
  h=a[2],i=dd(f);return av(i,function(a){if(0===a[0])return 0;var
  i=a[2],p=a[4],q=a[1],j=b(aD(vm),i);return av(j,function(r){var
  b=r[2],s=hr(c),t=hr(i),u=(s+bs(g)|0)===t?1:0,j=e(d,vn),k=j?e(b,h):j;if(k)var
  a=k;else{var
  l=e(d,vo);if(l){var
  m=e(q,vp);if(m)var
  n=e(b,h),a=n?u:n;else
  var
  a=m}else
  var
  a=l}if(a){var
  v=c2(f);return[0,[0,[1,d,c,o,z(g,p)],v]]}return 0})})}return av(b(aD(vq),c),a)},vt=[0,function(a,g,f,d){var
  b=e(a,vr),c=b||e(a,vs);return c},vl],vu=function(e,a,d,c){var
  b=ai(function(a){return h(a[1],vv)},a);return a===b?0:[0,[1,e,b,d,c]]},vw=[0,function(d,a,c,b){return 0!==a?1:0},vu],hs=function(a){var
  e=3<=m(a)?1:0;if(e){var
  f=58===G(a,1)?1:0;if(f){var
  b=G(a,0),d=0;if(113<=b){if(!(2<b-118>>>0))d=1}else
  if(111<=b)d=1;if(!d)return 0;var
  c=1}else
  var
  c=f}else
  var
  c=e;return c},vA=function(d,c,b,a){return a?1:2},vB=[0,function(a,d,c,b){return hs(a)},vA],vC=function(e,a,d,c){if(a){var
  b=a[1];if(!h(b[1],vD)&&!a[2]&&aY(b[2],vE))return 1}return 0},vG=[0,function(a,d,c,b){return e(a,vF)},vC],vL=function(g,b,f,d){if(b){var
  c=b[1];if(!h(c[1],vM)&&!b[2]){var
  a=ek(c[2]);if(!e(a,vH)&&!e(a,vI)&&!aY(a,vJ)&&!aY(a,vK))return 0;return 2}}return 0},vP=[0,function(a,h,g,c){var
  d=e(a,vN),b=d||e(a,vO),f=b?0===c?1:0:b;return f},vL],vQ=function(d,a,c,b){if(a&&!h(a[1][1],vR)&&!a[2])return 2;return 0},vT=[0,function(a,b,c,d){return dh(vS,a,b,c,d)},vQ],ht=b(y[37],vU),vW=b(y[37],vV),vX=b(b(y[7],ht),vW),v5=function(d,c,b,a){return 1},hu=[0,function(g,f,d,h){var
  a=e(g,v6);if(a)var
  b=0===f?1:0,c=b?0===d?1:0:b;else
  var
  c=a;return c},v5],v7=function(i,g,f,c){if(c){var
  a=c[1];if(0!==a[0]&&!h(a[1],v8)&&!c[2]){var
  j=a[4],k=a[3],l=a[2],e=b(eE(function(a){return eH(v9,a)}),l),d=e[1],m=e[2];if(d&&!d[2])return[0,[1,i,eI(v$,d[1][2],g),f,[0,[1,v_,m,k,j],0]]];return 0}}return 0},wb=[0,function(a,d,c,b){return e(a,wa)},v7],wf=function(q,p,c,n){if(aR(function(a){var
  c=a[2][1],b=e(a[1][1],wg),d=b?bG(c,wh):b;return d},c)){var
  b=D(n),g=0;if(b){var
  a=b[1];if(0!==a[0]){var
  i=b[2],j=a[4],k=a[3],l=a[2],m=a[1],o=Q(0,aG(function(a){var
  b=a[2];return e(a[1][1],wc)?[0,[0,[0,wd,ch(b)],0]]:0},c)),d=ai(function(a){return aY(a[1][1],we)},c),h=z(ai(function(a){var
  b=a[1][1];return 1-aR(function(a){return e(a[1][1],b)},d)},k),d),f=[0,[1,m,z(o,l),h,j],i];g=1}}if(!g)var
  f=0;return[1,D(f)]}return 0},wj=[0,function(a,d,c,b){return e(a,wi)},wf],wl=b(y[37],wk),hv=function(a){return f(y[3],a,wl)},wn=b(y[37],wm),wo=0,wE=function(c,a,b){return hv(a)},eR=function(s,b,a){var
  n=hv(b);if(n)var
  o=n;else{var
  p=f(y[3],b,wn);if(p)var
  j=p;else{var
  l=45===G(b,0)?1:0;if(l)var
  i=l;else{var
  m=aY(b,wC);if(m)var
  r=1-s,i=r||h(b,wD);else
  var
  i=m}var
  j=i}if(j)var
  q=j;else{var
  e=0;if(h(b,wp)&&h(b,wq)){var
  c=0;if(h(b,wr)){var
  d=0;if(h(b,ws))if(h(b,wt))if(h(b,wu))if(h(b,wv)){if(h(b,ww)){c=1;d=1}}else
  if(a&&!(h(a[1],wy)||a[2])){var
  k=wo;e=2;c=1;d=1}else{c=1;d=1}else
  if(a&&!(h(a[1],wz)||a[2])){e=1;c=1;d=1}else{c=1;d=1}else
  d=1;if(!d)if(a&&!(h(a[1],wx)||a[2])){e=1;c=1}else
  c=1}if(!c&&a&&!h(a[1],wA)&&!a[2])e=1}else
  e=3;var
  g=0;switch(e){case
  3:if(a&&!h(a[1],wB)&&!a[2])g=2;break;case
  0:break;case
  1:g=2;break;default:g=1}switch(g){case
  0:var
  k=0;break;case
  2:var
  k=1;break}var
  q=k}var
  o=1-q}return o},wG=b(y[37],wF),hw=function(a,c,b){var
  d=a?a[1]:0,e=c?eR:wE;return ai(function(a){return e(d,a[1][1],a[2][1])},b)},hx=function(a,c){var
  d=a?a[1]:0;function
  b(g,f,a,e){var
  b=hw([0,d],c,a);return a===b?0:[0,[1,g,f,b,e]]}return[0,function(c,g,b,e){var
  a=0!==b?1:0,d=a?1-f(y[3],c,wG):a;return d},b]},wH=function(b,a){if(0===b[0]){var
  d=b[1],c=hw(0,1,b[2]);return 0===c?a:[0,[0,d,c],a]}return a},hy=b(y[37],wI),eS=function(a){return ai(function(a){return 1-f(y[3],a[1],hy)},a)},hz=function(g,f,d,a){return ai(function(c){var
  a=c[1][1],h=c[2][1];if(g){var
  b=1-e(a,d);return b?eR(1,a,h):b}return e(a,f)},a)},wL=function(k,d,c,j){var
  b=eD(function(a){return e(a[1],wK)},d);if(b){var
  f=b[1];if(!aR(function(a){return e(a[1][1],wM)},c)){var
  a=f[2],h=f[1],i=jx(a)?g(a,wJ):a;return[0,[1,k,d,[0,[0,[0,h],[0,[0,i,0]]],c],j]]}}return 0},wO=[0,function(a,d,c,b){return e(a,wN)},wL],wW=[0,tH,[0,vB,[0,vG,0]]],hA=[A,w4,bo(0)],w1=function(G,F,E,ar,aq){var
  c=F?F[1]:0,I=E?E[1]:0,k=hc(ar);if(I)b_(g(w2,au(ru,at(ha,k))));var
  i=k;for(;;){if(i){var
  m=i[1],K=0;if(1===m[0]&&!h(m[1],pS)){var
  p=[0,m[4]];K=1}if(!K){var
  i=i[2];continue}}else
  var
  p=0;if(p){var
  O=p[1],t=eF(function(a){if(1===a[0]&&!h(a[1],tg))return 1;return 0},O),n=t[2],M=t[1],L=0,ay=Q(0,ah(gU(de(gW,de(gV(tk),M))),g7));if(n){var
  j=n[1];if(0!==j[0]&&!h(j[1],tf)){var
  o=[0,j[3],j[4]];L=1}}if(!L)var
  o=[0,0,n];var
  l=[0,ay,o[2],o[1]]}else
  var
  u=gP(function(a){if(1===a[0]){var
  b=a[2];if(b){var
  c=b[1],f=a[1];if(!h(c[1],th)&&!b[2]){var
  g=c[2],d=dh(ti,f,b,a[3],a[4]),i=d?e(ek(g),tj):d;return i}}}return 0},k),v=u[2],N=u[1],l=v?[0,Q(0,ah(gU(de(gW,de(gV(tm),[0,[1,tl,0,0,N],0]))),g7)),v,0]:[0,0,k,0];var
  s=l[1],as=l[3],av=l[2],ap=0,ao=[0,wj,[0,hx(wY,c),[0,hu,0]]],T=function(o,m,d,l,k){function
  a(p){var
  n=p[1][1],q=[0,[1,o,m,d,l],k];function
  i(t,j){var
  a=t;for(;;){if(a){var
  c=a[1];if(0!==c[0]){var
  k=a[2],f=c[4],g=c[3],l=c[2],m=c[1],o=eQ(g);if(o){var
  p=o[1],h=p[2],q=p[1][1];if(j){var
  u=j[1];if(e(q,n)&&h===u){var
  r=i(k,j);return[0,[0,[0,h,[0,m,l,g,f]],r[1]],r[2]]}}else
  if(e(q,n)){var
  s=i(k,[0,h]);return[0,[0,[0,h,[0,m,l,g,f]],s[1]],s[2]]}return[0,0,a]}var
  b=hl(ao,m,l,g,f);if(typeof
  b==="number")switch(b){case
  0:var
  d=0;break;case
  1:var
  d=[0,f];break;default:var
  d=uc}else
  var
  d=0===b[0]?[0,[0,b[1],0]]:[0,b[1]];if(d){var
  a=z(d[1],k);continue}return[0,0,a]}}return[0,0,a]}}var
  b=i(q,0),a=b[1],r=b[2];function
  f(k,j){var
  a=k,b=j;for(;;){if(b){var
  e=b[1],g=e[2],d=e[1],l=b[2];if(a){var
  h=a[1],c=h[1],m=a[2],n=h[2];if(c<d){var
  o=d===(c+1|0)?0:[0,[0,c+1|0,hn(g),0],0],i=f(o,b),p=i[2],a=[0,[0,c,n,D(i[1])],m],b=p;continue}if(d<c)return[0,a,b]}var
  a=[0,[0,d,g,0],a],b=l;continue}return[0,a,0]}}if(a)var
  c=a[1],h=c[2],j=1===c[1]?0:[0,[0,1,hn(h),0],0],g=D(f(j,a)[1]);else
  var
  g=0;return[0,z(ho(s,n,g),r)]}return Q(0,ah(eQ(d),a))},aw=dk(0,wW,[0,ub,[0,t0,[0,[0,function(a,d,c,b){return e(a,u0)},T],ap]]],av),ad=[0,hu,[0,wb,0]],ab=b(y[37],wT),ac=function(g,b,a,f){var
  d=eS(b),e=hz(c,wV,wU,a);if(d===b&&e===a)return 0;return[0,[1,g,d,e,f]]},ae=[0,[0,function(a,d,c,b){return f(y[3],a,ab)},ac],ad],aa=function(g,b,a,f){var
  d=eS(b),e=hz(c,wR,wQ,a);if(d===b&&e===a)return 0;return[0,[1,g,d,e,f]]},af=[0,[0,function(a,d,c,b){return e(a,wS)},aa],ae],$=function(h,b,a,g){var
  d=eS(b),e=ai(function(a){var
  b=a[1][1],d=a[2][1];return c?eR(1,b,d):f(y[3],b,hy)},a);if(d===b&&e===a)return 0;return[0,[1,h,d,e,g]]},ag=[0,wO,[0,[0,function(a,d,c,b){return e(a,wP)},$],af]],_=function(d,c,b,a){return a?1:2},ak=[0,[0,function(a,h,g,e){if(c)return 0;var
  d=b(y[37],aq);return f(y[3],a,d)},_],ag],al=[0,vT,[0,vP,[0,hx(wX,c),ak]]],Z=function(d,c,b,a){return aR(function(b){if(0===b[0]){var
  a=b[1][1];if(a&&!h(a[1],v2)&&!a[2])return 1}return 0},s)?[0,[1,d,ai(function(a){var
  c=a[2],b=e(a[1],v3),d=b?e(c,v4):b;return 1-d},c),b,a]]:1},am=[0,[0,function(f,a,d,b){return c?aR(function(a){var
  c=a[2],b=e(a[1],v0),d=b?e(c,v1):b;return d},a):0},Z],al],X=c?ht:vX,Y=function(g,a,d,c){var
  b=ai(function(c){var
  a=c[1],i=c[2],d=hs(a);if(d)var
  g=d;else
  var
  b=e(a,vY),h=b?e(i,vZ):b,g=h||f(y[3],a,X);return 1-g},a);return a===b?0:[0,[1,g,b,d,c]]},r=[0,0],an=[0,p9,[0,p2,[0,[0,function(d,a,c,b){return 0!==a?1:0},Y],am]]],V=[0,vi,0],U=function(m,i,u,c){var
  f=[aj,function(g){function
  f(v){var
  b=v[2],f=r[1];try{var
  n=cc(b,f)}catch(a){a=H(a);if(a===q){r[1]=[0,[0,b,bs(c)],f];return 0}throw a}if(c){var
  j=c[1];if(0!==j[0]&&!h(j[1],u6)){var
  l=j[4];if(l){var
  t=l[1];if(0!==t[0]&&!h(t[1],u7)&&!l[2]&&!c[2])return 0}}}function
  w(a){return a[1]}var
  x=ah(dd(f),w),g=function(a){return Q(b,a)}(x),y=function(a){return df(a,58)}(b),z=cT(function(a){return eg(a,1)}(y)),A=function(a){return df(a,58)}(b),k=function(a){return eg(a,0)}(A),B=function(a){return df(a,58)}(g),C=cT(function(a){return eg(a,1)}(B)),D=dd(function(a){return df(a,58)}(g)),o=function(a){return Q(k,a)}(D),p=z<C?1:0,E=e(g,b),F=E||p||h(o,k),s=F?a(d+(n+1|0)):a(fD),G=e(g,b),I=G||p||h(o,k),J=I?n+bs(c)|0:bs(c);r[1]=[0,[0,b,J],f];if(!e(m,u3)&&!e(s,u4))return[0,[1,m,[0,[0,u5,s],i],u,c]];return 0}return Q(0,ah(b(aD(u8),i),f))}];function
  g(a){return 0}return gM(f,ah(b(aD(u9),i),g))},W=dk(vx,[0,[0,function(a,g,f,d){var
  b=e(a,u_),c=b||e(a,u$);return c},U],an],V,aw),C=function(i,h){var
  a=i,c=h;for(;;){if(a){var
  b=a[1];if(0===b[0]){var
  j=a[2],a=j,c=hq(c,[0,b,0]);continue}var
  d=a[2],e=b[1],k=b[3],l=b[2],g=C(b[4],0);if(f(y[3],e,u2)&&0===g){var
  a=d;continue}var
  a=d,c=hq(c,[0,[1,e,l,k,hp(g)],0]);continue}return c}},az=dk(vz,[0,vw,0],0,dk(vy,0,[0,vt,0],C(W,0))),J=c?ga(wH,s,0):0,ax=c?eC(function(a){var
  b=a[2];return e(a[1][1],wZ)?[0,[0,w0,ch(b)]]:0},as):0,P=G?G[1]:1,w=0===J?0:[0,[1,tr,0,0,[0,[0,au(qH,at(qu,J))],0]],0],x=P?[0,tn,0]:0,A=0===x?1:0,R=A?0===w?1:0:A,S=R?0:[0,[1,tq,0,0,z(x,w)],0],B=[1,tp,0,0,z(S,[0,[1,to,ax,0,az],0])];if(I)b_(g(w3,ha(B)));return[0,B,0]}};mI(w5,[0,hA,[0]]);(function(a){throw a});var
  dm=w,eT=null,eU=undefined,dn=function(a){return a==eT?0:[0,a]},w6=dm.Array;gy(function(a){return a[1]===hA?[0,al(a[2].toString())]:0});gy(function(a){return a
  instanceof
  w6?0:[0,al(a.toString())]});var
  hB=dm.document;dm.HTMLElement===eU;var
  w7=x2(0),hC=function(a){var
  b=bG(a,eT)?eU:a;return b===eU?0:[0,b]},w8=function(a){return e(al(typeof
  a),w9)},w_=function(d){var
  a=d.src,b=a.length;if(0<b){var
  c=a.indexOf(fp),e=c<0?b:c,f=ia["length"];return(a.indexOf(ia)+f|0)===e?1:0}return 0},hD=function(a){var
  b=a.split(bm),c=[0,dm];return b.reduce(x4(function(a,b,d,c){return a?hC(a[1][b]):a}),c)},hE=function(a){if(a){var
  b=a[1],c=dn(b.getAttribute(iF));if(c){var
  d=c[1];b.removeAttribute(iF);return db(w8,hD(d))}return 0}return 0},w$=[aj,function(g){var
  d=hB.getElementsByTagName(ak),b=0,a=0,e=d.length;for(;;){if(a<e){var
  c=dn(d.item(a));if(c){var
  b=[0,c[1],b],a=a+1|0;continue}var
  a=a+1|0;continue}var
  f=D(b);return aG(function(a){var
  b=a.tagName.toLowerCase()===ak?a:eT;return hE(db(w_,dn(b)))},f)}}],xa=hE(hC(hB.currentScript)),hF=function(a){return da(w$,a)}(xa),eV=[0,0,0,0],xb=function(n,m){if(!eV[1]){if(0===dp)var
  a=gE([0]);else{var
  d=gE(gj(mK,dp)),g=dp.length-1-1|0,k=0;if(!(g<0)){var
  c=k;for(;;){var
  h=(c*2|0)+2|0;d[3]=aH(c_[4],dp[1+c],h,d[3]);d[4]=aH(c$[4],h,1,d[4]);var
  l=c+1|0;if(g!==c){var
  c=l;continue}break}}var
  a=d}var
  i=mQ(a,xc),e=mO(a,xd),j=function(c){var
  a=c[1+i];return b(a[2],a[1])};mM[1]++;if(f(c$[28],e,a[4])){ez(a,e+1|0);B(a[2],e)[1+e]=j}else
  a[6]=[0,[0,e,j],a[6]];var
  o=function(d){var
  b=jj(A,a[1]);b[1]=a[2];var
  c=yl(b);c[1+i]=d;return c};gF[1]=(gF[1]+a[1]|0)-1|0;a[8]=D(a[8]);ez(a,3+((B(a[2],1)[2]*16|0)/32|0)|0);eV[1]=o}return b(eV[1],[0,n,m])},xe=function(n,l,k,j){var
  e=dn(j);if(e){var
  d=gj(al,x3(e[1])),a=d.length-1-1|0,b=0;for(;;){if(0<=a){var
  h=[0,d[1+a],b],a=a-1|0,b=h;continue}var
  f=b;break}}else
  var
  f=0;var
  g=al(l),i=g_(0,w1(0,[0,k|0],[0,0],g,f)),c=go(m(g));pb(eA,1,function(a){return bM(c,a)},i);return fY(gp(c))},hG=function(a,b){return{"cleanDocument":x5(a)}}(xe,xb),xf=function(c,b){var
  a=hD("tinymce.Resource.add");return a?a[1](c,b):w7.error("Unable to find Word Import registration API")},xg=function(a){return a(hG)};if(hF)xg(hF[1]);else
  xf(xh,hG);ed(0);return}}(globalThis));
